{
  "translation": {
    "ADD_COMPANY.CODE.LABEL": "Codice Azienda",
    "ADD_COMPANY.COUNTRY.LABEL": "Paese",
    "ADD_COMPANY.COUNTRY.PLACEHOLDER": "Seleziona un paese",
    "ADD_COMPANY.CURRENCY.LABEL": "Valuta",
    "ADD_COMPANY.CURRENCY.PLACEHOLDER": "Seleziona una valuta",
    "ADD_COMPANY.LANGUAGE.LABEL": "Lingua",
    "ADD_COMPANY.LOGO.LABEL": "Seleziona Logo",
    "ADD_COMPANY.MEASUREMENT_TYPE.LABEL": "Tipo di Misurazione",
    "ADD_COMPANY.MEASUREMENT_TYPE.PLACEHOLDER": "Seleziona un tipo di misurazione",
    "ADD_COMPANY.NAME.LABEL": "Nome",
    "ADD_COMPANY.PARTNER.LABEL": "Partner",
    "ADD_COMPANY.PARTNER.PLACEHOLDER": "Scegli un partner",
    "ADD_COMPANY.RESPONSE.SUCCESS": "La società è stata creata con successo",
    "ADD_COMPANY.SUBMIT": "Aggiungi Nuova Azienda",
    "ADD_COMPANY.TITLE": "Aggiungi Nuova Azienda",
    "ADD_COMPANY.VALIDATION.CODE": "Il Codice Azienda è richiesto",
    "ADD_COMPANY.VALIDATION.COUNTRY": "È richiesto il Paese",
    "ADD_COMPANY.VALIDATION.CURRENCY": "È richiesta la valuta",
    "ADD_COMPANY.VALIDATION.IMAGE": "È richiesto il logo dell'azienda",
    "ADD_COMPANY.VALIDATION.LANGUAGE": "È richiesta la lingua",
    "ADD_COMPANY.VALIDATION.MEASUREMENT_TYPE": "È richiesto il tipo di misurazione",
    "ADD_COMPANY.VALIDATION.NAME": "Il nome è obbligatorio",
    "ADD_COMPANY.VALIDATION.PARTNER": "È richiesto un partner",
    "ADD_FLOW_DATA.BTN.FLOW_DATA": "Aggiungi Dati di Flusso",
    "ADD_FLOW_DATA.BTN.SUBMIT": "Invia",
    "ADD_FLOW_DATA.INPUT.DATE_TIME.LABEL": "Data e Ora dei Dati di Flusso",
    "ADD_FLOW_DATA.INPUT.DATE_TIME.PLACEHOLDER": "Fai clic qui per selezionare data e ora",
    "ADD_FLOW_DATA.INPUT.FLOW_DATA.LABEL": "Valore",
    "ADD_FLOW_DATA.INPUT.FLOW_DATA.PLACEHOLDER": "Valore dei Dati di Flusso",
    "ADD_FLOW_DATA.MODAL.ERROR.DESC": "Si prega di riprovare, i dati del flusso non sono stati aggiornati",
    "ADD_FLOW_DATA.MODAL.ERROR.TITLE": "Riprova!",
    "ADD_FLOW_DATA.MODAL.SUCCESS.DESC": "I dati di flusso sono stati aggiornati",
    "ADD_FLOW_DATA.MODAL.SUCCESS.TITLE": "Fantastico!",
    "ADD_PARTNER.ADDRESS.LABEL": "Indirizzo",
    "ADD_PARTNER.CODE.LABEL": "Codice",
    "ADD_PARTNER.COUNTRY.LABEL": "Paese",
    "ADD_PARTNER.COUNTRY.PLACEHOLDER": "Seleziona un Paese",
    "ADD_PARTNER.CURRENCY.LABEL": "Valuta",
    "ADD_PARTNER.CURRENCY.PLACEHOLDER": "Seleziona una Valuta",
    "ADD_PARTNER.LOGO.LABEL": "Seleziona Logo",
    "ADD_PARTNER.NAME.LABEL": "Nome",
    "ADD_PARTNER.RESPONSE.SUCCESS": "Il Partner è stato creato con successo",
    "ADD_PARTNER.SUBMIT": "Aggiungi Nuovo Partner",
    "ADD_PARTNER.TITLE": "Aggiungi Nuovo Partner",
    "ADD_PARTNER.VALIDATION.ADDRESS": "Indirizzo è richiesto",
    "ADD_PARTNER.VALIDATION.CODE": "Il codice è richiesto",
    "ADD_PARTNER.VALIDATION.COUNTRY": "È richiesto il Paese",
    "ADD_PARTNER.VALIDATION.CURRENCY": "È richiesta la valuta",
    "ADD_PARTNER.VALIDATION.IMAGE": "È richiesta l'immagine del partner",
    "ADD_PARTNER.VALIDATION.NAME": "Il nome è obbligatorio",
    "ADD_PROJECT.COMPANY.LABEL": "Azienda",
    "ADD_PROJECT.COMPANY.PLACEHOLDER": "Seleziona un'azienda",
    "ADD_PROJECT.COST_PER_KM.LABEL": "Costo per KM($)",
    "ADD_PROJECT.CURRENCY.LABEL": "Valuta",
    "ADD_PROJECT.CURRENCY.PLACEHOLDER": "Seleziona una valuta",
    "ADD_PROJECT.DMAS.LABEL": "DMAs",
    "ADD_PROJECT.DMAS.NO_MATCHING": "Nessun DMA corrispondente",
    "ADD_PROJECT.DMAS.PLACEHOLDER": "Seleziona DMAs",
    "ADD_PROJECT.END_DATE.LABEL": "Data di Fine",
    "ADD_PROJECT.MEASUREMENT_TYPE.LABEL": "Tipo di Misurazione",
    "ADD_PROJECT.MEASUREMENT_TYPE.PLACEHOLDER": "Seleziona un tipo di misurazione",
    "ADD_PROJECT.NAME.LABEL": "Aggiungi Nuovo Progetto",
    "ADD_PROJECT.RESPONSE.SUCCESS": "Il Progetto è stato creato con successo",
    "ADD_PROJECT.START_DATE.LABEL": "Data di inizio",
    "ADD_PROJECT.SUBMIT": "Crea Nuovo Progetto",
    "ADD_PROJECT.TITLE": "Aggiungi Nuovo Progetto",
    "ADD_PROJECT.VALIDATION.COMPANY": "È richiesta l'azienda",
    "ADD_PROJECT.VALIDATION.COST_PER_KM": "È richiesto il costo per KM",
    "ADD_PROJECT.VALIDATION.CURRENCY": "È richiesta la valuta",
    "ADD_PROJECT.VALIDATION.END_DATE": "La data di fine è obbligatoria",
    "ADD_PROJECT.VALIDATION.MEASUREMENT_TYPE": "È richiesto il tipo di misurazione",
    "ADD_PROJECT.VALIDATION.NAME": "Il nome è obbligatorio",
    "ADD_PROJECT.VALIDATION.START_DATE": "La data di inizio è obbligatoria",
    "ADD_USER.MODAL.BTN.CLOSE": "Chiudi Modale",
    "ADD_USER.RESPONSE.SUCCESS": "L'utente è stato creato con successo",
    "ADD_USER.SUBMIT": "Aggiungi Nuovo Utente",
    "ADD_USER.TITLE": "Aggiungi Nuovo Utente",
    "ASSET_TOOLTIP.DESC_TITLE.ASSET_ID": "ID dell'asset",
    "ASSET_TOOLTIP.DESC_TITLE.ASSET_TYPE": "Tipo di Asset Standardizzato",
    "ASSET_TOOLTIP.ERROR": "Impossibile recuperare le informazioni sull'asset",
    "ASSET_TOOLTIP.NO_DATA": "Nessuna informazione sulla sessione disponibile",
    "ASSET_TOOLTIP.TABLE.HEADER.1": "ID sessione",
    "ASSET_TOOLTIP.TABLE.HEADER.2": "ID del bug",
    "ASSET_TOOLTIP.TABLE.HEADER.3": "Timestamp",
    "ASSET_TOOLTIP.TABLE.HEADER.4": "Risultato",
    "ASSET_TOOLTIP.TITLE.ASSET": "Informazioni sull'asset",
    "ASSET_TOOLTIP.TITLE.SESSION": "Informazioni sulla sessione",
    "BREADCRUMB.FILTERS.COMPANY": "Azienda",
    "BREADCRUMB.FILTERS.DATE_FROM": "Data da",
    "BREADCRUMB.FILTERS.DATE_TO": "Data a",
    "BREADCRUMB.FILTERS.DATEFROM": "Data da",
    "BREADCRUMB.FILTERS.DATETO": "Data a",
    "BREADCRUMB.FILTERS.DAY": "Giorno",
    "BREADCRUMB.FILTERS.ENGINEER": "Ingegnere",
    "BREADCRUMB.FILTERS.PARTNER": "Partner",
    "BREADCRUMB.FILTERS.PROJECT": "Progetto",
    "BROWSE_HOME_PAGE.TITLE": "Seleziona un tipo di dati per iniziare la navigazione.",
    "BROWSE_VIEW.BACK_TO_LIST": "Torna all'elenco",
    "BROWSE_VIEW.MEDIA_SECTION.EMPTY_MSG": "Nessun supporto per questo waypoint",
    "BROWSE_VIEW.MEDIA_SECTION.LABEL": "Media",
    "BROWSE_VIEW.RELAY.ADDRESS": "Indirizzo",
    "BROWSE_VIEW.RELAY.DEPLOYED_BY": "Distribuito da",
    "BROWSE_VIEW.RELAY.LAST_CONTACT": "Ultimo contatto",
    "BROWSE_VIEW.RELAY.LAST_UPLOADED": "Ultimo caricamento",
    "BROWSE_VIEW.RELAY.NO_NAME_PLACEHOLDER": "Staffetta",
    "BROWSE_VIEW.RELAY.SESSION": "Sessione",
    "BROWSE_VIEW.RELAY.UPDATED": "Aggiornato",
    "BROWSE_VIEW.RELAY.W3W": "Quali 3 parole",
    "BROWSE_VIEW.SENSOR.BATTERY_VOLTAGE": "Tensione della batteria",
    "BROWSE_VIEW.SENSOR.COLLECTED_BY": "Raccolti da",
    "BROWSE_VIEW.SENSOR.DEPLOYED_BY": "Distribuito da",
    "BROWSE_VIEW.SENSOR.END_TIME": "Ora di fine",
    "BROWSE_VIEW.SENSOR.FIRMWARE_VERSION": "Versione",
    "BROWSE_VIEW.SENSOR.LAST_UPLOADED": "Ultimo caricamento",
    "BROWSE_VIEW.SENSOR.LATEST_SESSION": "Ultima sessione",
    "BROWSE_VIEW.SENSOR.SESSION": "Sessione",
    "BROWSE_VIEW.SENSOR.SESSION_TYPE": "Tipo di sessione",
    "BROWSE_VIEW.SENSOR.START_TIME": "Ora di inizio",
    "BROWSE_VIEW.SESSION.LAST_UPLOADED": "Ultimo caricamento",
    "BROWSE_VIEW.WAYPOINT.ADD_JOB": "Aggiungi lavoro",
    "BROWSE_VIEW.WAYPOINT.ADDRESS": "Indirizzo",
    "BROWSE_VIEW.WAYPOINT.CREATED": "Creato",
    "BROWSE_VIEW.WAYPOINT.DIAMETER": "Diametro",
    "BROWSE_VIEW.WAYPOINT.ENG_NOTES": "Note di ingegneria",
    "BROWSE_VIEW.WAYPOINT.ENGINEER": "Ingegnere assegnato",
    "BROWSE_VIEW.WAYPOINT.ENV_NOTES": "Note ambientali",
    "BROWSE_VIEW.WAYPOINT.MATERIAL": "Materiale del tubo",
    "BROWSE_VIEW.WAYPOINT.MERGE_WP": "Unisci waypoint",
    "BROWSE_VIEW.WAYPOINT.NO_NAME_PLACEHOLDER": "Waypoint senza nome",
    "BROWSE_VIEW.WAYPOINT.SECTION.ACTIVITIES": "Attività",
    "BROWSE_VIEW.WAYPOINT.SECTION.CONSUMPTION_PROFILES": "Profili di consumo",
    "BROWSE_VIEW.WAYPOINT.SECTION.CONSUMPTION_PROFILES_EMTPY": "Nessun profilo di consumo per questo waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.CORRELATIONS": "Correlazioni",
    "BROWSE_VIEW.WAYPOINT.SECTION.CORRELATIONS_EMPTY": "Nessuna correlazione per questo waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.HISTORY": "Storia",
    "BROWSE_VIEW.WAYPOINT.SECTION.HISTORY_EMPTY": "Nessuna cronologia per questo waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.JOBS": "Lavori",
    "BROWSE_VIEW.WAYPOINT.SECTION.JOBS_EMPTY": "Nessun lavoro per questo waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.NOTES": "Note",
    "BROWSE_VIEW.WAYPOINT.SECTION.NOTES_EMPTY": "Nessuna nota per questo waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.SESSIONS": "Sessioni",
    "BROWSE_VIEW.WAYPOINT.SECTION.SESSIONS_EMPTY": "Nessuna sessione per questo waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.SOUNDINGS": "Sondaggi",
    "BROWSE_VIEW.WAYPOINT.SECTION.SOUNDINGS_EMPTY": "Nessun sondaggio per questo waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.TOP_SOUNDINGS": "Top Soundings",
    "BROWSE_VIEW.WAYPOINT.SECTION.TOP_SOUNDINGS_EMPTY": "Nessun sondaggio per questo waypoint",
    "BROWSE_VIEW.WAYPOINT.UPDATED": "Aggiornato",
    "BROWSE_VIEW.WAYPOINT.W3W": "Quali 3 parole",
    "BROWSE.FILTERS.COLLECTED_BY": "Raccolti da",
    "BROWSE.FILTERS.COLLECTED_BY_PLACEHOLDER": "Seleziona raccolto dall'utente",
    "BROWSE.FILTERS.COMPANY": "Azienda",
    "BROWSE.FILTERS.COMPANY_NAME": "Nome dell'azienda",
    "BROWSE.FILTERS.COMPANY_PLACEHOLDER": "Seleziona le aziende",
    "BROWSE.FILTERS.DEPLOYED_BY": "Distribuito da",
    "BROWSE.FILTERS.DEPLOYED_BY_PLACEHOLDER": "Seleziona distribuito dall'utente",
    "BROWSE.FILTERS.DMA": "DMA",
    "BROWSE.FILTERS.DMA_KEY": "Chiave DMA",
    "BROWSE.FILTERS.DMA_PLACEHOLDER": "Seleziona DMA",
    "BROWSE.FILTERS.FILTER": "Filtro",
    "BROWSE.FILTERS.FROM": "Da",
    "BROWSE.FILTERS.ID": "ID",
    "BROWSE.FILTERS.JOB_TYPE": "Tipo di lavoro",
    "BROWSE.FILTERS.JOB_TYPE_PLACEHOLDER": "Seleziona i codici del tipo di lavoro",
    "BROWSE.FILTERS.LAST_SCHEDULED_ENGINEER": "Ultimo ingegnere programmato",
    "BROWSE.FILTERS.LAST_SCHEDULED_ENGINEER_PLACEHOLDER": "Seleziona gli ultimi ingegneri programmati",
    "BROWSE.FILTERS.LEAK_RESULTS": "Risultati delle perdite",
    "BROWSE.FILTERS.LEAK_RESULTS_PLACEHOLDER": "Seleziona i risultati delle perdite",
    "BROWSE.FILTERS.MOST_RECENT_AUTHOR_OF_MODIFICATION": "Autore più recente della modifica",
    "BROWSE.FILTERS.MOST_RECENT_AUTHOR_OF_MODIFICATION_PLACEHOLDER": "Seleziona gli ultimi utenti che hanno effettuato l'azione",
    "BROWSE.FILTERS.NAME": "Nome",
    "BROWSE.FILTERS.OTHERS": "Altri",
    "BROWSE.FILTERS.PARTNER": "Partner",
    "BROWSE.FILTERS.PARTNER_NAME": "Nome del partner",
    "BROWSE.FILTERS.PARTNER_PLACEHOLDER": "Seleziona i partner",
    "BROWSE.FILTERS.PREDICTED_LEAK_TYPE": "Tipo di perdita previsto",
    "BROWSE.FILTERS.PREDICTED_LEAK_TYPE_PLACEHOLDER": "Seleziona i tipi di perdite previsti",
    "BROWSE.FILTERS.PREDICTED_SIZE": "Dimensione prevista",
    "BROWSE.FILTERS.PREDICTED_SIZE_PLACEHOLDER": "Seleziona le dimensioni previste",
    "BROWSE.FILTERS.PREDICTED_SIZE.CORRELATION": "Correlazione",
    "BROWSE.FILTERS.PREDICTED_SIZE.ERROR": "Errore",
    "BROWSE.FILTERS.PREDICTED_SIZE.LARGE": "Grande",
    "BROWSE.FILTERS.PREDICTED_SIZE.MEDIUM": "Medio",
    "BROWSE.FILTERS.PREDICTED_SIZE.NA": "N / A",
    "BROWSE.FILTERS.PREDICTED_SIZE.NOT_ENOUGH_FILES": "File insufficienti",
    "BROWSE.FILTERS.PREDICTED_SIZE.SMALL": "Piccolo",
    "BROWSE.FILTERS.PROJECT": "Progetto",
    "BROWSE.FILTERS.PROJECT_PLACEHOLDER": "Seleziona progetti",
    "BROWSE.FILTERS.RELAY_CONNECTED": "Relè connesso",
    "BROWSE.FILTERS.RELAYS": "Relè",
    "BROWSE.FILTERS.SELECT_FIELD": "Seleziona campo",
    "BROWSE.FILTERS.SENSORS": "Sensori",
    "BROWSE.FILTERS.SESSION_STATUS.AWAITING_UPLOAD": "In attesa di caricamento",
    "BROWSE.FILTERS.SESSION_STATUS.COMPLETED": "Completato",
    "BROWSE.FILTERS.SESSION_STATUS.DELETED": "Eliminato",
    "BROWSE.FILTERS.SESSION_STATUS.IN_PROGRESS": "In corso",
    "BROWSE.FILTERS.SESSION_TYPE.CONTINUOUS": "Continuo",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION": "Correlazione",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_1_MIN_DELAY": "Correlazione: 1 minuto di ritardo",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_12_MIN_DELAY": "Correlazione: ritardo di 12 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_15_MIN_DELAY": "Correlazione: ritardo di 15 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_5_MIN_DELAY": "Correlazione: ritardo di 5 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_8_MIN_DELAY": "Correlazione: ritardo di 8 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_CHILD": "Correlazione Bambino",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_PARENT": "Correlazione Genitore",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_3_MIN_DAY": "FCC: giornata da 3 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_3_MIN_NIGHT": "FCC: notte di 3 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_5_MIN_DAY": "FCC: giornata da 5 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_5_MIN_NIGHT": "FCC: notte da 5 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_8_MIN_DAY": "FCC: giornata da 8 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_8_MIN_NIGHT": "FCC: notte da 8 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.FIVE_MINUTES": "5 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.ONE_HOUR": "1 ora",
    "BROWSE.FILTERS.SESSION_TYPE.OVERNIGHT": "Durante la notte",
    "BROWSE.FILTERS.SESSION_TYPE.RELAY": "Staffetta",
    "BROWSE.FILTERS.SESSION_TYPE.SYSTEM_MODE": "Modalità di sistema",
    "BROWSE.FILTERS.SESSION_TYPE.TEST": "Test",
    "BROWSE.FILTERS.SESSION_TYPE.THIRTY_MINUTES": "30 minuti",
    "BROWSE.FILTERS.SESSION_TYPE.TWENTY_FOUR_HOURS": "24 ore",
    "BROWSE.FILTERS.SESSION_TYPE.TYPE": "Tipo",
    "BROWSE.FILTERS.SESSION_TYPES": "Tipi di sessione",
    "BROWSE.FILTERS.SESSION_TYPES_PLACEHOLDER": "Seleziona i tipi di sessione",
    "BROWSE.FILTERS.SESSIONS": "Sessioni",
    "BROWSE.FILTERS.SORTING": "Ordinamento",
    "BROWSE.FILTERS.STATUS": "Stato",
    "BROWSE.FILTERS.STATUS_PLACEHOLDER": "Seleziona gli stati",
    "BROWSE.FILTERS.STATUS.MAINTENANCE_ALERT": "Avviso di manutenzione",
    "BROWSE.FILTERS.STATUS.OFFLINE": "Fuori linea",
    "BROWSE.FILTERS.STATUS.OK": "OK",
    "BROWSE.FILTERS.STATUS.ONLINE": "In linea",
    "BROWSE.FILTERS.STATUS.WARNING": "Avvertimento",
    "BROWSE.FILTERS.TO": "A",
    "BROWSE.FILTERS.TYPES": "Tipi",
    "BROWSE.FILTERS.TYPES_PLACEHOLDER": "Seleziona i tipi di sessione",
    "BROWSE.FILTERS.WAYPOINTS": "Punti di passaggio",
    "BROWSE.LABELS.TYPE": "Tipo",
    "BROWSE.LAYOUT.LOADING_MAP": "Caricamento mappa",
    "BROWSE.LAYOUT.LOADING_MAP_DESCRIPTION": "Attendi mentre inizializziamo la mappa interattiva...",
    "BROWSE.LAYOUT.LOADING_PREVIEW": "Caricamento anteprima",
    "BROWSE.LAYOUT.LOADING_PREVIEW_DESCRIPTION": "Attendi mentre carichiamo l'anteprima condivisa...",
    "BROWSE.LIST.BACK_TO_LIST": "Torna all'elenco",
    "BROWSE.LIST.JOBS_VIEW_ACTIVE": "Visualizza lavori attivi",
    "BROWSE.LIST.JOBS_VIEW_DESCRIPTION": "I dati del lavoro vengono visualizzati sulla mappa",
    "BROWSE.PANEL.COLLAPSE": "Comprimi pannello",
    "BROWSE.PANEL.EXPAND": "Espandi pannello",
    "BROWSE.PREDEFINED_VIEWS.LEAKS_FOUND_LAST_7_DAYS": "Perdite trovate negli ultimi 7 giorni",
    "BROWSE.PREDEFINED_VIEWS.LEAKS_MARKED_UP_LAST_7_DAYS": "Perdite evidenziate negli ultimi 7 giorni",
    "BROWSE.PREDEFINED_VIEWS.RELAY_NEEDS_MAINTENANCE": "Relè che necessita di manutenzione",
    "BROWSE.PREDEFINED_VIEWS.RELAY_WARNINGS_LAST_7_DAYS": "Avvisi di inoltro negli ultimi 7 giorni",
    "BROWSE.PREVIEW.CHANGE_WAYPOINT": "cambia waypoint",
    "BROWSE.SHARE.ADD_EMAIL": "Aggiungi email",
    "BROWSE.SHARE.ADD_MESSAGE": "Aggiungi un messaggio",
    "BROWSE.SHARE.COPY_LINK": "Copia collegamento",
    "BROWSE.SHARE.ERROR.COPY_CLIPBOARD_FAILED": "Impossibile copiare il collegamento negli appunti",
    "BROWSE.SHARE.ERROR.GENERATE_LINK_FAILED": "Impossibile generare il collegamento di condivisione",
    "BROWSE.SHARE.REMOVE_EMAIL": "Rimuovere %1$s",
    "BROWSE.SHARE.SEND": "Inviare",
    "BROWSE.SHARE.SUCCESS.EMAIL_SENT_AND_LINK_COPIED": "Email inviata e link copiato negli appunti!",
    "BROWSE.SHARE.SUCCESS.LINK_COPIED": "Link copiato negli appunti!",
    "BROWSE.TABLE.COLUMNS.ADDRESS": "Indirizzo",
    "BROWSE.TABLE.COLUMNS.ASSET": "Risorsa",
    "BROWSE.TABLE.COLUMNS.BATTERY_VOLTAGE": "Tensione della batteria",
    "BROWSE.TABLE.COLUMNS.COLLECTED_BY": "Raccolti da",
    "BROWSE.TABLE.COLUMNS.COMMENT": "Commento",
    "BROWSE.TABLE.COLUMNS.COMPANY": "Azienda",
    "BROWSE.TABLE.COLUMNS.COMPANY_NAME": "Nome dell'azienda",
    "BROWSE.TABLE.COLUMNS.CREATED_AT": "Creato a",
    "BROWSE.TABLE.COLUMNS.CREATED_DATE": "Data di creazione",
    "BROWSE.TABLE.COLUMNS.DEPLOYED_BY": "Distribuito da",
    "BROWSE.TABLE.COLUMNS.DMA": "DMA",
    "BROWSE.TABLE.COLUMNS.END_DATE": "Data di fine",
    "BROWSE.TABLE.COLUMNS.END_TIME": "Ora di fine",
    "BROWSE.TABLE.COLUMNS.ENVIRONMENTAL_NOTES": "Note ambientali",
    "BROWSE.TABLE.COLUMNS.EST_SIZE_ENG": "Dimensioni stimate (Eng)",
    "BROWSE.TABLE.COLUMNS.EXPECTED_FINISH": "Fine prevista",
    "BROWSE.TABLE.COLUMNS.FIRMWARE": "Firmware",
    "BROWSE.TABLE.COLUMNS.FLOW_REDUCTION": "Riduzione del flusso",
    "BROWSE.TABLE.COLUMNS.ID": "ID",
    "BROWSE.TABLE.COLUMNS.JOB_COUNT": "Conteggio dei lavori",
    "BROWSE.TABLE.COLUMNS.JOB_TYPE_CODE": "Codice tipo di lavoro",
    "BROWSE.TABLE.COLUMNS.JOBS": "Lavori",
    "BROWSE.TABLE.COLUMNS.LAST_ACTION_BY": "Ultima azione di",
    "BROWSE.TABLE.COLUMNS.LAST_CONTACT": "Ultimo contatto",
    "BROWSE.TABLE.COLUMNS.LAST_SCHEDULED_ENGINEER": "Ultimo ingegnere programmato",
    "BROWSE.TABLE.COLUMNS.LAST_UPDATE": "Ultimo aggiornamento",
    "BROWSE.TABLE.COLUMNS.LAST_UPDATED": "Ultimo aggiornamento",
    "BROWSE.TABLE.COLUMNS.LATITUDE": "Latitudine",
    "BROWSE.TABLE.COLUMNS.LEAK_RESULT": "Risultato della perdita",
    "BROWSE.TABLE.COLUMNS.LEAK_SIZE": "Dimensione della perdita",
    "BROWSE.TABLE.COLUMNS.LONGITUDE": "Longitudine",
    "BROWSE.TABLE.COLUMNS.MAC_ADDRESS": "Indirizzo MAC",
    "BROWSE.TABLE.COLUMNS.NAME": "Nome",
    "BROWSE.TABLE.COLUMNS.PARTNER": "Partner",
    "BROWSE.TABLE.COLUMNS.PARTNER_NAME": "Nome del partner",
    "BROWSE.TABLE.COLUMNS.PIPE_DIAMETER": "Diametro del tubo",
    "BROWSE.TABLE.COLUMNS.PIPE_DIAMETER_UNITS": "Unità di diametro del tubo",
    "BROWSE.TABLE.COLUMNS.PIPE_MATERIAL": "Materiale del tubo",
    "BROWSE.TABLE.COLUMNS.PREDICTED_LEAK_TYPE": "Tipo di perdita previsto",
    "BROWSE.TABLE.COLUMNS.PREDICTED_SIZE": "Dimensione prevista",
    "BROWSE.TABLE.COLUMNS.PROJECT": "Progetto",
    "BROWSE.TABLE.COLUMNS.RELAY_CONNECTED": "Relè connesso",
    "BROWSE.TABLE.COLUMNS.RELAY_ID": "ID relè",
    "BROWSE.TABLE.COLUMNS.RELAY_NAME": "Nome del relè",
    "BROWSE.TABLE.COLUMNS.SENSOR_ID": "ID sensore",
    "BROWSE.TABLE.COLUMNS.SENSOR_MAC": "Sensore MAC",
    "BROWSE.TABLE.COLUMNS.SENSOR_NAME": "Nome del sensore",
    "BROWSE.TABLE.COLUMNS.SESSION": "Sessione",
    "BROWSE.TABLE.COLUMNS.SESSION_COUNT": "Conteggio delle sessioni",
    "BROWSE.TABLE.COLUMNS.SESSION_ID": "ID sessione",
    "BROWSE.TABLE.COLUMNS.SESSION_TYPE": "Tipo di sessione",
    "BROWSE.TABLE.COLUMNS.SESSIONS": "Sessioni",
    "BROWSE.TABLE.COLUMNS.SIZE": "Misurare",
    "BROWSE.TABLE.COLUMNS.START_DATE": "Data di inizio",
    "BROWSE.TABLE.COLUMNS.START_TIME": "Ora di inizio",
    "BROWSE.TABLE.COLUMNS.STATUS": "Stato",
    "BROWSE.TABLE.COLUMNS.SURFACE_TYPE": "Tipo di superficie",
    "BROWSE.TABLE.COLUMNS.UPDATE_DATE": "Data di aggiornamento",
    "BROWSE.TABLE.COLUMNS.WAYPOINT_NAME": "Nome del waypoint",
    "BROWSE.TABLE.COLUMNS.WHAT3WORDS": "What3Words",
    "BROWSE.TABLE.ID_PREFIX": "ID:",
    "BROWSE.TABLE.SORT_BY": "Ordina per %1$s",
    "BROWSE.TABS.RELAYS": "Relè",
    "BROWSE.TABS.SENSORS": "Sensori",
    "BROWSE.TABS.SESSIONS": "Sessioni",
    "BROWSE.TABS.WAYPOINTS": "Punti di passaggio",
    "BROWSE.VIEWS.CREATED_SUCCESS": "Visualizzazione personalizzata creata correttamente",
    "BROWSE.VIEWS.DELETE_CONFIRM": "Eliminare la vista salvata?",
    "BROWSE.VIEWS.DELETE_DESCRIPTION": "Questo eliminerà definitivamente \"%1$s\".",
    "BROWSE.VIEWS.EMPTY": "Nessuna visualizzazione salvata ancora",
    "BROWSE.VIEWS.LOAD_ERROR": "Impossibile caricare le visualizzazioni",
    "BROWSE.VIEWS.LOADING": "Caricamento visualizzazioni...",
    "BROWSE.VIEWS.POPOVER_DESCRIPTION": "Puoi salvare i tuoi filtri preferiti e accedervi con un clic da qui",
    "BROWSE.VIEWS.SAVE_BUTTON": "Salva vista",
    "BROWSE.VIEWS.SAVE_DESCRIPTION": "Assegna un nome alla tua vista personalizzata per salvare i filtri correnti.",
    "BROWSE.VIEWS.SAVE_TITLE": "Salva vista personalizzata",
    "BROWSE.VIEWS.VIEW_NAME_LABEL": "Visualizza nome",
    "BROWSE.VIEWS.VIEW_NAME_PLACEHOLDER": "Inserisci il nome della vista",
    "BROWSE.VIEWS.YOUR_SAVED_VIEWS": "Le tue visualizzazioni salvate",
    "BROWSE.VIEWS.YOUR_VIEWS_SHORT": "Le tue opinioni",
    "CHANGE_LOG.ACTIONS.CREATE_BRANCH": "Crea Progetto",
    "CHANGE_LOG.ACTIONS.CREATE_COMPANY": "Crea compagnia",
    "CHANGE_LOG.ACTIONS.CREATE_USER": "Crea invito utente",
    "CHANGE_LOG.ACTIONS.DELETE_BRANCH": "Elimina Progetto",
    "CHANGE_LOG.ACTIONS.DELETE_COMPANY": "Elimina azienda",
    "CHANGE_LOG.ACTIONS.DELETE_USER": "Elimina utente",
    "CHANGE_LOG.ACTIONS.EDIT_COMPANY": "Modifica azienda",
    "CHANGE_LOG.ACTIONS.FORGOT_PASSWORD": "Invia email con link di recupero",
    "CHANGE_LOG.ACTIONS.GET_COMPANY": "Fatti compagnia",
    "CHANGE_LOG.ACTIONS.LOGIN": "Login",
    "CHANGE_LOG.ACTIONS.SET_PASSWORD": "Imposta la password del profilo",
    "CHANGE_LOG.ACTIONS.TOKEN_DECODE": "Decodifica token e-mail",
    "CHANGE_LOG.ACTIONS.UPDATE_BRANCH": "Il progetto è stato aggiornato",
    "CHANGE_LOG.ACTIONS.UPDATE_USER": "Il profilo utente è stato aggiornato",
    "CHANGE_LOG.FILTERS.ACTION.LABEL": "Azione",
    "CHANGE_LOG.FILTERS.ACTION.PLACEHOLDER": "Seleziona un'azione",
    "CHANGE_LOG.FILTERS.BRANCH.LABEL": "Progetto",
    "CHANGE_LOG.FILTERS.BRANCH.PLACEHOLDER": "Seleziona un Progetto",
    "CHANGE_LOG.FILTERS.CLEAR": "Scartare",
    "CHANGE_LOG.FILTERS.COMPANY.LABEL": "Azienda",
    "CHANGE_LOG.FILTERS.COMPANY.PLACEHOLDER": "Seleziona un'azienda",
    "CHANGE_LOG.FILTERS.DATE.LABEL": "Data",
    "CHANGE_LOG.FILTERS.DATE.PLACEHOLDER": "Seleziona una data",
    "CHANGE_LOG.FILTERS.EMAIL.LABEL": "E-mail",
    "CHANGE_LOG.FILTERS.EMAIL.PLACEHOLDER": "Inserisci un'e-mail",
    "CHANGE_LOG.FILTERS.ERASE": "Chiaro",
    "CHANGE_LOG.FILTERS.STATUS.LABEL": "Stato",
    "CHANGE_LOG.FILTERS.STATUS.PLACEHOLDER": "Seleziona uno stato",
    "CHANGE_LOG.FILTERS.SUBMIT": "Filtro",
    "CHANGE_LOG.FILTERS.TITLE": "Filtri",
    "CHANGE_LOG.STATUSES.FAILURE": "Fallimento",
    "CHANGE_LOG.STATUSES.SUCCESS": "Successo",
    "CHANGE_LOG.TABLE.ACTION": "Azione",
    "CHANGE_LOG.TABLE.BRANCH": "Progetto",
    "CHANGE_LOG.TABLE.COMPANY": "Azienda",
    "CHANGE_LOG.TABLE.DATE": "Data",
    "CHANGE_LOG.TABLE.EMAIL": "E-mail",
    "CHANGE_LOG.TABLE.NAME": "Nome",
    "CHANGE_LOG.TABLE.NUMBER": "№",
    "CHANGE_LOG.TABLE.ROLE": "Ruolo",
    "CHANGE_LOG.TABLE.STATUS": "Stato",
    "CHANGE_LOG.TABLE.TIME": "Tempo",
    "CHANGE_LOG.TITLE.NO_LOGS": "Non ci sono registri",
    "CHANGE_LOG.TITLE.TOTAL_COUNT": "Log totali:",
    "CHATBOT.DEFAULT_ASSISTANT_MSG": "Come posso aiutarti?",
    "CHATBOT.INPUT.PLACEHOLDER": "Scrivi un messaggio",
    "CHATBOT.OFFLINE_MSG": "askFIDO non è attualmente disponibile. Si prega di riprovare più tardi.",
    "CHATBOT.RATING.RESPONSE": "Grazie per il feedback",
    "CHATBOT.SUBHEADING": "Online",
    "CHATBOT.SUBHEADING_ERROR": "Offline",
    "CHATBOT.YOU": "Tu",
    "COMMON.ACTION.CANCEL": "Cancellare",
    "COMMON.ACTION.CLEAR": "Chiaro",
    "COMMON.ACTION.CLEAR_SEARCH": "Cancella ricerca",
    "COMMON.ACTION.CLOSE": "Vicino",
    "COMMON.ACTION.COPY_COORDINATES": "Copia le coordinate",
    "COMMON.ACTION.COPY_COORDINATES_TO_CLIPBOARD": "Copia le coordinate negli appunti",
    "COMMON.ACTION.DELETE": "Eliminare",
    "COMMON.ACTION.LOAD_MORE": "Carica altro",
    "COMMON.ACTION.RESET": "Reset",
    "COMMON.ACTION.SAVING": "Risparmio...",
    "COMMON.ACTION.SEARCH": "Ricerca",
    "COMMON.ACTION.SHARE": "Condividere",
    "COMMON.BOOLEAN.NO": "NO",
    "COMMON.BOOLEAN.YES": "SÌ",
    "COMMON.BUTTON.EDIT": "modificare",
    "COMMON.BUTTON.OPEN": "aprire",
    "COMMON.BUTTON.SHARE": "condividere",
    "COMMON.DATE.PLACEHOLDER.DDMMYYYY": "gg/mm/aaaa",
    "COMMON.EMPTY.ADJUST_FILTERS_OR_SEARCH": "Prova a modificare i filtri o i criteri di ricerca",
    "COMMON.EMPTY.ADJUST_SEARCH_TERMS": "Prova a modificare i termini di ricerca o controlla gli errori di battitura",
    "COMMON.EMPTY.NO_DATA": "Nessun dato.",
    "COMMON.EMPTY.NO_RESULTS_FOUND": "Nessun risultato trovato",
    "COMMON.ERROR.FAILED_TO_LOAD_DATA": "Impossibile caricare i dati",
    "COMMON.ERROR.GENERIC_TRY_AGAIN_LATER": "Si è verificato un errore durante il recupero dei dati. Riprova più tardi.",
    "COMMON.ERROR.SUGGESTIONS_FETCH": "Si è verificato un errore durante il recupero dei suggerimenti. Riprova più tardi.",
    "COMMON.FILTERS.APPLY_FILTERS": "Applica filtri",
    "COMMON.FILTERS.EMAILS_PLACEHOLDER": "Filtra le email...",
    "COMMON.FILTERS.SAVE_FILTERS": "Salva filtri",
    "COMMON.FILTERS.TOGGLE_FILTERS": "attiva/disattiva i filtri",
    "COMMON.FORM.PLACEHOLDER.ZERO": "0",
    "COMMON.LOADING.GENERIC": "Caricamento...",
    "COMMON.LOADING.SUGGESTIONS": "Caricamento suggerimenti in corso...",
    "COMMON.MEDIA.PAUSE_VIDEO": "Metti in pausa il video",
    "COMMON.MEDIA.PLAY_AUDIO": "Riproduci audio",
    "COMMON.MEDIA.PLAY_VIDEO": "Guarda il video",
    "COMMON.MEDIA.UPLOAD_ALT": "Media caricati",
    "COMMON.MEDIA.VIDEO_LOAD_ERROR": "Si è verificato un errore durante il caricamento del video. Riprova più tardi.",
    "COMMON.PAGINATION.NEXT_PAGE": "Vai alla pagina successiva",
    "COMMON.PAGINATION.OF": "Di",
    "COMMON.PAGINATION.PAGE_TITLE": "Pagina %1$s",
    "COMMON.PAGINATION.PREVIOUS_PAGE": "Vai alla pagina precedente",
    "COMMON.PAGINATION.ROWS_PER_PAGE": "Righe per pagina",
    "COMMON.SEARCH.RESULTS": "Risultati",
    "COMMON.SEARCH.SUGGESTIONS": "Suggerimenti",
    "COMMON.SEARCH.WAITING_FOR_TYPING": "Aspetto che tu finisca di scrivere...",
    "COMMON.SORT.ASC": "Ascendente",
    "COMMON.SORT.DESC": "Discendente",
    "COMMON.TABLE.COLUMNS_SETTINGS": "Impostazioni colonne",
    "COMMON.TABLE.CUSTOMIZE_TABLE": "Personalizza tabella",
    "COMMON.TABLE.CUSTOMIZE_TABLE_DESCRIPTION": "Riordina, blocca e attiva/disattiva la visibilità delle colonne",
    "COMMON.TABLE.DRAG_TO_PIN": "Trascina qui le colonne per bloccarle",
    "COMMON.TABLE.DRAG_TO_REORDER": "Trascina per riordinare",
    "COMMON.TABLE.DRAG_TO_UNPIN": "Trascina le colonne qui per sbloccarle",
    "COMMON.TABLE.MANAGE_COLUMNS": "Gestisci colonne",
    "COMMON.TABLE.MAX_PINNED_COLUMNS_REACHED": "Numero massimo di colonne bloccate raggiunto",
    "COMMON.TABLE.OTHER_COLUMNS": "Altre colonne",
    "COMMON.TABLE.PIN_COLUMN": "Colonna di spilli",
    "COMMON.TABLE.PINNED_COLUMNS": "Colonne bloccate",
    "COMMON.TABLE.PINNED_COLUMNS_COUNT": "Colonne bloccate (%1$s/%1$s)",
    "COMMON.TABLE.UNPIN_COLUMN": "Sblocca colonna",
    "COMMON.UPLOAD.CHOOSE_FILE": "Scegli file",
    "COMMON.VALIDATION.INVALID_EMAIL": "Indirizzo email non valido",
    "COMMON.VIEW.CLASSIC_VIEW": "Visualizzazione classica",
    "COMMON.VIEW.LIST_VIEW": "Visualizzazione elenco",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.COMPANIES": "Aziende",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.DEFAULT_TITLE": "Seleziona un partner o un'azienda",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.PARTNERS": "Partner",
    "COMPANIES_PAGE.ADD_COMPANY.BUTTON": "Nuova Compagnia",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.ADDRESS.LABEL": "indirizzo aziendale",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.ADDRESS.PLACEHOLDER": "Inserisci l'indirizzo",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.NAME.LABEL": "Nome della ditta",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.NAME.PLACEHOLDER": "Inserisci il nome",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.SUBMIT": "Aggiungere",
    "COMPANIES_PAGE.ADD_COMPANY.TITLE": "Aggiungi nuova azienda",
    "COMPANIES_PAGE.CRUMB": "Aziende",
    "COMPANIES_PAGE.DELETE_COMPANY.TITLE": "Sei sicuro di voler eliminare questa Azienda?",
    "COMPANIES_PAGE.SUBTITLE": "Alcune altre informazioni importanti vanno qui",
    "COMPANIES_PAGE.TABLE.ACTIONS": "Azioni",
    "COMPANIES_PAGE.TABLE.ADDRESS": "Indirizzo",
    "COMPANIES_PAGE.TABLE.BRANCHES": "Progetti",
    "COMPANIES_PAGE.TABLE.ID": "ID",
    "COMPANIES_PAGE.TABLE.INDEX": "№",
    "COMPANIES_PAGE.TABLE.NAME": "Nome",
    "COMPANIES_PAGE.TABLE.REPORTS": "Rapporti personalizzati totali",
    "COMPANIES_PAGE.TABLE.USERS": "Utenti totali",
    "COMPANIES_PAGE.TITLE.NO_COMPANIES": "Non ci sono aziende",
    "COMPANIES_PAGE.TITLE.TOTAL_COUNT": "Aziende totali:",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.ALLOCATE_LE": "Assegna LE",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.API_ERROR": "Errore, per favore prova ancora",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.API_SUCCESS": "Successo, i punti di passaggio sono stati assegnati",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.ASSIGN_WAYPOINTS": "Assegna i Punti di Riferimento Selezionati all'Ingegnere delle Perdite",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.CHANGE": "Cambia",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.CLOSE": "Chiudi",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.NO_WAYPOINTS": "Nessun waypoint selezionato",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.OPTION_ENGINEER": "Ingegnere:",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.REMOVE": "rimuovi",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SEARCH.PLACEHOLDER": "Cerca ingegnere",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SELECTING_ERROR": "Seleziona un ingegnere e dei punti di passaggio",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SUBMIT_BTN": "Assegna punti di passaggio",
    "COMPONENTS.COMPANY_SELECT.CHOOSE_COMPANY": "Scegli una società/partner",
    "COMPONENTS.COMPANY_SELECT.COMPANY": "Progetto",
    "COMPONENTS.COMPANY_SELECT.ERROR": "Oops! Qualcosa è andato storto. Si prega di aggiornare la pagina e riprovare.",
    "COMPONENTS.COMPANY_SELECT.FORM.SEARCH.PLACEHOLDER": "Cerca azienda, partner o progetto",
    "COMPONENTS.COMPANY_SELECT.FORM.SELECT.PLACEHOLDER": "Seleziona il tipo di dati",
    "COMPONENTS.COMPANY_SELECT.NO_DATA": "Non ci sono progetti disponibili",
    "COMPONENTS.COMPANY_SELECT.NO_RESULTS": "Nessun risultato trovato",
    "COMPONENTS.COMPANY_SELECT.PARTNER": "Azienda/Partner",
    "COMPONENTS.COMPANY_SELECT.VIEW": "Visualizzazione",
    "COMPONENTS.DATE_VIEWER.END_DATE": "Data di Fine",
    "COMPONENTS.DATE_VIEWER.START_DATE": "Data di inizio",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.COMPANIES": "Aziende",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.ENGINEERS": "Ingegneri",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.PARTNERS": "Partner",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.PROJECTS": "Progetti",
    "COMPONENTS.ERROR_BOUNDARY.MESSAGE": "Si è verificato un errore imprevisto",
    "COMPONENTS.ERROR_BOUNDARY.RELOAD": "Ricarica pagina",
    "COMPONENTS.ERROR_BOUNDARY.SHOW_STACK": "Mostra stack di errori (sviluppo)",
    "COMPONENTS.ERROR_BOUNDARY.TITLE": "Oops! Qualcosa è andato storto",
    "COMPONENTS.FILE_UPLOAD.BROWSE": "Sfoglia File",
    "COMPONENTS.FILE_UPLOAD.DRAG_TEXT": "Trascina & Rilascia",
    "COMPONENTS.FILE_UPLOAD.ERROR": "È richiesto un file",
    "COMPONENTS.FILE_UPLOAD.FILES": "File",
    "COMPONENTS.FILE_UPLOAD.OR": "Oro",
    "COMPONENTS.FILE_UPLOAD.SUPPORTED": "Supporta: ",
    "COMPONENTS.FILTER.CLOSE": "Chiudi",
    "COMPONENTS.FILTER.SELECT_A_DMA": "Seleziona un DMA",
    "COMPONENTS.FILTER.SELECT_A_PROJECT": "Seleziona un progetto",
    "COMPONENTS.FILTER.SELECT_A_SIZE": "Seleziona una taglia",
    "COMPONENTS.FILTER.SELECT_A_STATUS": "Seleziona uno stato",
    "COMPONENTS.FILTER.SELECT_DMA": "Seleziona DMA",
    "COMPONENTS.FILTER.SELECT_PROJECT": "Seleziona Progetto",
    "COMPONENTS.FILTER.SELECT_SIZE": "Seleziona la dimensione",
    "COMPONENTS.FILTER.SELECT_STATUS": "Seleziona Stato",
    "COMPONENTS.FUNNEL_CHART.ERROR_MSG": "Nessun dato",
    "COMPONENTS.GRAPH_TOGGLE.SPECTRAL_PROFILE": "Profilo Spettrale",
    "COMPONENTS.HISTORY_CONTAINER.ACTION": "Azione",
    "COMPONENTS.HISTORY_CONTAINER.DATETIME": "Data e Ora",
    "COMPONENTS.HISTORY_CONTAINER.ID": "ID",
    "COMPONENTS.HISTORY_CONTAINER.NOTES": "note",
    "COMPONENTS.HISTORY_CONTAINER.REFERENCE_WAYPOINT": "punto di riferimento",
    "COMPONENTS.HISTORY_CONTAINER.REFERENCE_WAYPOINT_ID": "id punto di riferimento",
    "COMPONENTS.HISTORY_CONTAINER.SCHEDULED_DATE": "data programmata",
    "COMPONENTS.HISTORY_CONTAINER.STATUS_CHANGED_FROM_ID": "lo stato è cambiato da id",
    "COMPONENTS.HISTORY_CONTAINER.STATUS_NAME": "cambiato in nome dello stato",
    "COMPONENTS.HISTORY_CONTAINER.TIME_ELAPSED": "Tempo Trascorso",
    "COMPONENTS.HISTORY_CONTAINER.TITLE": "Storia dai registri dei waypoint",
    "COMPONENTS.HISTORY_CONTAINER.USER_ID": "ID utente",
    "COMPONENTS.HISTORY_CONTAINER.USER_NAME": "Autore della modifica",
    "COMPONENTS.HISTORY_CONTAINER.WAYPOINT_ID": "id waypoint",
    "COMPONENTS.HISTORY_CONTAINER.WAYPOINT_NAME": "nome del waypoint",
    "COMPONENTS.ICON_INSIGHT.ALT": "Icona delle informazioni",
    "COMPONENTS.IMAGE_UPLOAD_BOX.BUTTON_TEXT": "Sfoglia Foto",
    "COMPONENTS.IMAGE_UPLOAD_BOX.DRAG_TEXT": "Trascina & Rilascia",
    "COMPONENTS.IMAGE_UPLOAD_BOX.IMAGE_TYPE": "Supporta: *.png, *.jpg e *.jpeg",
    "COMPONENTS.IMAGE_UPLOAD_BOX.OR": "OPPURE",
    "COMPONENTS.INSERT_DATE.ADD.END_DATE": "Aggiungi Data di Fine",
    "COMPONENTS.INSERT_DATE.ADD.START_DATE": "Aggiungi Data di Inizio",
    "COMPONENTS.INSERT_DATE.DATE.LABEL": "Data",
    "COMPONENTS.INSERT_DATE.DATE.PLACEHOLDER": "Seleziona una Data",
    "COMPONENTS.INSERT_DATE.EDIT.END_DATE": "Modifica Data di Fine",
    "COMPONENTS.INSERT_DATE.EDIT.START_DATE": "Modifica Data di Inizio",
    "COMPONENTS.INSERT_DATE.FAILURE_DESC": "Si prega di riprovare, l'aggiornamento non è stato eseguito con successo",
    "COMPONENTS.INSERT_DATE.FAILURE_TITLE": "Riprova!",
    "COMPONENTS.INSERT_DATE.OK": "OK",
    "COMPONENTS.INSERT_DATE.SUBMIT": "Invia",
    "COMPONENTS.INSERT_DATE.SUCCESS_DESC": "La data è stata aggiornata",
    "COMPONENTS.INSERT_DATE.SUCCESS_TITLE": "Fantastico!",
    "COMPONENTS.LEAK_SIZE_FUNNEL.LARGE": "Grande perdita",
    "COMPONENTS.LEAK_SIZE_FUNNEL.MEDIUM": "Perdita media",
    "COMPONENTS.LEAK_SIZE_FUNNEL.SMALL": "Piccola perdita",
    "COMPONENTS.PAGINATION.PAGE_OF": "{{page}} di {{total}}",
    "COMPONENTS.PAGINATION.ROWS_PER_PAGE": "Righe per pagina",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.FAILURE_DESC": "Si prega di riprovare, il rapporto non è stato eseguito correttamente",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.FAILURE_TITLE": "Riprova!",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.OK": "OK",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.POST_PROJECT_DESC": "Questo rapporto ti verrà inviato via email una volta che lo invii",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SELECT_FORMAT": "Seleziona il formato",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SUCCESS_DESC": "Il tuo rapporto è stato creato. Controlla la tua email per i dettagli",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SUCCESS_TITLE": "Fantastico!",
    "COMPONENTS.PROGRESS_BAR.END_DATE": "Data di fine",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_A": "Pipeline Implementato",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_B": "Pipeline Raccolto",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_C": "Progresso Obiettivo",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_D": "Caricato su FIDO AI",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_E": "Implementato",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_F": "Convalidato",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_G": "Contrassegnato per la Riparazione",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_H": "Identificato da FIDO AI",
    "COMPONENTS.PROGRESS_BAR.LEAKAGE_REDUCTION": "Acqua risparmiata da perdite previste, perdite segnalate per riparazione e perdite validate, mostrate rispetto all'obiettivo di riduzione.",
    "COMPONENTS.PROGRESS_BAR.LEAKAGE_TITLE": "Riduzione delle Perdite",
    "COMPONENTS.PROGRESS_BAR.PIPELINE_COVERAGE": "La copertura del pipeline indica la frazione del pipeline totale che è stata coperta, mostrata come una percentuale.",
    "COMPONENTS.PROGRESS_BAR.PIPELINE_TITLE": "Copertura del Pipeline",
    "COMPONENTS.PROGRESS_BAR.SESSIONS": "Sessioni",
    "COMPONENTS.PROGRESS_BAR.START_DATE": "Data di inizio",
    "COMPONENTS.PROGRESS_BAR.TARGET_LEAKAGE.ERROR_MSG": "Specifica il tuo obiettivo per la riduzione delle perdite per attivare la visualizzazione dei progressi.",
    "COMPONENTS.PROGRESS_BAR.TARGET_PIPELINE.ERROR_MSG": "Specifica la tua distanza target per la copertura del pipeline per attivare la visualizzazione dei progressi.",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_RESULTS": "Risultati delle dimensioni delle perdite",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.LARGE": "grande",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.MEDIUM": "medio",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.SMALL": "piccolo",
    "COMPONENTS.PROPORTIONAL_BAR.NO_LEAKS": "Non sono state rilevate perdite.",
    "COMPONENTS.PROPORTIONAL_BAR.TITLE": "Percentuale o Numero di Perdite",
    "COMPONENTS.SEARCH_BAR.GENERIC": "Cerca",
    "COMPONENTS.SEARCH_BAR.SEARCH_COMPANIES": "Ricerca di aziende",
    "COMPONENTS.SEARCH_BAR.SEARCH_PROJECTS": "Ricerca di progetti",
    "COMPONENTS.SEARCH_BAR.SEARCH.DISABLED_TOOLTIP": "Seleziona un partner o un'azienda prima di utilizzare la ricerca",
    "COMPONENTS.SEARCH.IMG.ALT": "Icona di ricerca",
    "COMPONENTS.SELECT.DESELECT_ALL": "Deseleziona tutto",
    "COMPONENTS.SELECT.SELECT_ALL": "Seleziona tutto",
    "COMPONENTS.SESSION_INFORMATION.CONFIRMED_LEAKS": "Perdite Confermate",
    "COMPONENTS.SESSION_INFORMATION.NAME": "Nome",
    "COMPONENTS.SESSION_INFORMATION.REGION": "Regione",
    "COMPONENTS.SESSION_INFORMATION.TITLE": "Informazioni su DMA ID",
    "COMPONENTS.SESSION_RELOCATION.BUTTON_CANCEL": "Annulla",
    "COMPONENTS.SESSION_RELOCATION.BUTTON_CONFIRM": "Conferma",
    "COMPONENTS.SESSION_RELOCATION.PARAGRAPH_A": "Sei sicuro di volere questo ID sessione",
    "COMPONENTS.SESSION_RELOCATION.PARAGRAPH_B": "da posizionare su questa Chiave di Risorsa",
    "COMPONENTS.SESSION_RELOCATION.SUCCESS.REQUEST": "Sessione spostata con successo",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.ERROR": "Icona di errore",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.SUCCESS": "Icona di successo",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.WARNING": "Icona di avvertimento",
    "COMPONENTS.STATUS_MODAL.ICON.NEGATIVE.ALT": "Croce che indica un fallimento",
    "COMPONENTS.STATUS_MODAL.ICON.POSITIVE.ALT": "Spunta indicante il successo",
    "COMPONENTS.STATUS_MODAL.OK": "OK",
    "COMPONENTS.WAYPOINT_HEADINGS.CONSUMPTION_PROFILE": "Profilo di Consumo",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION": "Correlazione",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION_TOOLTIP.CONTENT": "Questo mostra l'elenco delle correlazioni con le relative sessioni nel seguente formato:\\n{ID Correlazione}: {ID Sessione A} - {ID Sessione B}",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION_TOOLTIP.TITLE": "Dropdown di Correlazione",
    "COMPONENTS.WAYPOINT_HEADINGS.JOB": "Lavori",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION_TOOLTIP.CONTENT": "Questo menu a discesa rappresenta gli ID di sessione con il loro stato corrispondente e l'ultimo orario di aggiornamento nel formato:\\n{Session ID} : {Status} : {Last Update Time}",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION_TOOLTIP.TITLE": "Dropdown della sessione",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.ID": "ID sessione",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.LAST_UPDATE": "Ora di fine",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.STATUS": "Stato",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.TYPE": "Tipo",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSIONS": "Sessioni",
    "COMPONENTS.WAYPOINT_HEADINGS.TOP_SOUND": "Suono di punta",
    "COMPONENTS.WAYPOINT_HEADINGS.WAYPOINT_LINK": "Torna a Waypoint",
    "COMPONENTS.WAYPOINT_KEY.LARGEST": "Punto di passaggio più grande",
    "COMPONENTS.WAYPOINT_KEY.LATEST": "Ultimo Waypoint",
    "COMPONENTS.WAYPOINT_TABLE.NUMBER_ROWS": "Righe per pagina",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_FIVE": "Data Aggiornata",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_FOUR": "Nome dell'Ingegnere",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_ONE": "Nome",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_SEVEN": "Seleziona Waypoint",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_SIX": "Data di Creazione",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_THREE": "Stato",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_TWO": "Dimensione",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.CORRELATION": "Correlazione",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.MARKED_UP": "Contrassegnato",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.OVERNIGHT_SESSION": "Sessione notturna",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.REPAIR_SCHEDULED": "Riparazione Programmata",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.REPAIRED": "Riparato",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.SCHEDULED": "Pianificato",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.TITLE": "Stato attuale",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.TOP_SOUND": "Suono superiore",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.VALIDATED": "Convalidato",
    "CONFIRM_ACCOUNT_PAGE.FORM.EMAIL.LABEL": "E-mail",
    "CONFIRM_ACCOUNT_PAGE.FORM.EMAIL.PLACEHOLDER": "Inserisci l'email",
    "CONFIRM_ACCOUNT_PAGE.FORM.PASSWORD.LABEL": "Parola d'ordine",
    "CONFIRM_ACCOUNT_PAGE.FORM.PASSWORD.PLACEHOLDER": "Inserire la password",
    "CONFIRM_ACCOUNT_PAGE.FORM.REPEAT_PASSWORD.LABEL": "Ripeti la password",
    "CONFIRM_ACCOUNT_PAGE.FORM.REPEAT_PASSWORD.PLACEHOLDER": "Ripeti la password",
    "CONFIRM_ACCOUNT_PAGE.FORM.SUBMIT": "Confermare",
    "CONFIRM_ACCOUNT_PAGE.SUBTITLE": "Conferma l'account di seguito",
    "CONFIRM_ACCOUNT_PAGE.TITLE": "Conferma conto",
    "CONSUMPTION_PROFILE_PAGE.CHART_LOAD_FAILED": "Impossibile caricare i dati del grafico dei consumi. Prova ad aggiornare la pagina o contatta l'assistenza se il problema persiste.",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.CONSUMPTION_INFO_TITLE": "Informazioni sul Consumo",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.CONSUMPTION_PROFILING": "ID del Profilo di Consumo",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.DATE_TITLE": "Date Orari",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.END_TIME": "Ora di fine",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.EXPECTED_SAMPLES": "Campioni previsti",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.START_TIME": "Ora di inizio",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.TITLE": "Informazioni sul Profilo di Consumo",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.UPLOADED_SAMPLES": "Campioni caricati",
    "CONSUMPTION_PROFILE_PAGE.LINE_GRAPH.EXPORT": "Esporta Dati dall'Intervallo Visualizzato",
    "CONSUMPTION_PROFILE_PAGE.LINE_GRAPH.TITLE": "Profilo di Consumo",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.COLLECTED_ENGINEER": "Ingegnere Raccolto",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.COMPANY": "Azienda",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.DEPLOYED_ENGINEER": "Ingegnere impiegato",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.LAST_UPDATED": "Giorni dall'ultimo aggiornamento",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.LOCATION": "Posizione",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.POSTCODE": "Codice postale",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.TITLE": "Dati di localizzazione",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.WHAT3WORDS": "What3Words",
    "CONSUMPTION_PROFILE_PAGE.NO_DATA": "Nessun dato nell'intervallo visualizzato, si prega di provare un intervallo diverso.",
    "CORRELATION_GRAPHS.CORRELATION_IMG_ALT": "Immagine di Correlazione",
    "CORRELATION_GRAPHS.NO_RESULTS": "Nessun audio o grafici disponibili per l'ID sessione:",
    "CORRELATION_GRAPHS.PAGE_TITLE": "Profilo Spettrale",
    "CORRELATION_GRAPHS.PSD_IMG_ALT": "PSD per sessione",
    "CORRELATION_GRAPHS.SESSION_ID": "Id sessione",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.DETAILS_TITLE": "Dettagli Correlazione",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.LEAK_DISTANCE": "Distanza di perdita",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.POINT_A": "Posizione del punto A",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.POINT_B": "Posizione del punto B",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.SPEED_OF_SOUND": "Velocità del suono",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TIMESTAMP": "Marca temporale",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TITLE": "Informazioni sulla correlazione",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TOTAL_LENGTH": "Lunghezza Totale",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.COMPANY": "Azienda",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.ENGINEER": "Ingegnere",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.TITLE": "Informazioni sull'ingegnere",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.DIAMETER": "Diametro",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.LENGTH": "Lunghezza",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.MILLIMETERS": "mm",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.TITLE": "Dettagli del materiale",
    "CORRELATION_INFO_PAGE.STATUS.CENTRAL": "Posizione centrale sospetta, si prega di controllare manualmente",
    "CORRELATION_INFO_PAGE.STATUS.DETECTED": "La correlazione è stata un successo",
    "CORRELATION_INFO_PAGE.STATUS.INCONCLUSIVE": "Correlazione inconcludente",
    "CORRELATION_INFO_PAGE.STATUS.NOT_FOUND": "Rumore di perdita non trovato",
    "CORRELATION_INFO_PAGE.STATUS.SUCCESS.DESCRIPTION": "I risultati della correlazione indicano l'assenza di una perdita.",
    "CORRELATION_INFO_PAGE.STATUS.SUCCESS.TITLE": "Ottima notizia!",
    "CORRELATION_INFO_PAGE.STATUS.SUSPICIOUS_A": "Informazioni sospette sul tubo o fuori parentesi verso il punto A",
    "CORRELATION_INFO_PAGE.STATUS.SUSPICIOUS_B": "Informazioni sospette sul tubo o fuori parentesi verso il punto B",
    "CORRELATION_INFO_PAGE.STATUS.WARNING.DESCRIPTION": "I risultati della correlazione indicano la presenza di una perdita.",
    "CORRELATION_INFO_PAGE.STATUS.WARNING.TITLE": "Attenzione!",
    "CURRENCY.EUR": "Euro",
    "CURRENCY.GBP": "Sterlina britannica",
    "CURRENCY.USD": "Dollaro statunitense",
    "DASHBOARD_PAGE.CO2.LABEL": "Risparmio di CO2",
    "DASHBOARD_PAGE.LEAKS.LABEL": "Numero di perdite",
    "DASHBOARD_PAGE.LEAKS.LEGEND.LARGE": "Grande",
    "DASHBOARD_PAGE.LEAKS.LEGEND.MEDIUM": "Medio",
    "DASHBOARD_PAGE.LEAKS.LEGEND.SMALL": "Piccolo",
    "DASHBOARD_PAGE.LEAKS.SUBTITLE": "Numero di perdite rilevate",
    "DASHBOARD_PAGE.LEAKS.TITLE": "Dimensione perdite",
    "DASHBOARD_PAGE.SUBTITLE": "Alcune altre informazioni importanti vanno qui",
    "DASHBOARD_PAGE.SUMMARY.EXCEPTIONS.SUBTITLE": "Problemi",
    "DASHBOARD_PAGE.SUMMARY.EXCEPTIONS.TITLE": "Avvisi di eccezione",
    "DASHBOARD_PAGE.SUMMARY.FIDO_FUNNEL": "Imbuto per Fido",
    "DASHBOARD_PAGE.SUMMARY.FIDO_SCORE": "Punteggio FIDO",
    "DASHBOARD_PAGE.SUMMARY.LEAK_TITLE": "Informazioni sulla perdita",
    "DASHBOARD_PAGE.SUMMARY.LEAKS_IDENTIFIED": "Perdite Predette da FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.LOCATE_DMA_BUTTON": "Localizza DMA sulla mappa",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_REPAIRED": "Numero contrassegnato per la riparazione",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_SCHEDULED": "Numero programmato",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_VERIFIED_REPAIRED": "Numero di riparazioni verificate da FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.DELIVERY": "Prestazioni di consegna",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.HEALTH_CHECK": "Rapporto di controllo della salute",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.POST_PROJECT": "Relazione post-progetto",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.PROJECT": "Stato del progetto",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.TITLE": "Rapporti",
    "DASHBOARD_PAGE.SUMMARY.SESSIONS_ANALISED": "File analizzati da FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.TIMELINE.COMPANY": "Cronologia dell'azienda",
    "DASHBOARD_PAGE.SUMMARY.TIMELINE.PROJECT": "Cronologia del progetto",
    "DASHBOARD_PAGE.TIME_RANGE.ALL_TIME": "Sempre",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_30_DAYS": "Ultimi 30 giorni",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_7_DAYS": "Ultimi 7 giorni",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_YEAR": "L'anno scorso",
    "DASHBOARD_PAGE.TIME_RANGE.TODAY": "Oggi",
    "DASHBOARD_PAGE.TITLE": "Pannello di controllo",
    "DASHBOARD_PAGE.TOTAL_LEAKAGE_DETECTED": "Perdita totale rilevata",
    "DASHBOARD_PAGE.VIEW_ALL_BTN": "Visualizza tutti i progetti",
    "DASHBOARD_PAGE.VOLUMETRICS.SUBTITLE": "Volumetria delle perdite",
    "DASHBOARD_PAGE.WATER.ANALYSED_BY": "Sessioni analizzate da FIDO AI",
    "DASHBOARD_PAGE.WATER.COST": "Costo dell'acqua persa",
    "DASHBOARD_PAGE.WATER.COST_PER_YEAR": "Sessioni analizzate da",
    "DASHBOARD_PAGE.WATER.FIDO_AI": "FIDO AI",
    "DASHBOARD_PAGE.WELCOME": "Benvenuto",
    "DASHBOARD_PAGE.WELCOME_DESCRIPTION": "Qui puoi accedere a dati chiave quali copertura, riduzione delle perdite, costi delle perdite d'acqua e monitoraggio dei progressi.",
    "DELETE_USER.BTN.CANCEL": "Annulla",
    "DELETE_USER.BTN.CLOSE": "Chiudi Modal",
    "DELETE_USER.BTN.SUBMIT": "Elimina",
    "DELETE_USER.DESC": "Eliminando questo profilo verranno rimossi tutti i dati personali",
    "DELETE_USER.SUCCESS.MSG": "Utente rimosso con successo",
    "DELETE_USER.TITLE": "Eliminare il profilo?",
    "DELETE_USER.VALIDATION.ERROR": "L'utente non può essere rimosso, per favore riprova",
    "DELIVERY_PERFORMANCE_PAGE.COLLECTIONS": "Collezioni",
    "DELIVERY_PERFORMANCE_PAGE.CONVERSION_RATE": "Tasso di conversione",
    "DELIVERY_PERFORMANCE_PAGE.COVERED": "Distanza Percorsa",
    "DELIVERY_PERFORMANCE_PAGE.DEPLOYMENT_ACCURACY": "Precisione del dispiegamento",
    "DELIVERY_PERFORMANCE_PAGE.DEPLOYMENTS": "Implementazioni",
    "DELIVERY_PERFORMANCE_PAGE.END_DATE": "Data di fine",
    "DELIVERY_PERFORMANCE_PAGE.HOURS_WORKED": "Ore lavorate",
    "DELIVERY_PERFORMANCE_PAGE.IN_PROGRESS_WAYPOINTS": "Punti di passaggio in corso",
    "DELIVERY_PERFORMANCE_PAGE.KM_COVERED": "km Percorsi",
    "DELIVERY_PERFORMANCE_PAGE.LEAKS_MARKED_UP": "Perdite marcate",
    "DELIVERY_PERFORMANCE_PAGE.NAME": "Nome",
    "DELIVERY_PERFORMANCE_PAGE.NON_LEAKS_MARKED_UP": "Non trapela Annotato",
    "DELIVERY_PERFORMANCE_PAGE.NOT_FOUND_WAYPOINTS": "waypoints non trovati",
    "DELIVERY_PERFORMANCE_PAGE.START_DATE": "data di inizio",
    "DELIVERY_PERFORMANCE_PAGE.WAYPOINTS_INVESTIGATED": "punti di passaggio indagati",
    "DETAIL_WIDGET.TITLE_A": "Sessioni",
    "DETAIL_WIDGET.TITLE_B": "FIDO AI Volumetrico Identificato",
    "DETAIL_WIDGET.TITLE_C": "Costo Operativo della Perdita d'Acqua",
    "DIALOG.CONFIRM_DELETE.DESCRIPTION": "Sei sicuro di voler eliminare questa colonna?",
    "DIALOG.CONFIRM_DELETE.TITLE": "Confermare",
    "DIALOG.FORGOT_PASSWORD.CLOSE": "Vicino",
    "DIALOG.FORGOT_PASSWORD.DESCRIPTION": "Invieremo un link per il recupero della password all'indirizzo email dell'utente.",
    "DIALOG.FORGOT_PASSWORD.SUBMIT": "Reimposta password",
    "DIALOG.FORGOT_PASSWORD.TITLE": "Reimposta password",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.BUTTON": "Nuovo Progetto",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.NAME.LABEL": "Nome del Progetto",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.NAME.PLACEHOLDER": "Inserisci il nome del progetto",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.SUBMIT": "Aggiungi Progetto",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.TITLE": "Aggiungi Progetto",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.BUTTON": "Nuovo impiegato",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.BRANCH.LABEL": "Progetto",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.BRANCH.PLACEHOLDER": "Scegli Progetto",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.COMPANY.LABEL": "Azienda",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.COMPANY.PLACEHOLDER": "Scegli Azienda",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.EMAIL.LABEL": "Indirizzo e-mail",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.EMAIL.PLACEHOLDER": "Inserisci l'email",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.FIRST_NAME.LABEL": "Nome di battesimo",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.FIRST_NAME.PLACEHOLDER": "Inserisci il nome",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.LAST_NAME.LABEL": "Cognome",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.LAST_NAME.PLACEHOLDER": "Inserisci Cognome",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.ROLE.LABEL": "Ruolo",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.ROLE.PLACEHOLDER": "Scegli Ruolo",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.SUBMIT": "Aggiungi dipendente",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.TITLE": "Aggiungi dipendente",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ACTIONS": "Azioni",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ADD": "Aggiungere",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ADDRESS": "Indirizzo",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.BRANCHES": "Progetti ({{ count }})",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.INDEX": "№",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.NAME": "Nome del Progetto",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.NO_BRANCHES": "Nessun Progetto",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.TOTAL_REPORTS": "Rapporti totali",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.TOTAL_USERS": "Utenti totali",
    "EDIT_COMPANY_PAGE.CRUMB": "Gestisci azienda",
    "EDIT_COMPANY_PAGE.DELETE_BRANCH.TITLE": "Sei sicuro di voler eliminare questo Progetto?",
    "EDIT_COMPANY_PAGE.DELETE_COMPANY.TITLE": "Sei sicuro di voler eliminare questa azienda?",
    "EDIT_COMPANY_PAGE.DELETE_EMPLOYEE.TITLE": "Sei sicuro di voler eliminare questo dipendente?",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.BUTTON": "Modifica Progetto",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.FORM.NAME.PLACEHOLDER": "Inserisci il nome del progetto",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.FORM.SUBMIT": "Aggiorna Progetto",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.TITLE": "Modifica Progetto",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ACTIONS": "Azioni",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ADD": "Aggiungere",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.BRANCH": "Progetto",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.EMAIL": "E-mail",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.EMPLOYEES": "Dipendenti ({{ count }})",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.INDEX": "№",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.NAME": "Nome utente",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.NO_EMPLOYEES": "Nessun dipendente",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ROLE": "Ruolo",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.STATUS": "Stato",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.TOTAL_REPORTS": "Rapporti personalizzati totali",
    "EDIT_COMPANY_PAGE.FORM.ADDRESS.LABEL": "Indirizzo",
    "EDIT_COMPANY_PAGE.FORM.ADDRESS.PLACEHOLDER": "Inserisci l'indirizzo",
    "EDIT_COMPANY_PAGE.FORM.DELETE": "Eliminare",
    "EDIT_COMPANY_PAGE.FORM.DISCARD": "Scartare",
    "EDIT_COMPANY_PAGE.FORM.EDIT": "Modificare",
    "EDIT_COMPANY_PAGE.FORM.NAME.LABEL": "Nome",
    "EDIT_COMPANY_PAGE.FORM.NAME.PLACEHOLDER": "Inserisci il nome",
    "EDIT_COMPANY_PAGE.FORM.NO_CHANGES": "Nessun cambiamento",
    "EDIT_COMPANY_PAGE.FORM.SUBMIT": "Salva",
    "EDIT_COMPANY_PAGE.TITLE": "Modifica azienda",
    "EDIT_PARTNER.COUNTRY": "Paese",
    "EDIT_PARTNER.PARTNER_CODE": "Codice Partner",
    "EDIT_PARTNER.PARTNER_NAME": "Nome del Partner",
    "EDIT_PARTNER.TITLE": "Modifica Partner",
    "EDIT_PROJECT.COMPANY.LABEL": "Azienda",
    "EDIT_PROJECT.COMPANY.PLACEHOLDER": "Seleziona un'azienda",
    "EDIT_PROJECT.COMPANY.VALIDATION": "È richiesta un'azienda",
    "EDIT_PROJECT.COST_PER_DISTANCE.LABEL": "Costo per Distanza",
    "EDIT_PROJECT.COST_PER_DISTANCE.PLACEHOLDER": "Costo per Distanza",
    "EDIT_PROJECT.COST_PER_DISTANCE.VALIDATION": "È richiesto il costo per distanza",
    "EDIT_PROJECT.DISCARD": "Scarta",
    "EDIT_PROJECT.DMAS.LABEL": "DMAs",
    "EDIT_PROJECT.DMAS.NO_MATCHING": "Nessun DMA corrispondente",
    "EDIT_PROJECT.DMAS.PLACEHOLDER": "Seleziona DMAs",
    "EDIT_PROJECT.END_DATE.LABEL": "Data di Fine",
    "EDIT_PROJECT.END_DATE.PLACEHOLDER": "Seleziona Data di Fine",
    "EDIT_PROJECT.END_DATE.VALIDATION": "La data di fine deve essere successiva alla data di inizio",
    "EDIT_PROJECT.NAME.LABEL": "Nome del Progetto",
    "EDIT_PROJECT.NAME.PLACEHOLDER": "Inserisci il nome del progetto",
    "EDIT_PROJECT.NAME.VALIDATION": "Il nome del progetto è obbligatorio",
    "EDIT_PROJECT.NO_CHANGES": "Nessuna modifica alle informazioni del progetto.",
    "EDIT_PROJECT.START_DATE.LABEL": "Data di inizio",
    "EDIT_PROJECT.START_DATE.PLACEHOLDER": "Seleziona Data di Inizio",
    "EDIT_PROJECT.START_DATE.VALIDATION": "La data di inizio deve essere precedente alla data di fine",
    "EDIT_PROJECT.SUBMIT": "Invia",
    "EDIT_PROJECT.TARGET_DISTANCE.LABEL": "Distanza del bersaglio",
    "EDIT_PROJECT.TARGET_DISTANCE.PLACEHOLDER": "Inserisci la distanza target",
    "EDIT_PROJECT.TARGET_DISTANCE.VALIDATION": "È richiesta la distanza target",
    "EDIT_PROJECT.TARGET_LEAKAGE.LABEL": "Perdita di bersaglio",
    "EDIT_PROJECT.TARGET_LEAKAGE.PLACEHOLDER": "Inserisci Target Leakage",
    "EDIT_PROJECT.TARGET_LEAKAGE.VALIDATION": "È richiesta la perdita target",
    "EDIT_PROJECT.TITLE": "Modifica Progetto",
    "EDIT_USER.PAGE_TITLE": "Modifica Utente",
    "EDIT_USER.RETURN_BTN": "Scarta",
    "EDIT_USER.SUBMIT_BTN": "Salva Utente",
    "ERROR.DUPLICATE_EMAIL": "L'indirizzo email inserito esiste già",
    "ERROR.DUPLICATE_PROJECT": "Il nome del progetto esiste già",
    "ERROR.NO_DATA": "I dati per questo utente non sono disponibili al momento",
    "ERROR.REPORT.NO_DATA": "Il rapporto non ha restituito dati. Si prega di provare a modificare l'intervallo di date",
    "ERROR.REQUEST": "Si è verificato un errore durante l'elaborazione della richiesta. Prova ad aggiornare la pagina.",
    "ERROR.SESSION_EXPIRED": "Sessione scaduta, accedi nuovamente",
    "EXPORT_BUTTON.ALL": "Esporta tutto",
    "EXPORT_BUTTON.ALL_CSV": "Esporta tutto (CSV)",
    "EXPORT_BUTTON.ALL_EXCEL": "Esporta tutto (Excel)",
    "EXPORT_BUTTON.ALL_JSON": "Esporta tutto (JSON)",
    "EXPORT_BUTTON.ERROR.REQUEST": "Errore durante l'esportazione dei dati",
    "EXPORT_BUTTON.EXPORT": "Esportare",
    "EXPORT_BUTTON.FILTERED": "Esportazione filtrata",
    "EXPORT_BUTTON.FILTERED_CSV": "Esporta filtrato (CSV)",
    "EXPORT_BUTTON.FILTERED_EXCEL": "Esportazione filtrata (Excel)",
    "EXPORT_BUTTON.FILTERED_JSON": "Esportazione filtrata (JSON)",
    "EXPORT_BUTTON.SUCCESS.REQUEST": "Dovresti ricevere a breve un'e-mail con l'esportazione",
    "FILTERS.DATE_RANGE.TITLE": "Intervallo di date",
    "FILTERS.DIALOG.SUBTITLE.CHANGE": "Tutti i filtri verranno eliminati?",
    "FILTERS.DIALOG.SUBTITLE.CLOSE": "Le modifiche verranno eliminate",
    "FILTERS.DIALOG.TITLE.CHANGE": "Sei sicuro di voler cambiare l'origine dati?",
    "FILTERS.DIALOG.TITLE.CLOSE": "Sei sicuro di voler chiudere le impostazioni?",
    "FILTERS.FORM.COLUMN.LABEL": "Colonna",
    "FILTERS.FORM.COLUMN.PLACEHOLDER": "Seleziona colonna",
    "FILTERS.FORM.SOURCE.LABEL": "Fonte di dati",
    "FILTERS.FORM.SOURCE.PLACEHOLDER": "Seleziona Origine dati",
    "FILTERS.FORM.TYPE.LABEL": "Tipo",
    "FILTERS.FORM.TYPE.PLACEHOLDER": "Seleziona il tipo",
    "FILTERS.FORM.VALUE.LABEL": "Valore",
    "FILTERS.FORM.VALUE.PLACEHOLDER": "Seleziona valore",
    "FILTERS.MODAL_TITLE": "Impostazioni",
    "FORGOT_PASSWORD_PAGE.FORM.EMAIL.LABEL": "E-mail",
    "FORGOT_PASSWORD_PAGE.FORM.EMAIL.PLACEHOLDER": "Inserisci il tuo indirizzo email",
    "FORGOT_PASSWORD_PAGE.FORM.SUBMIT": "Invia collegamento di ripristino",
    "FORGOT_PASSWORD_PAGE.RECOVERY_SUCCESS": "Il link di recupero è stato inviato con successo alla tua email",
    "FORGOT_PASSWORD_PAGE.SUBTITLE": "Inserisci la tua email qui sotto",
    "FORGOT_PASSWORD_PAGE.TITLE": "Ha dimenticato la password",
    "FORM.LABEL.COMPANY": "Azienda",
    "FORM.LABEL.COUNTRY": "Paese",
    "FORM.LABEL.CURRENCY": "Valuta",
    "FORM.LABEL.DIAMETER_UNIT": "Diametro",
    "FORM.LABEL.EMAIL": "E-mail",
    "FORM.LABEL.FIRST_NAME": "Nome",
    "FORM.LABEL.FLOW_RATE_UNIT": "Portata",
    "FORM.LABEL.LAST_NAME": "Cognome",
    "FORM.LABEL.LONG_DISTANCE_UNIT": "Lunga distanza",
    "FORM.LABEL.MEASUREMENT_SYSTEM": "Sistema di misurazione",
    "FORM.LABEL.PARTNER": "Partner",
    "FORM.LABEL.PHONE": "Telefono",
    "FORM.LABEL.ROLE": "Ruolo",
    "FORM.LABEL.SHORT_DISTANCE_UNIT": "Breve distanza",
    "FORM.LABEL.VOLUME_UNIT": "Volume",
    "FORM.LABEL.WEIGHT_UNIT": "Peso",
    "FORM.PLACEHOLDER.COMPANY": "Seleziona un'azienda",
    "FORM.PLACEHOLDER.COUNTRY": "Seleziona paese",
    "FORM.PLACEHOLDER.CURRENCY": "Seleziona valuta",
    "FORM.PLACEHOLDER.DIAMETER_UNIT": "Seleziona diametro",
    "FORM.PLACEHOLDER.FLOW_RATE_UNIT": "Seleziona la portata",
    "FORM.PLACEHOLDER.LONG_DISTANCE_UNIT": "Seleziona lunga distanza",
    "FORM.PLACEHOLDER.MEASUREMENT_SYSTEM": "Seleziona il sistema di misura",
    "FORM.PLACEHOLDER.PARTNER": "Scegli un partner",
    "FORM.PLACEHOLDER.PHONE": "Seleziona telefono",
    "FORM.PLACEHOLDER.ROLE": "Seleziona un ruolo",
    "FORM.PLACEHOLDER.SHORT_DISTANCE_UNIT": "Seleziona distanza breve",
    "FORM.PLACEHOLDER.VOLUME_UNIT": "Seleziona volume",
    "FORM.PLACEHOLDER.WEIGHT_UNIT": "Seleziona il peso",
    "FORM.VALIDATION.COMPANY": "È richiesta l'azienda",
    "FORM.VALIDATION.COUNTRY": "Il paese è obbligatorio",
    "FORM.VALIDATION.CURRENCY": "La valuta è obbligatoria",
    "FORM.VALIDATION.EMAIL": "È richiesta l'email",
    "FORM.VALIDATION.FIRST_NAME": "Il nome è obbligatorio",
    "FORM.VALIDATION.LAST_NAME": "Il cognome è obbligatorio",
    "FORM.VALIDATION.MEASUREMENT_SYSTEM": "Il sistema di misurazione è obbligatorio",
    "FORM.VALIDATION.PARTNER": "È richiesto un partner",
    "FORM.VALIDATION.PHONE": "Il numero di telefono è obbligatorio",
    "FORM.VALIDATION.ROLE": "Il ruolo è richiesto",
    "GIS_ADMIN.ACTION.SELECT": "Selezionare",
    "GIS_ADMIN.DELETE_MODAL.BTN.CANCEL": "Annulla",
    "GIS_ADMIN.DELETE_MODAL.BTN.REMOVE": "Rimuovere",
    "GIS_ADMIN.DELETE_MODAL.ERROR_MSG": "Impossibile eliminare il caricamento GIS",
    "GIS_ADMIN.DELETE_MODAL.TITLE": "Conferma la rimozione del caricamento GIS",
    "GIS_ADMIN.PREVIEW_MODAL.BTN.CLOSE": "Chiudi Anteprima",
    "GIS_ADMIN.PREVIEW_MODAL.ERROR_MSG": "Impossibile caricare l'anteprima",
    "GIS_ADMIN.PREVIEW_MODAL.NO_DATA": "Nessun dato da visualizzare",
    "GIS_ADMIN.PREVIEW_MODAL.TITLE": "Anteprima GIS",
    "GIS_ADMIN.SEARCH.PLACEHOLDER": "Cerca",
    "GIS_ADMIN.SEARCH.TEXT": "Cerca",
    "GIS_ADMIN.TABLE.HEADERS.A": "Nome dell'Azienda",
    "GIS_ADMIN.TABLE.HEADERS.B": "Data di caricamento",
    "GIS_ADMIN.TABLE.HEADERS.C": "Caricato Da",
    "GIS_ADMIN.TABLE.HEADERS.D": "Azione",
    "GIS_ADMIN.TABLE.TITLE": "Elenco dei caricamenti GIS",
    "GIS_ADMIN.TITLE": "Amministratore GIS",
    "GIS_UPLOAD.API.GENERIC_ERROR": "Richiesta fallita, si prega di controllare il formato del file",
    "GIS_UPLOAD.ASSETS.COLUMN.CREATED_DATE.DESCRIPTION": "Data di installazione della risorsa",
    "GIS_UPLOAD.ASSETS.COLUMN.DIAMETER.DESCRIPTION": "Diametro del bene",
    "GIS_UPLOAD.ASSETS.COLUMN.DMA_KEY.DESCRIPTION": "Riferimento alla chiave dell'area di cui la risorsa fa parte",
    "GIS_UPLOAD.ASSETS.COLUMN.KEY.DESCRIPTION": "Identificatore distinto per ogni risorsa sulla rete",
    "GIS_UPLOAD.ASSETS.COLUMN.SUBTYPE.DESCRIPTION": "Ulteriore classificazione che dettaglia le caratteristiche specifiche dell'attività",
    "GIS_UPLOAD.ASSETS.COLUMN.TYPE.DESCRIPTION": "Classificazione dell'asset in base alla funzione",
    "GIS_UPLOAD.BUTTON.DISCARD": "Scarta",
    "GIS_UPLOAD.BUTTON.NEXT": "Avanti",
    "GIS_UPLOAD.DMA.COLUMN.KEY.DESCRIPTION": "Identificatore univoco per ogni area",
    "GIS_UPLOAD.DMA.COLUMN.NAME.DESCRIPTION": "Nome descrittivo dell'area",
    "GIS_UPLOAD.ERROR_MODAL.ALT.GIF_A": "mostrando sullo schermo il processo di mappatura delle colonne",
    "GIS_UPLOAD.ERROR_MODAL.ALT.GIF_B": "visualizzazione sullo schermo del processo di mappatura dei campi di sistema",
    "GIS_UPLOAD.ERROR_MODAL.BUTTON.CLOSE": "Chiudi",
    "GIS_UPLOAD.ERROR_MODAL.DESC.A": "Mappa le colonne richieste come mostrato di seguito",
    "GIS_UPLOAD.ERROR_MODAL.DESC.B": "Mappa i campi di sistema come mostrato di seguito",
    "GIS_UPLOAD.ERROR_MODAL.DESC.C": "ANCHE",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.A": "Oops! Qualcosa è andato storto da parte nostra.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.B": "Sembra che il nostro sistema stia attualmente riscontrando alcuni problemi. Si prega di riprovare più tardi.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.C": "Se il problema persiste, non esitare a contattare il nostro team di supporto.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.D": "Si è verificato un errore",
    "GIS_UPLOAD.ERROR.INVALID_FILE": "File non valido",
    "GIS_UPLOAD.ERROR.MISSING_FILE": "File mancante",
    "GIS_UPLOAD.FILE_HEADER.BTN.BACK_TO_PROJECT": "Torna alla creazione del progetto",
    "GIS_UPLOAD.FILE_HEADER.BTN.CLOSE_MODAL": "Chiudi Modale",
    "GIS_UPLOAD.FILE_HEADER.BTN.GIS_ADMIN": "Visualizza Amministratore GIS",
    "GIS_UPLOAD.FILE_HEADER.BTN.LINK.GIS_ADMIN": "Visualizza GIS Admin",
    "GIS_UPLOAD.FILE_HEADER.BTN.UPLOAD": "Carica",
    "GIS_UPLOAD.FILE_HEADER.COUNTER": "File",
    "GIS_UPLOAD.FILE_HEADER.DISCARD": "Scarta File",
    "GIS_UPLOAD.FILE_HEADER.ERROR.PARAGRAPH": "Errore nel caricamento di GIS, riprova",
    "GIS_UPLOAD.FILE_HEADER.FINAL_STEP": "Passo finale",
    "GIS_UPLOAD.FILE_HEADER.LOADING.TEXT": "Caricamento",
    "GIS_UPLOAD.FILE_HEADER.MODAL.UPLOAD_TXT": "Caricamento completato! Controlla la pagina di amministrazione per i dettagli qui sotto",
    "GIS_UPLOAD.FILE_HEADER.NEXT": "Avanti",
    "GIS_UPLOAD.FILE_HEADER.NO_FILE": "Nessun file da selezionare",
    "GIS_UPLOAD.FILE_HEADER.PREVIOUS": "Precedente",
    "GIS_UPLOAD.FILE_HEADER.RESET": "Torna ai caricamenti di file",
    "GIS_UPLOAD.FILE_HEADER.SUCCESS.PARAGRAPH": "GIS caricato con successo",
    "GIS_UPLOAD.FILE_HEADER.TEXT.PARAGRAPH": "Sei sicuro di voler caricare GIS?",
    "GIS_UPLOAD.FILE_HEADER.TEXT.UPLOAD_PARAGRAPH": "Sei sicuro di voler caricare GIS?",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAP_PREVIEW": "Anteprima Mappa",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAPPING": "Mappatura delle colonne",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAPPING_FOR": "per",
    "GIS_UPLOAD.INPUT.COMPANY.LABEL": "Seleziona Azienda",
    "GIS_UPLOAD.INPUT.COMPANY.PLACEHOLDER": "Seleziona Azienda",
    "GIS_UPLOAD.LOADING": "Caricamento in corso...",
    "GIS_UPLOAD.MAP_PREVIEW.API.GENERAL_ERROR": "Errore nel Caricamento della Mappa",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.GIS_ADMIN": "Visualizza Amministratore GIS",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.NEXT": "Avanti",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.PREVIOUS": "Precedente",
    "GIS_UPLOAD.MAP_PREVIEW.TITLE": "Anteprima Mappa",
    "GIS_UPLOAD.MAP_PREVIEW.UPLOAD_FINISHED": "Caricamento completato! Controlla la pagina di amministrazione per i dettagli qui sotto",
    "GIS_UPLOAD.PAGE_TITLE": "Carica GIS",
    "GIS_UPLOAD.PIPES.COLUMN.CREATED_DATE.DESCRIPTION": "Data in cui è stato creato o installato il record della tubazione",
    "GIS_UPLOAD.PIPES.COLUMN.DIAMETER_UNITS.DESCRIPTION": "Unità di misura per il diametro del tubo",
    "GIS_UPLOAD.PIPES.COLUMN.DIAMETER.DESCRIPTION": "Diametro del tubo, unità specificate separatamente",
    "GIS_UPLOAD.PIPES.COLUMN.DMA_KEY.DESCRIPTION": "Riferimento alla chiave dell'area di cui il tubo fa parte",
    "GIS_UPLOAD.PIPES.COLUMN.KEY.DESCRIPTION": "Identificatore distinto per ogni tubo sulla rete",
    "GIS_UPLOAD.PIPES.COLUMN.MATERIAL.DESCRIPTION": "Materiale di costruzione primario del tubo",
    "GIS_UPLOAD.PIPES.COLUMN.STATUS.DESCRIPTION": "Se la tubazione è in servizio attivo, abbandonata, rimossa, ecc.",
    "GIS_UPLOAD.PIPES.COLUMN.SUBTYPE.DESCRIPTION": "Classificazione specifica dei tubi in base alla funzione o alla struttura",
    "GIS_UPLOAD.PIPES.COLUMN.TYPE.DESCRIPTION": "Quale servizio svolge il tubo: distribuzione principale, linea di servizio, condotto principale principale, ecc.",
    "GIS_UPLOAD.ROUTES.STEP_FIVE": "Anteprima della mappa",
    "GIS_UPLOAD.ROUTES.STEP_FOUR": "Gestisci Asset",
    "GIS_UPLOAD.ROUTES.STEP_ONE": "Carica Shapefile",
    "GIS_UPLOAD.ROUTES.STEP_THREE": "Tubi di processo",
    "GIS_UPLOAD.ROUTES.STEP_TWO": "Processo DMA",
    "GIS_UPLOAD.STATUS.FILE_FETCHING": "I dati del file sono in fase di recupero...",
    "GIS_UPLOAD.STATUS.FILE_LOADING": "Caricamento dei dati del file in corso...",
    "GIS_UPLOAD.STATUS.FILE_UPLOADING": "Caricamento del file in corso...",
    "GIS_UPLOAD.STATUS.LOADING_COMPANIES_DATA": "Caricamento dati aziendali in corso...",
    "GIS_UPLOAD.STATUS.UPLOADING_FILE": "Caricamento di un file...",
    "GIS_UPLOAD.TABLE.CREATE_COLUMN": "Crea colonna",
    "GIS_UPLOAD.TABLE.CREATE_COLUMN_ERROR": "Qualcosa è andato storto: impossibile creare la colonna",
    "GIS_UPLOAD.TABLE.INVALID_MAPPING": "Questa colonna non è valida per il tipo di dati selezionato",
    "GIS_UPLOAD.TABLE.MAPPING_TITLE": "Mappatura delle Colonne Selezionate",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.DELETE": "Eliminare",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.SAVE": "Salva le modifiche",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.TYPE": "Tipo di colonna",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.TYPE.PLACEHOLDER": "Seleziona il tipo di colonna",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.UNITS": "Unità",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.UNITS.PLACEHOLDER": "Seleziona unità",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE": "Valore",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE_MANUAL": "Valore",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE_MANUAL.PLACEHOLDER": "Inserisci un valore per tutte le celle nella colonna",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE.PLACEHOLDER": "Seleziona un valore per tutte le celle nella colonna",
    "GIS_UPLOAD.TABLE.NO_MAPPING_OPTIONS": "Nessuna opzione di mappatura",
    "GIS_UPLOAD.TABLE.SELECT_COLUMN": "Seleziona una colonna",
    "GIS_UPLOAD.TABLE.UPDATE_COLUMN": "Aggiorna colonna",
    "GIS_UPLOAD.TABLE.UPDATE_COLUMN_ERROR": "Qualcosa è andato storto: impossibile aggiornare la colonna",
    "GIS_UPLOAD.UPLOAD.ERROR": "Errore di caricamento, riprova.",
    "GIS_UPLOAD.UPLOAD.LABEL": "Carica Shapefile",
    "HEADER.BROWSE": "Sfogliare",
    "HEADER.COMPANIES": "Aziende",
    "HEADER.CONSUMPTION_PROFILE": "Profilo di Consumo",
    "HEADER.CORRELATION": "Correlazione",
    "HEADER.DASHBOARD": "Cruscotto",
    "HEADER.DPLE": "Ingegnere delle prestazioni di consegna",
    "HEADER.DPST": "Tecnico Sensore di Prestazione di Consegna",
    "HEADER.GIS_ADMIN": "Amministratore GIS",
    "HEADER.GIS_UPLOAD": "Caricamento GIS",
    "HEADER.HOME": "Casa",
    "HEADER.JOB_DETAILS": "Dettagli del lavoro",
    "HEADER.LOGS": "Registro delle modifiche",
    "HEADER.PROFILE": "Profilo",
    "HEADER.PROJECT_STATUS": "Stato del Progetto",
    "HEADER.RELAY_MANAGEMENT": "Gestione del Relay",
    "HEADER.REPORTS": "Rapporti",
    "HEADER.SENSOR_MANAGEMENT": "Gestione dei sensori",
    "HEADER.SESSION": "Informazioni sulla sessione",
    "HEADER.STOCK_MANAGEMENT": "Gestione delle Scorte",
    "HEADER.TOP_SOUND": "Top Sound",
    "HEADER.USERS": "Gestione Utenti",
    "HEADER.WAYPOINT": "Punto di passaggio",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_GRAPHS": "Nessun grafico storico o notturno disponibile",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_HISTORICAL_GRAPHS": "Nessun grafico storico disponibile",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_OVERNIGHT_GRAPHS": "Nessun grafico notturno disponibile",
    "HISTORY_AND_OVERNIGHT_GRAPHS.IMG.ALT.HISTORICAL": "Grafico della sessione storica",
    "HISTORY_AND_OVERNIGHT_GRAPHS.IMG.ALT.OVERNIGHT": "Grafico della sessione notturna",
    "HISTORY_AND_OVERNIGHT_GRAPHS.TITLES.HISTORY": "Storia",
    "HISTORY_AND_OVERNIGHT_GRAPHS.TITLES.OVERNIGHT": "Notturno",
    "HOME_PAGE.DESCRIPTION": "Benvenuto nell'Hub, dove puoi gestire le attività, supportare gli utenti e visualizzare tutti i dati del tuo servizio FIDO Smart. Come possiamo aiutarti oggi?",
    "HOME_PAGE.HELLO": "Ciao, {{name}}",
    "HOME_PAGE.HERO_IMAGE_ALT": "Immagine dell'eroe",
    "HOME_PAGE.LOCATE_LEAKS.DESCRIPTION": "Esplora i waypoint in base alle dimensioni e monitora le indagini",
    "HOME_PAGE.LOCATE_LEAKS.TITLE": "Individuare le perdite",
    "HOME_PAGE.MANAGE_PROJECTS.DESCRIPTION": "Monitorare l'avanzamento del progetto e visualizzare le attività passate",
    "HOME_PAGE.MANAGE_PROJECTS.TITLE": "Gestire i progetti",
    "HOME_PAGE.MONITOR_NETWORK.DESCRIPTION": "Gestisci i tuoi sensori fissi e ottimizza la connettività",
    "HOME_PAGE.MONITOR_NETWORK.TITLE": "Monitora la tua rete",
    "HOME_PAGE.NO_ACTIVITIES_FOUND": "Nessuna attività trovata",
    "HOME_PAGE.YOUR_DASHBOARDS.DESCRIPTION": "Analizzare e rendicontare i dati chiave sulle prestazioni",
    "HOME_PAGE.YOUR_DASHBOARDS.TITLE": "I tuoi cruscotti",
    "HOME_PAGE.YOUR_LATEST_ACTIVITIES": "Le tue ultime attività",
    "INVITATIONS.ACCEPT.CONTEXT.EMAIL": "E-mail",
    "INVITATIONS.ACCEPT.CONTEXT.NOT_PROVIDED": "Non fornito",
    "INVITATIONS.ACCEPT.CONTEXT.ORGANIZATION": "Organizzazione",
    "INVITATIONS.ACCEPT.CONTEXT.ROLE": "Ruolo",
    "INVITATIONS.ACCEPT.ERROR.ALREADY_ACCEPTED.DESCRIPTION": "Accedi con il tuo account esistente per continuare.",
    "INVITATIONS.ACCEPT.ERROR.ALREADY_ACCEPTED.TITLE": "Invito già accettato",
    "INVITATIONS.ACCEPT.ERROR.CANCELLED.DESCRIPTION": "Questo invito non è più attivo. Contatta il tuo amministratore se hai ancora bisogno di accedere.",
    "INVITATIONS.ACCEPT.ERROR.CANCELLED.TITLE": "Invito annullato",
    "INVITATIONS.ACCEPT.ERROR.EXPIRED.DESCRIPTION": "Questo link di invito non è più attivo. Richiedi un nuovo invito al tuo amministratore.",
    "INVITATIONS.ACCEPT.ERROR.EXPIRED.TITLE": "Invito scaduto",
    "INVITATIONS.ACCEPT.ERROR.INVALID.DESCRIPTION": "Questo invito non è valido o è scaduto. Richiedi un nuovo invito al tuo amministratore.",
    "INVITATIONS.ACCEPT.ERROR.INVALID.TITLE": "Invito non valido",
    "INVITATIONS.ACCEPT.ERROR.SUBMIT_FAILURE": "Non ha accettato l'invito",
    "INVITATIONS.ACCEPT.FIELDS.CONFIRM_PASSWORD": "Conferma password",
    "INVITATIONS.ACCEPT.FIELDS.COUNTRY": "Paese",
    "INVITATIONS.ACCEPT.FIELDS.CURRENCY": "Valuta",
    "INVITATIONS.ACCEPT.FIELDS.DIAMETER": "Diametro",
    "INVITATIONS.ACCEPT.FIELDS.FIRST_NAME": "Nome di battesimo",
    "INVITATIONS.ACCEPT.FIELDS.FLOW_RATE": "Portata",
    "INVITATIONS.ACCEPT.FIELDS.LAST_NAME": "Cognome",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_ARIA": "Accetto l'informativa sulla privacy e i termini e le condizioni.",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_CONJUNCTION": "E",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_PREFIX": "Accetto il",
    "INVITATIONS.ACCEPT.FIELDS.LONG_DISTANCE": "Lunga distanza",
    "INVITATIONS.ACCEPT.FIELDS.MEASUREMENT_SYSTEM": "Sistema di misurazione",
    "INVITATIONS.ACCEPT.FIELDS.PASSWORD": "Password",
    "INVITATIONS.ACCEPT.FIELDS.PHONE": "Telefono",
    "INVITATIONS.ACCEPT.FIELDS.SELECT_PLACEHOLDER": "Selezionare",
    "INVITATIONS.ACCEPT.FIELDS.SHORT_DISTANCE": "Breve distanza",
    "INVITATIONS.ACCEPT.FIELDS.VOLUME": "Volume",
    "INVITATIONS.ACCEPT.FIELDS.WEIGHT": "Peso",
    "INVITATIONS.ACCEPT.FORM_ARIA_LABEL": "Accetta l'invito",
    "INVITATIONS.ACCEPT.LINKS.PRIVACY_POLICY": "Politica sulla riservatezza",
    "INVITATIONS.ACCEPT.LINKS.TERMS_AND_CONDITIONS": "Termini e Condizioni",
    "INVITATIONS.ACCEPT.LOADING": "Invito al caricamento",
    "INVITATIONS.ACCEPT.SUBMIT": "Creare un account",
    "INVITATIONS.ACCEPT.SUBMITTING": "Accetto l'invito…",
    "INVITATIONS.ACCEPT.SUCCESS.DESCRIPTION": "Il tuo account è pronto. Accedi per continuare.",
    "INVITATIONS.ACCEPT.SUCCESS.SIGN_IN_CTA": "Registrazione",
    "INVITATIONS.ACCEPT.SUCCESS.TITLE": "Il tuo account è pronto",
    "INVITATIONS.ACCEPT.TITLE": "Accetta l'invito",
    "INVITATIONS.ACTION.CANCEL": "Cancellare",
    "INVITATIONS.ACTION.SUBMIT": "Invia invito",
    "INVITATIONS.DIALOG.DESCRIPTION": "Invita un utente tramite e-mail. L'utente verrà aggiunto all'elenco dopo aver accettato l'invito.",
    "INVITATIONS.DIALOG.TITLE": "Invita utente",
    "INVITATIONS.SUCCESS.SENT": "Invito inviato. L'utente apparirà nell'elenco degli utenti dopo aver accettato l'invito.",
    "INVITATIONS.VALIDATION.DIAMETER": "È richiesta l'unità di misura del diametro",
    "INVITATIONS.VALIDATION.FLOW_RATE": "È necessaria un'unità di misura della portata.",
    "INVITATIONS.VALIDATION.GENERIC": "Si è verificato un problema con l'invito a questo utente. Si prega di verificare le informazioni e riprovare.",
    "INVITATIONS.VALIDATION.LEGAL_ACCEPTANCE": "L'informativa sulla privacy e i termini devono essere accettati.",
    "INVITATIONS.VALIDATION.LONG_DISTANCE": "È necessaria un'unità a lunga distanza",
    "INVITATIONS.VALIDATION.PASSWORD_COMPLEXITY": "La password deve contenere almeno tre dei seguenti caratteri: minuscolo, maiuscolo, numerico e speciale.",
    "INVITATIONS.VALIDATION.PASSWORD_MAX": "La password deve essere lunga al massimo 64 caratteri.",
    "INVITATIONS.VALIDATION.SHORT_DISTANCE": "È necessaria un'unità a breve distanza",
    "INVITATIONS.VALIDATION.VOLUME": "È richiesta l'unità di volume",
    "INVITATIONS.VALIDATION.WEIGHT": "È necessaria l'unità di misura del peso",
    "JOB_DETAILS.ADDRESS": "Indirizzo della perdita",
    "JOB_DETAILS.AI_LEAK": "Dimensione della perdita prevista dall'IA",
    "JOB_DETAILS.BACK_BUTTON": "Torna a Waypoint",
    "JOB_DETAILS.CANCEL": "Annulla",
    "JOB_DETAILS.COMMENTS": "Note",
    "JOB_DETAILS.DATE_INFO_TITLE": "Informazioni sulla data",
    "JOB_DETAILS.DATE_SECTION.CREATED": "Data di Creazione",
    "JOB_DETAILS.DATE_SECTION.REPAIR": "Data di Riparazione",
    "JOB_DETAILS.DATE_SECTION.TITLE": "Date Orari",
    "JOB_DETAILS.DATE_SECTION.UPDATED": "Data Aggiornata",
    "JOB_DETAILS.DMA": "Riferimento DMA",
    "JOB_DETAILS.EDIT": "Modifica Dettagli Lavoro",
    "JOB_DETAILS.ENGINEER": "Ingegnere Assegnato",
    "JOB_DETAILS.ENVIRONMENTAL_NOTE": "Nota Ambientale",
    "JOB_DETAILS.ERROR": "Impossibile aggiornare il lavoro",
    "JOB_DETAILS.FLOW": "Riduzione del flusso",
    "JOB_DETAILS.FLOW_REDUCTION": "Riduzione del Flusso Convenuta",
    "JOB_DETAILS.ID": "ID lavoro",
    "JOB_DETAILS.JOB_IMAGES_TITLE": "Immagini del lavoro",
    "JOB_DETAILS.JOB_INFO_TITLE": "Informazioni sul lavoro",
    "JOB_DETAILS.LEAK": "Stima della Dimensione della Perdita del Cliente",
    "JOB_DETAILS.LEAK_SIZE": "Dimensione Stimata della Perdita",
    "JOB_DETAILS.LEAK_TYPE": "Stima del Tipo di Perdita sul Posto",
    "JOB_DETAILS.LOCATION_INFO_TITLE": "Informazioni sulla località",
    "JOB_DETAILS.MATERIAL": "Materiale del tubo",
    "JOB_DETAILS.NO_IMAGES": "Nessuna immagine",
    "JOB_DETAILS.NO_JOB": "Lavoro non trovato con ID",
    "JOB_DETAILS.NOMINAL": "Stima della Perdita del Cliente/ Volume Nominale",
    "JOB_DETAILS.NOTES": "Note Ambientali",
    "JOB_DETAILS.PROJECT": "Progetto",
    "JOB_DETAILS.ROAD_SPEED": "Velocità Stradale",
    "JOB_DETAILS.SAVE": "Salva",
    "JOB_DETAILS.SIZE": "Dimensione del tubo",
    "JOB_DETAILS.STATUS": "Stato del lavoro",
    "JOB_DETAILS.SURFACE": "Tipo di superficie",
    "JOB_DETAILS.TITLE": "Dettagli del lavoro",
    "JOB_DETAILS.TYPE": "Tipo di lavoro",
    "JOB_DETAILS.W3W": "What3Words",
    "JOB_DETAILS.WAYPOINT": "ID del punto di passaggio",
    "JOB_DETAILS.WAYPOINT_STATUS": "Stato del waypoint",
    "JOB_DETAILS.WORK_ORDER": "Riferimento dell'ordine di lavoro del cliente/utility",
    "LANGUAGE.ENGLISH": "Inglese",
    "LANGUAGE.FRENCH": "Francese",
    "LANGUAGE.ITALIAN": "Italiano",
    "LANGUAGE.POLISH": "Polacco",
    "LANGUAGE.SPANISH": "spagnolo",
    "LIST_VIEW.CONSUMPTION_PROFILE": "Profilazione dei consumi",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_FROM": "Data da",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_TO": "Data A",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_TYPE": "Tipo di data",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.awaiting_upload": "In attesa di caricamento",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.completed": "Completato",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.deleted": "Eliminato",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.in_progress": "In corso",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.BUTTON_LABEL": "Personalizza vista",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.DESCRIPTION": "Trascina le intestazioni delle colonne per riorganizzare l'ordine, seleziona/deseleziona per mostrare/nascondere le colonne della tabella.",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.RESET_BUTTON_LABEL": "Ripristina la vista predefinita",
    "LIST_VIEW.CONSUMPTION_PROFILE.FILTER_SECTION": "Filtro",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.address": "Indirizzo",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.collected_by": "Raccolti da",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.company": "Azienda",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.deployed_by": "Distribuito da",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.dma_key": "DMA",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.end_date": "Data di fine",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.end_time": "Ora di fine",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.id": "ID",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.latitude": "Latitudine",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.longitude": "Longitudine",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.partner": "Partner",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.project": "Progetto",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.start_date": "Data di inizio",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.start_time": "Ora di inizio",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.waypoint_id": "ID del waypoint",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.waypoint_name": "Nome del waypoint",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.what3words": "What3Words",
    "LIST_VIEW.CONSUMPTION_PROFILE.NO_DATA": "Nessun dato disponibile",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH_BAR.APPLY.FILTER": "Applica filtri",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH_BAR.RESET": "Reimposta tutti i filtri",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH.PLACEHOLDER": "Ricerca...",
    "LIST_VIEW.CONSUMPTION_PROFILE.TITLE": "Sfoglia tutti i profili di consumo",
    "LIST_VIEW.JOBS": "Lavori",
    "LIST_VIEW.JOBS.HEADERS.address": "Indirizzo",
    "LIST_VIEW.JOBS.HEADERS.agreed_flow_reduction": "Riduzione del Flusso Concordata",
    "LIST_VIEW.JOBS.HEADERS.branch_id": "Progetto",
    "LIST_VIEW.JOBS.HEADERS.client_leak_size_estimate": "Stima della Dimensione della Perdita del Cliente",
    "LIST_VIEW.JOBS.HEADERS.comment": "Commento",
    "LIST_VIEW.JOBS.HEADERS.created_at": "Creato",
    "LIST_VIEW.JOBS.HEADERS.date_raised_externally": "Data sollevata esternamente",
    "LIST_VIEW.JOBS.HEADERS.date_raised_internally": "Data sollevata internamente",
    "LIST_VIEW.JOBS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.JOBS.HEADERS.environmental_notes": "Note Ambientali",
    "LIST_VIEW.JOBS.HEADERS.estimate_leak_size": "Dimensione stimata della perdita",
    "LIST_VIEW.JOBS.HEADERS.id": "ID",
    "LIST_VIEW.JOBS.HEADERS.job_status": "Stato del lavoro",
    "LIST_VIEW.JOBS.HEADERS.last_scheduled_engineer_id": "Ingegnere",
    "LIST_VIEW.JOBS.HEADERS.leak_type": "Codice di lavoro",
    "LIST_VIEW.JOBS.HEADERS.material": "Materiale",
    "LIST_VIEW.JOBS.HEADERS.pipe_diameter": "Dimensioni del tubo",
    "LIST_VIEW.JOBS.HEADERS.pipe_diameter_unit": "Unità di misura del tubo",
    "LIST_VIEW.JOBS.HEADERS.repair_date": "Data di riparazione",
    "LIST_VIEW.JOBS.HEADERS.road_speed": "Velocità Stradale",
    "LIST_VIEW.JOBS.HEADERS.updated_at": "Aggiornato",
    "LIST_VIEW.JOBS.HEADERS.waypoint_id": "Punto di riferimento",
    "LIST_VIEW.JOBS.HEADERS.work_order": "Ordine di lavoro",
    "LIST_VIEW.JOBS.SUMMARY.JOB_TYPE": "Tipo di lavoro",
    "LIST_VIEW.JOBS.SUMMARY.SESSION_TYPE": "Tipo di sessione",
    "LIST_VIEW.JOBS.TITLE": "Visualizza Tutti i Lavori",
    "LIST_VIEW.RELAYS": "Dispositivi di Relay",
    "LIST_VIEW.RELAYS.HEADERS.address": "Indirizzo",
    "LIST_VIEW.RELAYS.HEADERS.bug_id": "Indirizzo MAC",
    "LIST_VIEW.RELAYS.HEADERS.bug_mac": "Indirizzo MAC",
    "LIST_VIEW.RELAYS.HEADERS.company": "Azienda",
    "LIST_VIEW.RELAYS.HEADERS.company_name": "Azienda",
    "LIST_VIEW.RELAYS.HEADERS.create_time": "Ora di creazione",
    "LIST_VIEW.RELAYS.HEADERS.dma_name": "DMA",
    "LIST_VIEW.RELAYS.HEADERS.last_contact": "Ultimo contatto",
    "LIST_VIEW.RELAYS.HEADERS.last_update": "Ultimo caricamento",
    "LIST_VIEW.RELAYS.HEADERS.latitude": "Latitudine",
    "LIST_VIEW.RELAYS.HEADERS.longitude": "Longitudine",
    "LIST_VIEW.RELAYS.HEADERS.partner": "Partner",
    "LIST_VIEW.RELAYS.HEADERS.partner_name": "Partner",
    "LIST_VIEW.RELAYS.HEADERS.project": "Progetto",
    "LIST_VIEW.RELAYS.HEADERS.project_name": "Progetto",
    "LIST_VIEW.RELAYS.HEADERS.relay_id": "ID di Relay",
    "LIST_VIEW.RELAYS.HEADERS.relay_name": "Nome del relè",
    "LIST_VIEW.RELAYS.HEADERS.relay_status": "Stato del relè",
    "LIST_VIEW.RELAYS.HEADERS.relay_uptime": "Tempo di attività del relay",
    "LIST_VIEW.RELAYS.HEADERS.session_id": "Sessione",
    "LIST_VIEW.RELAYS.HEADERS.session_leak_size": "Dimensione prevista dall'IA della sessione",
    "LIST_VIEW.RELAYS.HEADERS.update_time": "Aggiorna ora",
    "LIST_VIEW.RELAYS.HEADERS.what3words": "What3Words",
    "LIST_VIEW.RELAYS.TITLE": "Sfoglia tutti i dispositivi Relay",
    "LIST_VIEW.SELECT_DATA_TYPE.LABEL": "Tipo di dati",
    "LIST_VIEW.SELECT_DATA_TYPE.PLACEHOLDER": "Seleziona il tipo di dati",
    "LIST_VIEW.SESSIONS": "Sessioni",
    "LIST_VIEW.SESSIONS.DATE_FROM": "Data Da",
    "LIST_VIEW.SESSIONS.DATE_TO": "Data fino a",
    "LIST_VIEW.SESSIONS.DATE_TYPE": "Tipo di Data",
    "LIST_VIEW.SESSIONS.DISTINCT.awaiting_upload": "In attesa di caricamento",
    "LIST_VIEW.SESSIONS.DISTINCT.completed": "Completato",
    "LIST_VIEW.SESSIONS.DISTINCT.deleted": "Eliminato",
    "LIST_VIEW.SESSIONS.DISTINCT.in_progress": "In corso",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.BUTTON_LABEL": "Personalizza Vista",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.DESCRIPTION": "Trascina le intestazioni delle colonne per riordinare l'ordine, seleziona/deseleziona per mostrare/nascondere le colonne della tabella.",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.RESET_BUTTON_LABEL": "Reimposta alla vista predefinita",
    "LIST_VIEW.SESSIONS.FILTER_SECTION": "Filtro",
    "LIST_VIEW.SESSIONS.HEADERS.address": "Indirizzo",
    "LIST_VIEW.SESSIONS.HEADERS.asset_id": "Bene",
    "LIST_VIEW.SESSIONS.HEADERS.collected_by": "Raccolto da",
    "LIST_VIEW.SESSIONS.HEADERS.company_id": "Azienda",
    "LIST_VIEW.SESSIONS.HEADERS.created": "Data di creazione",
    "LIST_VIEW.SESSIONS.HEADERS.deployed_by": "Distribuito da",
    "LIST_VIEW.SESSIONS.HEADERS.dma_id": "DMA",
    "LIST_VIEW.SESSIONS.HEADERS.end_time": "Data di fine",
    "LIST_VIEW.SESSIONS.HEADERS.expected_finish": "Fine prevista",
    "LIST_VIEW.SESSIONS.HEADERS.last_update": "Ultimo aggiornamento",
    "LIST_VIEW.SESSIONS.HEADERS.latitude": "Latitudine",
    "LIST_VIEW.SESSIONS.HEADERS.leak_size": "Dimensione prevista",
    "LIST_VIEW.SESSIONS.HEADERS.longitude": "Longitudine",
    "LIST_VIEW.SESSIONS.HEADERS.partner_id": "Partner",
    "LIST_VIEW.SESSIONS.HEADERS.project_id": "Progetto",
    "LIST_VIEW.SESSIONS.HEADERS.relay_connected": "Relè Connesso",
    "LIST_VIEW.SESSIONS.HEADERS.sensor-id": "ID Sensore",
    "LIST_VIEW.SESSIONS.HEADERS.session_id": "ID sessione",
    "LIST_VIEW.SESSIONS.HEADERS.start_time": "Data di inizio",
    "LIST_VIEW.SESSIONS.HEADERS.status_id": "Stato",
    "LIST_VIEW.SESSIONS.HEADERS.type": "Tipo di sessione",
    "LIST_VIEW.SESSIONS.HEADERS.what3words": "W3W",
    "LIST_VIEW.SESSIONS.NO_DATA": "Nessun dato disponibile",
    "LIST_VIEW.SESSIONS.SEARCH_BAR.APPLY.FILTER": "Applica filtri",
    "LIST_VIEW.SESSIONS.SEARCH_BAR.RESET": "Reimposta tutti i filtri",
    "LIST_VIEW.SESSIONS.SEARCH.PLACEHOLDER": "Cerca...",
    "LIST_VIEW.SESSIONS.SUMMARY.LEAK_SIZE": "Dimensione della perdita",
    "LIST_VIEW.SESSIONS.SUMMARY.SESSION_TYPE": "Tipo di sessione",
    "LIST_VIEW.SESSIONS.SUMMARY.TITLE": "Sommario",
    "LIST_VIEW.SESSIONS.SUMMARY.TOOLTIP.DESC": "Per regolare i dati visualizzati qui, utilizza i filtri della tabella sopra.",
    "LIST_VIEW.SESSIONS.SUMMARY.TOOLTIP.TITLE": "Riepilogo dei dati risultanti",
    "LIST_VIEW.SESSIONS.SUMMARY.WAYPOINT_STATUS": "Stato del Waypoint",
    "LIST_VIEW.SESSIONS.TITLE": "Esplora tutte le sessioni",
    "LIST_VIEW.WAYPOINT_LOGS": "Registri dei Punti di Riferimento",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.changed_from_status_name": "Stato precedente",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.changed_to_status_name": "Stato attuale",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.company": "Azienda",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.datetime": "Data di aggiornamento",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.id": "ID",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.notes": "Note",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.partner": "Partner",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.project": "Progetto",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.user_name": "Nome utente",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.waypoint_id": "Punto di riferimento",
    "LIST_VIEW.WAYPOINT_LOGS.TITLE": "Esplora tutti i registri dei waypoint",
    "LIST_VIEW.WAYPOINTS": "Punti di passaggio",
    "LIST_VIEW.WAYPOINTS.HEADERS.address": "Indirizzo",
    "LIST_VIEW.WAYPOINTS.HEADERS.agreed_flow_reduction": "Riduzione del flusso concordata",
    "LIST_VIEW.WAYPOINTS.HEADERS.branch_name": "Progetto",
    "LIST_VIEW.WAYPOINTS.HEADERS.comment": "Commento",
    "LIST_VIEW.WAYPOINTS.HEADERS.company_id": "Azienda",
    "LIST_VIEW.WAYPOINTS.HEADERS.created_at": "Creato il",
    "LIST_VIEW.WAYPOINTS.HEADERS.date_time": "Data di aggiornamento",
    "LIST_VIEW.WAYPOINTS.HEADERS.diameter": "Diametro",
    "LIST_VIEW.WAYPOINTS.HEADERS.diameter_unit": "Unità di diametro",
    "LIST_VIEW.WAYPOINTS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.WAYPOINTS.HEADERS.environmental_notes": "Note ambientali",
    "LIST_VIEW.WAYPOINTS.HEADERS.estimated_size": "Dimensioni stimate",
    "LIST_VIEW.WAYPOINTS.HEADERS.job_type_code": "Codice tipo di lavoro",
    "LIST_VIEW.WAYPOINTS.HEADERS.jobs": "Lavori",
    "LIST_VIEW.WAYPOINTS.HEADERS.last_action_by": "Ultima azione di",
    "LIST_VIEW.WAYPOINTS.HEADERS.last_scheduled_engineer_id": "Ultimo Ingegnere Programmato",
    "LIST_VIEW.WAYPOINTS.HEADERS.latitude": "Latitudine",
    "LIST_VIEW.WAYPOINTS.HEADERS.longitude": "Longitudine",
    "LIST_VIEW.WAYPOINTS.HEADERS.material": "Materiale",
    "LIST_VIEW.WAYPOINTS.HEADERS.name": "Nome",
    "LIST_VIEW.WAYPOINTS.HEADERS.partner_id": "Partner",
    "LIST_VIEW.WAYPOINTS.HEADERS.predicted_leak_type_id": "Tipo di perdita previsto",
    "LIST_VIEW.WAYPOINTS.HEADERS.predicted_size": "Taglia Prevista",
    "LIST_VIEW.WAYPOINTS.HEADERS.sessions": "Sessioni",
    "LIST_VIEW.WAYPOINTS.HEADERS.status_id": "Stato",
    "LIST_VIEW.WAYPOINTS.HEADERS.surface_type": "Tipo di superficie",
    "LIST_VIEW.WAYPOINTS.HEADERS.w3w": "What3Words",
    "LIST_VIEW.WAYPOINTS.TITLE": "Esplora Tutti i Waypoint",
    "LOGIN_PAGE.ENTRA_TITLE": "Accedi al portale",
    "LOGIN_PAGE.ERROR.MSG": "Email o password non corretti",
    "LOGIN_PAGE.FORGOT_PASSWORD": "Ha dimenticato la password?",
    "LOGIN_PAGE.FORM.EMAIL.LABEL": "E-mail",
    "LOGIN_PAGE.FORM.EMAIL.PLACEHOLDER": "Inserisci il tuo indirizzo email",
    "LOGIN_PAGE.FORM.OKTA_SUBMIT": "Accedi con Okta",
    "LOGIN_PAGE.FORM.PASSWORD.LABEL": "Parola d'ordine",
    "LOGIN_PAGE.FORM.PASSWORD.PLACEHOLDER": "Inserisci la tua password",
    "LOGIN_PAGE.FORM.SUBMIT": "Registrazione",
    "LOGIN_PAGE.SIGNING_IN": "Accesso in corso...",
    "LOGIN_PAGE.SIGNING_IN_SUBTITLE": "Se non verrai reindirizzato automaticamente entro pochi secondi, aggiorna la pagina.",
    "LOGIN_PAGE.SUBTITLE": "Inserisci la tua email e password qui sotto",
    "LOGIN_PAGE.TITLE": "Accedi al Pannello di amministrazione",
    "LOGS.ACTION.ASSIGN_DMAs": "Assegnare DMA",
    "LOGS.ACTION.CHANGE DATES": "Cambia date",
    "LOGS.ACTION.Change project 1 dates": "Modifica le date del progetto 1",
    "LOGS.ACTION.CHANGE_DATES": "Cambia date",
    "LOGS.ACTION.CHANGE_PASSWORD": "Cambiare la password",
    "LOGS.ACTION.CREATE PROJECT": "Crea progetto",
    "LOGS.ACTION.CREATE_BRANCH": "Crea ramo",
    "LOGS.ACTION.CREATE_COMPANY": "Crea azienda",
    "LOGS.ACTION.CREATE_MULTI_USER": "Crea più utenti",
    "LOGS.ACTION.CREATE_PARTNER": "Crea partner",
    "LOGS.ACTION.CREATE_PROJECT": "Crea progetto",
    "LOGS.ACTION.CREATE_USER": "Crea utente",
    "LOGS.ACTION.DELETE_BRANCH": "Elimina ramo",
    "LOGS.ACTION.DELETE_COMPANY": "Elimina azienda",
    "LOGS.ACTION.DELETE_DMAs": "Elimina DMA",
    "LOGS.ACTION.DELETE_PARTNER": "Elimina Partner",
    "LOGS.ACTION.DELETE_PROJECT": "Elimina progetto",
    "LOGS.ACTION.DELETE_USER": "Elimina utente",
    "LOGS.ACTION.EDIT_COMPANY": "Modifica azienda",
    "LOGS.ACTION.FORGOT_PASSWORD": "Ha dimenticato la password",
    "LOGS.ACTION.GET_COMPANY": "Ottieni azienda",
    "LOGS.ACTION.LOGIN": "Login",
    "LOGS.ACTION.MODIFY_COMPANY": "Modifica azienda",
    "LOGS.ACTION.MODIFY_PARTNER": "Modifica partner",
    "LOGS.ACTION.MODIFY_USER": "Modifica utente",
    "LOGS.ACTION.REACTIVATE_COMPANY": "Riattivare l'azienda",
    "LOGS.ACTION.REACTIVATE_PARTNER": "Riattiva il partner",
    "LOGS.ACTION.RESTORE_COMPANY": "Ripristinare la società",
    "LOGS.ACTION.SET_PASSWORD": "Imposta password",
    "LOGS.ACTION.TOGGLE OFF RELAY DEVICE": "Disattiva dispositivo relay",
    "LOGS.ACTION.TRIGGER RELAY DEVICE": "Dispositivo di relè di attivazione",
    "LOGS.ACTION.UPDATE WAYPOINT": "Aggiorna waypoint",
    "LOGS.ACTION.UPDATE_BRANCH": "Aggiorna filiale",
    "LOGS.ACTION.UPDATE_LOGGER_SESSION": "Aggiorna sessione del logger",
    "LOGS.DESCRIPTION.ASSIGN_DMAs": "DMA assegnati {{dma_keys}} a {{project_name}}",
    "LOGS.DESCRIPTION.CHANGE_DATES": "Date modificate per {{project_name}}. Data di inizio: {{start_date}}. Data di fine: {{end_date}}",
    "LOGS.DESCRIPTION.COMMON.BY_USER_EMAIL": "tramite {{by_email}}",
    "LOGS.DESCRIPTION.CREATE_BRANCH": "Progetto creato {{project_name}}",
    "LOGS.DESCRIPTION.CREATE_COMPANY": "Creata la società {{company_name}}",
    "LOGS.DESCRIPTION.CREATE_PROJECT": "Progetto creato {{project_name}}",
    "LOGS.DESCRIPTION.CREATE_USER": "Utente creato {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.DELETE_PROJECT": "Progetto eliminato {{project_name}}",
    "LOGS.DESCRIPTION.DELETE_USER": "Utente eliminato {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.MODIFY_COMPANY": "Società modificata {{company_name}}",
    "LOGS.DESCRIPTION.MODIFY_PARTNER": "Partner modificato {{partner_name}}",
    "LOGS.DESCRIPTION.MODIFY_USER": "Utente modificato {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.UPDATE_LOGGER_SESSION": "Sessione del logger aggiornata {{session_id}}",
    "MAP_UNITS.TITLE.COLUMN": "Mappa colonna",
    "MAP_UNITS.TITLE.UNITS": "Valori delle unità mappa",
    "MAP_VIEW.DIALOG.SUBTITLE.CHANGE": "Tutti i filtri verranno eliminati?",
    "MAP_VIEW.DIALOG.SUBTITLE.CLOSE": "Le modifiche verranno eliminate",
    "MAP_VIEW.DIALOG.TITLE.CHANGE": "Sei sicuro di voler cambiare l'origine dati?",
    "MAP_VIEW.DIALOG.TITLE.CLOSE": "Sei sicuro di voler chiudere le impostazioni?",
    "MAP_VIEW.FILTERS.BUTTONTITLE": "Opzioni mappa",
    "MAP_VIEW.FILTERS.SUBMIT": "Invia",
    "MAP_VIEW.FILTERS.TITLES.ASSETS": "Risorse",
    "MAP_VIEW.FILTERS.TITLES.AWAITING_UPLOAD_SESSION": "In attesa della sessione di caricamento",
    "MAP_VIEW.FILTERS.TITLES.DELETED_SESSION": "Sessione Eliminata",
    "MAP_VIEW.FILTERS.TITLES.DMAS": "DMA",
    "MAP_VIEW.FILTERS.TITLES.IN_PROGRESS_SESSION": "Sessione in corso",
    "MAP_VIEW.FILTERS.TITLES.INVESTIGATION_SESSION": "Sessione investigativa",
    "MAP_VIEW.FILTERS.TITLES.LARGE_LEAK_SESSION": "Sessione di Grande Perdita",
    "MAP_VIEW.FILTERS.TITLES.MEDIUM_LEAK_SESSION": "Sessione di perdita media",
    "MAP_VIEW.FILTERS.TITLES.NON_LEAK_SESSION": "Sessione Non Perdente",
    "MAP_VIEW.FILTERS.TITLES.ODL": "ODL",
    "MAP_VIEW.FILTERS.TITLES.PIPES": "Tubi",
    "MAP_VIEW.FILTERS.TITLES.SMALL_LEAK_SESSION": "Sessione di piccola perdita",
    "MAP_VIEW.FILTERS.TITLES.WAYPOINTS": "Waypoint",
    "MAP_VIEW.FORM.SOURCE.LABEL": "Fonte di dati",
    "MAP_VIEW.FORM.SOURCE.PLACEHOLDER": "Seleziona Origine dati",
    "MAP_VIEW.LOADING": "Caricamento della mappa",
    "MAP_VIEW.MODAL_TITLE": "Impostazioni",
    "MAP.HUD.FETCH_BOUNDARIES": "Limiti di recupero",
    "MAP.HUD.LAT": "Latitudine:",
    "MAP.HUD.LNG": "Lng:",
    "MAP.HUD.SOURCES": "Fonti:",
    "MAP.HUD.TOGGLE_FETCH_BOUNDARY_VISUALIZATION": "Attiva/disattiva la visualizzazione del limite di recupero",
    "MAP.HUD.ZOOM_IN_TO_LOAD": "Ingrandisci per caricare",
    "MAP.STYLE.SATELLITE": "Vista satellitare",
    "MAP.STYLE.STREET": "Vista stradale",
    "MEASUREMENT_TYPE.IMPERIAL": "Imperiale",
    "MEASUREMENT_TYPE.METRIC": "Metriaco",
    "MERGE_WAYPOINT.FORM.SUBMIT": "Invia",
    "MERGE_WAYPOINT.FORM.SUCCESS": "Waypoint uniti con successo",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.LABEL": "Unisci il waypoint selezionato al waypoint corrente",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.LABEL_SHORT": "Punto di passaggio",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.PLACEHOLDER": "Seleziona un Punto di passaggio",
    "MERGE_WAYPOINT.INPUT.NOTES.LABEL": "Note",
    "MERGE_WAYPOINT.INPUT.NOTES.PLACEHOLDER": "Inserisci Note",
    "MERGE_WAYPOINT.NO_DATA": "Nessun waypoint disponibile per unire",
    "METRIC_WIDGET.DESCRIPTION": "al giorno",
    "METRIC_WIDGET.TITLE_A": "IA Identificata",
    "METRIC_WIDGET.TITLE_B": "Per Riparazione",
    "METRIC_WIDGET.TITLE_C": "Consegnato",
    "NOT_FOUND_PAGE.ACTION.GO_HOME": "Portami a casa",
    "NOT_FOUND_PAGE.DESCRIPTION": "Ops! La pagina che stai cercando sembra essersi persa nel vuoto digitale. Non preoccuparti, capita anche ai migliori.",
    "NOT_FOUND_PAGE.TITLE": "Pagina non trovata",
    "PIE_CHART.SUMMARY_DETAILS": "Dettagli del riepilogo",
    "PIE_CHART.SUMMARY_TOTAL": "Risultati totali",
    "PROCESS_FILES.BUTTON.DISCARD": "Scarta",
    "PROCESS_FILES.BUTTON.NEXT": "Avanti",
    "PROCESS_FILES.BUTTON.PREVIOUS": "Precedente",
    "PROCESS_FILES.BUTTON.RESET": "Reimposta",
    "PROCESS_FILES.COLUMNS_SELECT": "Colonne richieste ancora da selezionare",
    "PROCESS_FILES.COLUMNS_SELECTED": "tutte le colonne selezionate",
    "PROCESS_FILES.DESC.DIAMETER": "Si prega di selezionare: un'unità che corrisponda ai valori del diametro OPPURE una colonna per mappare i valori dell'unità",
    "PROCESS_FILES.ERROR.INSUFFICIENT_COLUMNS": "Non ci sono colonne sufficienti per mappare i dati forniti. Per continuare, si prega di scartare o caricare un nuovo file.",
    "PROCESS_FILES.ERROR.NO_FILE_TO_MAP": "Nessun file da mappare per {{type}} si prega di proseguire cliccando su successivo",
    "PROCESS_FILES.ERROR.SELECT_ALL": "Seleziona tutte le colonne",
    "PROCESS_FILES.FILENAME": "Nome del file",
    "PROCESS_FILES.INSTRUCTIONS": "Si prega di mappare le colonne con le intestazioni suggerite nei menu a discesa. Solo una colonna può essere mappata su un'intestazione.",
    "PROCESS_FILES.MAP_FIELD_TITLE": "Mappa il campo {{title}}",
    "PROCESS_FILES.OPTION_COLUMNS_SELECT": "Colonne opzionali ancora da selezionare",
    "PROCESS_FILES.OPTIONAL_COLUMNS_SELECTED": "Tutte le colonne opzionali sono state selezionate",
    "PROCESS_FILES.TITLE.DIAMETER": "Campo Diametro mappa",
    "PROFILE_PAGE.BRANCH": "Progetto:",
    "PROFILE_PAGE.COMPANY": "Azienda:",
    "PROFILE_PAGE.COMPANY_ADDRESS": "Indirizzo:",
    "PROFILE_PAGE.COMPANY_NAME": "Nome:",
    "PROFILE_PAGE.DISCARD": "Scartare",
    "PROFILE_PAGE.EDIT": "Modificare",
    "PROFILE_PAGE.EMAIL": "E-mail:",
    "PROFILE_PAGE.ERROR.FAILED_LOADING_USER_DATA": "Errore durante il caricamento dei dati utente.",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.BAD_AUTH": "Password Inserita Errata",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.ERROR": "Password attuale errata",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.LOADING": "Caricamento",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.SUBMIT": "Invia Nuova Password",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.SUCCESS": "Successo! La tua password è stata modificata.",
    "PROFILE_PAGE.FORM.EMAIL.LABEL": "E-mail",
    "PROFILE_PAGE.FORM.EMAIL.PLACEHOLDER": "Inserisci l'email",
    "PROFILE_PAGE.FORM.FIRST_NAME.LABEL": "Nome di battesimo",
    "PROFILE_PAGE.FORM.FIRST_NAME.PLACEHOLDER": "Inserisci il nome",
    "PROFILE_PAGE.FORM.LAST_NAME.LABEL": "Cognome",
    "PROFILE_PAGE.FORM.LAST_NAME.PLACEHOLDER": "Inserisci Cognome",
    "PROFILE_PAGE.FORM.MEASUREMENT_TYPE.LABEL": "Tipo di Misurazione",
    "PROFILE_PAGE.FORM.MEASUREMENT_TYPE.PLACEHOLDER": "Seleziona un tipo di misurazione",
    "PROFILE_PAGE.FORM.NEW_PASSWORD.LABEL": "Nuova password",
    "PROFILE_PAGE.FORM.NEW_PASSWORD.PLACEHOLDER": "Inserisci nuova password",
    "PROFILE_PAGE.FORM.PASSWORD.LABEL": "Password",
    "PROFILE_PAGE.FORM.PASSWORD.PLACEHOLDER": "Inserisci la password",
    "PROFILE_PAGE.ROLE": "Ruolo:",
    "PROFILE_PAGE.SUBMIT": "Salva",
    "PROFILE_PAGE.TABS.ACCOUNT_SETTINGS": "Impostazioni dell'account",
    "PROFILE_PAGE.TABS.CHANGE_PASSWORD": "Cambia Password",
    "PROFILE_PAGE.TABS.COMPANY_SETTINGS": "Impostazioni dell'azienda",
    "PROFILE_PAGE.TABS.DOCUMENTS": "Documenti",
    "PROFILE_PAGE.TITLE": "Modifica Profilo",
    "PROJECT_ADMIN.TITLE": "Amministratore del progetto",
    "PROJECT_CREATE.ERROR.PROJECT_CREATION": "Qualcosa è andato storto: impossibile creare il progetto",
    "PROJECT_CREATE.FOOTER.CREATE_DRAFT": "Crea una bozza",
    "PROJECT_CREATE.SUCCESS.DESCRIPTION_1": "Puoi accedervi nella sezione \"Visualizza progetti\".",
    "PROJECT_CREATE.SUCCESS.DESCRIPTION_2": "Prima di inviarlo per l'approvazione, aggiungi tutti i dettagli richiesti.",
    "PROJECT_CREATE.SUCCESS.LINK_PROJECT": "Aggiungi dettagli",
    "PROJECT_CREATE.SUCCESS.LINK_PROJECTS": "Visualizza i progetti",
    "PROJECT_CREATE.SUCCESS.TITLE": "È stata creata una bozza di progetto",
    "PROJECT_STATUS.INCOMPLETE_PROJECT_SETUP": "L'impostazione del progetto è incompleta",
    "PROJECT_STATUS.SUMMARY.TITLES.CONFIRMEDLEAKS": "N. di perdite confermate",
    "PROJECT_STATUS.SUMMARY.TITLES.LEAKSMARKEDUP": "N. di perdite contrassegnate",
    "PROJECT_STATUS.SUMMARY.TITLES.SESSIONS": "N. di sessioni",
    "PROJECT_STATUS.SUMMARY.TITLES.WAYPOINTS": "N. di waypoint",
    "PROJECT_STATUS.TITLE": "Stato del progetto",
    "PROJECT_UPDATE.DELETE_DIALOG.BUTTON_CANCEL": "Cancellare",
    "PROJECT_UPDATE.DELETE_DIALOG.BUTTON_CONFIRM": "Conferma l'eliminazione della bozza",
    "PROJECT_UPDATE.DELETE_DIALOG.DESCRIPTION": "Sei sicuro di voler eliminare questa bozza?",
    "PROJECT_UPDATE.DELETE_DIALOG.TITLE": "Elimina bozza",
    "PROJECT_UPDATE.DELETE_DRAFT": "Elimina bozza",
    "PROJECT_UPDATE.DELETE_PROJECT": "Elimina progetto",
    "PROJECT_UPDATE.ERROR.DELETE_DRAFT": "Qualcosa è andato storto: impossibile eliminare la bozza",
    "PROJECT_UPDATE.ERROR.PROJECT_DRAFT": "Qualcosa è andato storto: impossibile salvare la bozza",
    "PROJECT_UPDATE.ERROR.PROJECT_STATUS_UPDATE": "Qualcosa è andato storto: impossibile aggiornare lo stato del progetto",
    "PROJECT_UPDATE.ERROR.PROJECT_UPDATE": "Qualcosa è andato storto: impossibile aggiornare il progetto",
    "PROJECT_UPDATE.FOOTER.CONTINUE": "Continuare",
    "PROJECT_UPDATE.FOOTER.DONE": "Fatto",
    "PROJECT_UPDATE.FOOTER.PREVIOUS": "Precedente",
    "PROJECT_UPDATE.FOOTER.SAVE_DRAFT": "Salva bozza",
    "PROJECT_UPDATE.FOOTER.SUBMIT": "Invia",
    "PROJECT_UPDATE.SUCCESS.DRAFT_DELETED": "Bozza eliminata",
    "PROJECT_UPDATE.SUCCESS.PROJECT_DRAFT": "Bozza del progetto salvata",
    "PROJECT_UPDATE.SUCCESS.PROJECT_STATUS_UPDATE": "Stato del progetto aggiornato",
    "PROJECT_UPDATE.SUCCESS.PROJECT_UPDATE": "Progetto aggiornato",
    "PROJECT_UPDATE.TITLE_EDIT": "Modifica progetto",
    "PROJECT_UPDATE.TITLE_VIEW": "Visualizza progetto",
    "PROJECT.FORM.ERROR.MAP_PREVIEW_GENERAL": "Errore durante il caricamento della mappa",
    "PROJECT.FORM.ERROR.MAP_PREVIEW_NO_GIS": "Nessun GIS trovato.",
    "PROJECT.FORM.ERROR.ODL_LOADING": "Errore durante il caricamento degli ODL",
    "PROJECT.FORM.GIS_DATA.DESCRIPTION": "Carica nuovi dati GIS o selezionane uno esistente",
    "PROJECT.FORM.GIS_DATA.EXISTING_GIS_UPLOADS": "Caricamenti GIS esistenti",
    "PROJECT.FORM.GIS_DATA.TITLE": "Dati GIS",
    "PROJECT.FORM.GIS_DATA.UPLOAD_ALTERNATIVE": "o scegline uno esistente",
    "PROJECT.FORM.GIS_DATA.UPLOAD_NEW_GIS": "Carica nuovo GIS",
    "PROJECT.FORM.LABEL.COMPANY": "Azienda",
    "PROJECT.FORM.LABEL.COST_PER_DISTANCE": "Costo per distanza ($)",
    "PROJECT.FORM.LABEL.DEPLOYMENT_DENSITY": "Densità di distribuzione",
    "PROJECT.FORM.LABEL.DEPLOYMENT_DENSITY_LEVEL": "Livello {{level}}",
    "PROJECT.FORM.LABEL.DMA": "DMA",
    "PROJECT.FORM.LABEL.DMAS_LOADING": "Caricamento DMA in corso...",
    "PROJECT.FORM.LABEL.EMPTY_GIS_PREVIEW ": "Nessun GIS caricato",
    "PROJECT.FORM.LABEL.END_DATE": "Data di fine",
    "PROJECT.FORM.LABEL.GIS_PREVIEW": "Anteprima GIS",
    "PROJECT.FORM.LABEL.LEAK_RADIUS": "Raggio di perdita",
    "PROJECT.FORM.LABEL.LEAK_RADIUS_DESCRIPTION": "Regola il raggio di perdita per controllare la visibilità dell'ODL sulla mappa. Le modifiche vengono applicate quando rilasci il cursore.",
    "PROJECT.FORM.LABEL.ODLS_GENERATING": "Generazione di ODL...",
    "PROJECT.FORM.LABEL.PARTNER_OR_SELF_SERVE": "Partner o self-service",
    "PROJECT.FORM.LABEL.PROJECT_NAME": "Nome del progetto",
    "PROJECT.FORM.LABEL.SELF_SERVE_PROJECT": "Progetto self-service",
    "PROJECT.FORM.LABEL.START_DATE": "Data di inizio",
    "PROJECT.FORM.LABEL.TARGET_DISTANCE": "Distanza del bersaglio",
    "PROJECT.FORM.LABEL.TARGET_LEAKAGE": "Perdita di destinazione",
    "PROJECT.FORM.LABEL.WAITING_FOR_ODL": "In attesa della generazione ODL...",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_1": "Distribuzione sparsa: potrebbe trattarsi di un'area prevalentemente metallica o di un budget ridotto in cui non è necessario coprire ogni centimetro,",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_2": "Distribuzione standard: questa è la nostra raccomandazione standard per bilanciare i costi del progetto e coprire un'area che è un mix di metallo e plastica.",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_3": "Copertura completa: questa opzione potrebbe essere utilizzata se si dispone di una rete di plastica molto complessa con numerose giunzioni per garantire una copertura completa garantita, con un elevato consumo di sensori.",
    "PROJECT.FORM.OPTIONS.NO_MATCHING": "Nessun DMA corrispondente",
    "PROJECT.FORM.PLACEHOLDER.DMA": "Seleziona DMA",
    "PROJECT.FORM.PLACEHOLDER.END_DATE": "Scegli una data",
    "PROJECT.FORM.PLACEHOLDER.START_DATE": "Scegli una data",
    "PROJECT.REJECT_DIALOG.BUTTON_REJECT.DEFINITELY": "Rifiutare definitivamente il progetto",
    "PROJECT.REJECT_DIALOG.BUTTON_REJECT.WITH_NOTES": "Rifiuta progetto con note",
    "PROJECT.REJECT_DIALOG.DEFINITELY.DESCRIPTION": "Questa azione eliminerà il progetto.",
    "PROJECT.REJECT_DIALOG.DEFINITELY.TITLE": "Rifiutare definitivamente il progetto",
    "PROJECT.REJECT_DIALOG.FORM.NOTES.LABEL": "Note",
    "PROJECT.REJECT_DIALOG.FORM.NOTES.PLACEHOLDER": "Aggiungi le tue note",
    "PROJECT.REJECT_DIALOG.OR": "O",
    "PROJECT.REJECT_DIALOG.WITH_NOTES.DESCRIPTION": "Il progetto verrà restituito all'utente che lo ha inviato. L'utente potrà modificarlo e inviarlo nuovamente, oppure eliminarlo.",
    "PROJECT.REJECT_DIALOG.WITH_NOTES.TITLE": "Rifiuta il progetto con note",
    "PROJECT.TOAST.DMA.ERROR": "Errore durante il caricamento dei dati DMA.",
    "PROJECT.TOAST.DMA.LOADING": "Caricamento dati DMA in corso...",
    "PROJECT.TOAST.DMA.SUCCESS": "Dati DMA caricati correttamente.",
    "PROJECT.TOAST.ODL.ERROR": "Errore durante la generazione di ODL.",
    "PROJECT.TOAST.ODL.LOADING": "Generazione di ODL...",
    "PROJECT.TOAST.ODL.PENDING": "Generazione ODL in sospeso...",
    "PROJECT.TOAST.ODL.SUCCESS": "ODL generati correttamente.",
    "PROJECT.VIEW_REJECTION_NOTES.BUTTON_CLOSE": "Fatto",
    "PROJECT.VIEW_REJECTION_NOTES.FORM.LABEL.NOTES": "Note dell'amministratore",
    "PROJECT.VIEW_REJECTION_NOTES.FORM.PLACEHOLDER.NOTES": "Note lasciate dall'amministratore",
    "PROJECT.VIEW_REJECTION_NOTES.TITLE": "Il progetto è stato rifiutato da un amministratore",
    "PROJECTS.LOADING_PROJECT_INFO": "Caricamento informazioni sul progetto...",
    "RECOVERY_EXPIRED_PAGE.SUBTITLE": "Il tuo link non è più attivo",
    "RECOVERY_EXPIRED_PAGE.TITLE": "Recupero della password",
    "RECOVERY_PASSWORD_PAGE.FORM.EMAIL.LABEL": "E-mail",
    "RECOVERY_PASSWORD_PAGE.FORM.EMAIL.PLACEHOLDER": "Inserisci il tuo indirizzo email",
    "RECOVERY_PASSWORD_PAGE.FORM.PASSWORD.LABEL": "Parola d'ordine",
    "RECOVERY_PASSWORD_PAGE.FORM.PASSWORD.PLACEHOLDER": "Inserisci la tua password",
    "RECOVERY_PASSWORD_PAGE.FORM.REPEAT_PASSWORD.LABEL": "Ripeti la password",
    "RECOVERY_PASSWORD_PAGE.FORM.REPEAT_PASSWORD.PLACEHOLDER": "Ripeti la password",
    "RECOVERY_PASSWORD_PAGE.FORM.SUBMIT": "Recuperare",
    "RECOVERY_PASSWORD_PAGE.SUBTITLE": "Inserisci la tua password qui sotto",
    "RECOVERY_PASSWORD_PAGE.TITLE": "Recupero della password",
    "REPORT_BUILDER.APPLY": "Fare domanda a",
    "REPORT_BUILDER.BACK": "Indietro",
    "REPORT_BUILDER.EXPORT_TO_PDF": "Esporta in PDF",
    "REPORT_BUILDER.RUN": "Correre",
    "REPORT_BUILDER.SAVE": "Salva",
    "REPORT_BUILDER.SORT_MODE": "Modalità di ordinamento",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.ASSET_LEAK": "Perdita di beni",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CLIENT_METER_PRV_LEAK": "Perdita del contatore del cliente/PRV",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.COMM_PIPE_LEAK": "Perdita del tubo di comunicazione",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CUSTOMER_METER_LEAK": "Perdita del contatore del cliente",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CUSTOMER_SIDE_LEAK": "Perdita lato cliente",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.FERRULE_LEAK": "Perdita della ghiera",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.MAINS_LEAK": "Perdita di rete",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.NA": "N / A",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.NETWORK_MAINTENANCE": "Manutenzione della rete",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.RENEW_STOP_TAP_MSM": "Rinnovare il rubinetto di arresto/MSM",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.REPAIR": "Riparazione",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.RESOLVED_ONSITE": "Risolto in loco",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.ASSET_LEAK": "Perdita di beni",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CLIENT_METER_PRV_LEAK": "Perdita del contatore del cliente/PRV",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.COMMERCIAL_REPAIR": "Riparazione commerciale",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.COMMUNICATION_PIPE": "Tubo di comunicazione",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CSL": "CSL",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CUSTOMER_METER_LEAK": "Perdita del contatore del cliente",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CUSTOMER_SIDE_LEAK": "Perdita lato cliente",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.DECOMMISSION_FERRULE": "Ghiera di dismissione",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXCAVATE_TRIAL_HOLE_PERMIT": "Scavo di un foro di prova (permesso)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_INC_EXC": "Misuratore di perdite esterne>40 mm Inc. Escl.",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_NO_EXC": "Misuratore di perdite esterne>40 mm Nessuna eccezione",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_INC_EXC": "Misuratore di perdite esterne <40 mm Inc Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_NO_EXC": "Misuratore di perdite esterne <40 mm No Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FERRULE": "Ghiera",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FERRULE_EXCHANGE_NO_5": "Scambio di ghiere n. 5",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FH_STOPPED_ON_SITE": "F/H fermato sul posto",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FIRE_HYDRANT": "Idrante antincendio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FIRE_MAIN": "Fuoco principale",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_NO_EXC": "Prova di flusso al confine No Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_WITH_EXC": "Prova di flusso al confine con Ecc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INST_MSM_TO_EXIST_COMM_PIPE_UNMTRD": "Installare MSM per esistere Comm Pipe UnMtrd",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_FERRULE_ONLY": "Installare solo la ghiera",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_MSM_INC_METER": "Installa il contatore MSM Inc.",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_SAMPLE_TAP": "Installa il rubinetto campione",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_SLUICE_VALVE": "Installare la valvola di intercettazione",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_WASHOUT_HYDRANT": "Installare l'idrante di lavaggio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_FIXED_ONSITE": "Perdita riparata in loco",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_FH": "Perdita su F/H",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV": "Perdita sul fuso della SV",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV_FLANGE": "Perdita sul mandrino della SV/flangia.",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS": "Rete principale",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS_BURST": "Scoppio della rete elettrica",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS_LEAK": "Perdita di rete",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.NA_WO_STOPPED_ON_SITE": "N/A - W/O fermato sul posto",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.NETWORK_MAINTENANCE": "Manutenzione della rete",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.OSV_EXCHANGE": "Scambio OSV",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.OTHER": "Altro",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.PASSING_FH": "Superamento FH",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.PASSING_HYDRANT": "Idrante di passaggio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REMEDIAL_WORK_EXTERNAL": "Lavori di ripristino esterni",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REMOVE_SLUICE_VAVLE": "Rimuovere la valvola di scarico",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COMMUNICATION_PIPE_LONGSIDE": "Rinnovare il tubo di comunicazione laterale",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COMMUNICATION_PIPE_SHORTSIDE": "Rinnovare il canale di comunicazione corto",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COVER_AND_FRAME_STANDARD": "Rinnova copertura e telaio (standard)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FERRULE_ONLY": "Rinnovare solo la ghiera",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT": "Rinnovare l'idrante antincendio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT_CHAMBER": "Rinnovare la camera dell'idrante antincendio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT_FRAME_AND_COVER": "Rinnovare il telaio e la copertura dell'idrante antincendio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_GT_10M": "Sostituire il tubo di alimentazione che perde >10 m",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_LT_10M": "Sostituire il tubo di alimentazione che perde <10 m",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_MSM_STOP_TAP_ASSEMBLY": "Rinnovare il gruppo rubinetto MSM/Stop",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_SLUICE_VAVLE": "Rinnovare la valvola di chiusura",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_WASHOUT_HYDRANT": "Rinnovare l'idrante di lavaggio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPACK_SLUICE_VALVE": "Riconfezionamento della valvola a saracinesca",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_COMMUNICATION_PIPE": "Riparazione del tubo di comunicazione",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_EXTERNAL_LSP_NON_ELIGIBLE": "Riparazione LSP esterno - Non idoneo",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_INTERNAL_LEAK_RECH": "Riparazione perdite interne (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LEAKING_SUPPLY_PIPE_RECH": "Riparazione perdite del tubo di alimentazione (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LOP": "Riparazione LOP",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LSP_ELIGIBLE": "Riparazione LSP - Idoneo",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_GTE_200MM": "Riparazione del tassello principale >=200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_LT_200MM": "Riparazione del tassello principale <200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_GTE_200MM": "Riparazione principale [non tassello] >=200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_LT_200MM": "Riparazione principale [non tassello] <200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAJOR_BURST": "Riparazione scoppi importanti",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_NON_RETURN_VALVE": "Riparazione valvola di non ritorno",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_RUNNING_OVERFLOW_RECH": "Riparazione del sovraccarico in esecuzione (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_SLUICE_VALVE": "Riparazione della valvola a saracinesca",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPOSITION_MSM_STOP_TAP_ASSEMBLY": "Riposizionare il gruppo rubinetto MSM/Stop",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RESET_SURFACE_BOX_STANDARD": "Ripristina Surface Box (Standard)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SERVICE_LEAK": "Perdita di servizio",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SLUICE_VALVE": "Valvola a saracinesca",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SLUICE_VALVE_VL": "Valvola a saracinesca (VL)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_EXCHANGE": "Interrompere lo scambio di rubinetti",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_LEAK": "Fermare la perdita del rubinetto",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_LEAK_NO_7": "Tap Leak Stop n. 7",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.WO_FH": "WO / FH",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK.LEAK": "Perdere",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK.NO_LEAK": "Nessuna perdita",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE": "Dimensione prevista",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.LARGE": "Grande",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.MEDIUM": "medio",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.SMALL": "Piccolo",
    "REPORT.FILTERS.DROPDOWN.STATUS": "Stato",
    "REPORT.FILTERS.DROPDOWN.STATUS.1": "Fuga",
    "REPORT.FILTERS.DROPDOWN.STATUS.10": "Inprogress ST (Breakout)",
    "REPORT.FILTERS.DROPDOWN.STATUS.11": "Perdita Conosciuta",
    "REPORT.FILTERS.DROPDOWN.STATUS.12": "Perdita Inviata al Cliente",
    "REPORT.FILTERS.DROPDOWN.STATUS.13": "Evidenziato",
    "REPORT.FILTERS.DROPDOWN.STATUS.14": "Proposto",
    "REPORT.FILTERS.DROPDOWN.STATUS.15": "Riparazione Programmata",
    "REPORT.FILTERS.DROPDOWN.STATUS.16": "Riparato",
    "REPORT.FILTERS.DROPDOWN.STATUS.17": "Giorni Pianificati",
    "REPORT.FILTERS.DROPDOWN.STATUS.18": "Notti Prenotate",
    "REPORT.FILTERS.DROPDOWN.STATUS.19": "Sorgente di Rumore Non Confermata",
    "REPORT.FILTERS.DROPDOWN.STATUS.2": "Sorgente di Rumore Confermata",
    "REPORT.FILTERS.DROPDOWN.STATUS.20": "Convalidato",
    "REPORT.FILTERS.DROPDOWN.STATUS.3": "Raccolta dati",
    "REPORT.FILTERS.DROPDOWN.STATUS.4": "Eliminato",
    "REPORT.FILTERS.DROPDOWN.STATUS.5": "Scavo a Secco",
    "REPORT.FILTERS.DROPDOWN.STATUS.6": "Modificato",
    "REPORT.FILTERS.DROPDOWN.STATUS.7": "Ulteriore Lavoro Richiesto",
    "REPORT.FILTERS.DROPDOWN.STATUS.8": "In corso",
    "REPORT.FILTERS.DROPDOWN.STATUS.9": "Inprogress LE (Breakout)",
    "REPORT.FILTERS.DROPDOWN.STATUS.AWAITING_SCHEDULING": "In attesa di programmazione",
    "REPORT.FILTERS.DROPDOWN.STATUS.AWAITINGSCHEDULING": "In attesa di programmazione",
    "REPORT.FILTERS.DROPDOWN.STATUS.CLOSED": "Chiuso",
    "REPORT.FILTERS.DROPDOWN.STATUS.CONFIRMED_NOISE_SOURCE": "Sorgente di rumore confermata",
    "REPORT.FILTERS.DROPDOWN.STATUS.CONFIRMEDNOISESOURCE": "Sorgente di rumore confermata",
    "REPORT.FILTERS.DROPDOWN.STATUS.DRY_DIG": "Scavare a secco",
    "REPORT.FILTERS.DROPDOWN.STATUS.DRYDIG": "Scavare a secco",
    "REPORT.FILTERS.DROPDOWN.STATUS.EDITED": "Modificato",
    "REPORT.FILTERS.DROPDOWN.STATUS.FURTHER_WORK_REQUESTED": "Ulteriore lavoro richiesto",
    "REPORT.FILTERS.DROPDOWN.STATUS.FURTHERWORKREQUESTED": "Ulteriore lavoro richiesto",
    "REPORT.FILTERS.DROPDOWN.STATUS.LEAK_SUBMITTED_TO_CLIENT": "Perdita inviata al cliente",
    "REPORT.FILTERS.DROPDOWN.STATUS.LEAKSUBMITTEDTOCLIENT": "Perdita inviata al cliente",
    "REPORT.FILTERS.DROPDOWN.STATUS.MARKED_UP": "Contrassegnato",
    "REPORT.FILTERS.DROPDOWN.STATUS.MARKEDUP": "Contrassegnato",
    "REPORT.FILTERS.DROPDOWN.STATUS.PROPOSED": "Proposto",
    "REPORT.FILTERS.DROPDOWN.STATUS.REPAIRED": "Riparato",
    "REPORT.FILTERS.DROPDOWN.STATUS.SCHEDULED": "Programmato",
    "REPORT.FILTERS.DROPDOWN.STATUS.SCHEDULING": "Programmazione",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMED": "Non confermato",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMED_NOISE_SOURCE": "Fonte di rumore non confermata",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMEDNOISESOURCE": "Fonte di rumore non confermata",
    "REPORT.FILTERS.FILTER.BUTTON": "Filtri",
    "REPORT.FILTERS.SAVE.BUTTON": "Salva vista",
    "REPORTS_PAGE.CREATE_REPORT.BUTTON": "Crea rapporto",
    "REPORTS_PAGE.CREATE_REPORT.FORM.CHOOSE_LAYOUT.LABEL": "Scegli Disposizione",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REDIRECT_TO_EDIT": "Modifica rapporto",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REPORT_NAME.LABEL": "Nome rapporto",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REPORT_NAME.PLACEHOLDER": "Immettere il nome del rapporto",
    "REPORTS_PAGE.CREATE_REPORT.FORM.SUBMIT": "Crea rapporto",
    "REPORTS_PAGE.CREATE_REPORT.TITLE": "Crea nuovo rapporto",
    "REPORTS_PAGE.CRUMB": "Rapporti",
    "REPORTS_PAGE.SUBTITLE": "Rapporti sui risultati della scansione FIDO",
    "REPORTS_PAGE.TABLE.ACTIONS": "Azioni",
    "REPORTS_PAGE.TABLE.CREATED": "Creato",
    "REPORTS_PAGE.TABLE.NUMBER": "#",
    "REPORTS_PAGE.TABLE.REPORT_NAME": "Nome rapporto",
    "REPORTS_PAGE.TITLE.NO_REPORTS": "Non ci sono segnalazioni",
    "REPORTS_PAGE.TITLE.TOTAL_COUNT": "Report totali:",
    "REQUEST.FAILED": "Fallito",
    "REQUEST.SUCCESS": "Successo",
    "SERVER_ERRORS.-1": "Qualcosa è andato storto",
    "SERVER_ERRORS.1": "Errore di connessione al database",
    "SERVER_ERRORS.10": "Errore file vuoto",
    "SERVER_ERRORS.11": "Errore di autenticazione",
    "SERVER_ERRORS.12": "Errore di autenticazione",
    "SERVER_ERRORS.13": "Errore di autenticazione",
    "SERVER_ERRORS.14": "Errore di autenticazione",
    "SERVER_ERRORS.15": "Errore di autenticazione",
    "SERVER_ERRORS.16": "L'utente con l'indirizzo email fornito non è stato trovato",
    "SERVER_ERRORS.17": "L'e-mail o la password non sono corrette",
    "SERVER_ERRORS.18": "Il token e-mail non è valido",
    "SERVER_ERRORS.19": "Permesso negato",
    "SERVER_ERRORS.2": "Qualcosa è andato storto",
    "SERVER_ERRORS.21": "Utente non trovato",
    "SERVER_ERRORS.22": "Ruolo non trovato",
    "SERVER_ERRORS.23": "Azienda non trovata",
    "SERVER_ERRORS.24": "Progetto non trovato",
    "SERVER_ERRORS.25": "Permesso negato",
    "SERVER_ERRORS.26": "Permesso negato",
    "SERVER_ERRORS.27": "Dati del file non validi",
    "SERVER_ERRORS.28": "questa email esiste già",
    "SERVER_ERRORS.3": "Richiesta non valida",
    "SERVER_ERRORS.31": "Azienda non trovata",
    "SERVER_ERRORS.32": "Il nome dell'azienda non è valido o esiste già",
    "SERVER_ERRORS.4": "Formato file non valido",
    "SERVER_ERRORS.41": "Azienda non trovata",
    "SERVER_ERRORS.5": "Non autorizzato",
    "SERVER_ERRORS.6": "Risorsa non trovata",
    "SERVER_ERRORS.61": "Metodo non consentito",
    "SERVER_ERRORS.62": "Chiamata API non riuscita",
    "SERVER_ERRORS.63": "Tipo di geometria non valido",
    "SERVER_ERRORS.65": "Il progetto si sovrappone ai progetti esistenti {{ projectNames }} e alle DMA {{ dmaKeys }}",
    "SERVER_ERRORS.7": "Servizio non disponibile",
    "SERVER_ERRORS.8": "Errore di archiviazione Azure",
    "SERVER_ERRORS.9": "Formato geojson non valido",
    "SERVER_SUCCESS.ADD_COMPANY": "Società creata con successo",
    "SERVER_SUCCESS.CREATE_BRANCH": "Progetto creato con successo",
    "SERVER_SUCCESS.CREATE_USER": "Utente creato con successo",
    "SERVER_SUCCESS.EDIT_COMPANY": "Azienda aggiornata con successo",
    "SERVER_SUCCESS.EDIT_USER": "Utente aggiornato con successo",
    "SERVER_SUCCESS.FORGOT_PASSWORD": "Link di recupero inviato con successo",
    "SERVER_SUCCESS.LOGIN": "L'accesso è andato a buon fine",
    "SERVER_SUCCESS.LOGOUT": "Il logout ha avuto successo",
    "SERVER_SUCCESS.RECOVERY": "Il recupero è andato a buon fine",
    "SERVER_SUCCESS.UPDATE_BRANCH": "Progetto aggiornato con successo",
    "SERVER_SUCCESS.UPDATE_REPORT": "Il rapporto è stato aggiornato",
    "SESSION_PAGE.ENGINEERING_DETAILS.3D_PLOT_TOGGLE_TITLE": "Sessioni Notturne Separate",
    "SESSION_PAGE.ENGINEERING_DETAILS.ADDRESS_TITLE": "Dettagli dell'indirizzo",
    "SESSION_PAGE.ENGINEERING_DETAILS.APPLY_DATES": "Applica Date",
    "SESSION_PAGE.ENGINEERING_DETAILS.ASSET_TITLE": "Immagini degli Asset",
    "SESSION_PAGE.ENGINEERING_DETAILS.COLLECTED_ENGINEER": "Ingegnere Raccolto",
    "SESSION_PAGE.ENGINEERING_DETAILS.COMPANY": "Azienda",
    "SESSION_PAGE.ENGINEERING_DETAILS.DATE_TITLE": "Date Orari",
    "SESSION_PAGE.ENGINEERING_DETAILS.DEPLOYED_ENGINEER": "Ingegnere impiegato",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.ADDRESS": "Indirizzo",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.COMPANY": "Azienda",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.CREATED": "Creato",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.DMA_KEY": "Chiave DMA",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.END_TIME": "Ora di fine",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.FIDO_RESULT": "Risultato Fido",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LAST_UPDATE": "Ultimo Aggiornamento",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LEAK_SIZE": "Dimensione della perdita",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LOCATION": "Posizione",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SENSOR_ID": "ID del sensore",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SESSION_ID": "ID sessione",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SESSION_STATUS": "Stato della sessione",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.START_TIME": "Ora di inizio",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.TYPE": "Tipo",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.WAYPOINT_NAME": "Nome del waypoint",
    "SESSION_PAGE.ENGINEERING_DETAILS.ENGINEER_TITLE": "Ingegneri",
    "SESSION_PAGE.ENGINEERING_DETAILS.GRAPH_TITLE": "Grafico del Polline",
    "SESSION_PAGE.ENGINEERING_DETAILS.ID_TITLE": "Elenco di ID",
    "SESSION_PAGE.ENGINEERING_DETAILS.LAST_UPDATED": "Giorni dall'ultimo aggiornamento",
    "SESSION_PAGE.ENGINEERING_DETAILS.POSTCODE": "Codice postale",
    "SESSION_PAGE.ENGINEERING_DETAILS.RELAY_ERROR": "Si è verificato un errore durante l'elaborazione dei dati del relay",
    "SESSION_PAGE.ENGINEERING_DETAILS.RELAY_NO_DATA": "Nessun dato attualmente disponibile",
    "SESSION_PAGE.ENGINEERING_DETAILS.RESET_DATES": "Reimposta Date",
    "SESSION_PAGE.ENGINEERING_DETAILS.SESSION_TITLE": "Dettagli della sessione",
    "SESSION_PAGE.ENGINEERING_DETAILS.TITLE": "Dettagli di Ingegneria FIDO",
    "SESSION_PAGE.ENGINEERING_DETAILS.WHAT3WORDS": "What3Words",
    "SESSION_PAGE.GET_AUDIO.BUTTON.CANCEL": "Annulla Recupero",
    "SESSION_PAGE.GET_AUDIO.BUTTON.GET": "Recupera audio",
    "SESSION_PAGE.GET_AUDIO.BUTTON.NA": "Nessun dispositivo di relay disponibile",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.AVAILABLE.CONTENT": "Per recuperare l'audio, deve esserci un dispositivo di relay collegato a questa sessione. Se non c'è un dispositivo di relay collegato, non sarà possibile recuperare alcun audio tramite il portale per questa sessione e il pulsante sarà disabilitato.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.AVAILABLE.HEADING": "Disponibilità",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT1": "Indipendentemente da come è stato attivato il dispositivo di relè, puoi attivarlo o disattivarlo utilizzando il pulsante sopra. L'ultima azione possibile e gli stati corrispondenti sono",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT2": "Attivato DA utente del portale - Il dispositivo di relay recupererà l'audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT3": "Disattivato dall'utente del portale - Il dispositivo relè non recupererà l'audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT4": "Attivato ON da processo automatizzato - Il dispositivo relè recupererà l'audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT5": "Disattivato da processo automatico - Il dispositivo relè non recupererà l'audio",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT6": "N/D - Dispositivo di relè non disponibile",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.TITLE": "Funzionalità",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT1": "Supponiamo che ci sia un dispositivo relè collegato per questa sezione.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT2": "Puoi attivare o disattivare se il dispositivo di relay deve tentare di recuperare i dati audio entro le prossime 24 ore.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT3": "Una volta completata una richiesta, i dati su questa pagina verranno aggiornati e quindi il recupero audio verrà disattivato automaticamente.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT4": "C'è anche un processo automatizzato che recupererà automaticamente i dati audio per tutte le sessioni che hanno un dispositivo di relay collegato, dato che il nostro modello ha rilevato un problema.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.HEADING": "Il Processo",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.TITLE": "Dispositivi di relè spiegati",
    "SESSION_PAGE.GET_AUDIO.ERROR": "C'è stato un errore, per favore aggiorna la pagina e riprova",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION": "Ultima azione intrapresa",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.AUTO_OFF": "Disattivato da processo automatico",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.AUTO_ON": "Attivato DA processo automatico",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.NA": "N/D",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.USER_OFF": "Disattivato dall'utente del portale",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.USER_ON": "Attivato ON dall'utente del portale",
    "SESSION_PAGE.GET_AUDIO.STATUS": "Stato attuale",
    "SESSION_PAGE.GET_AUDIO.STATUS.GET": "Il dispositivo di relay recupererà l'audio",
    "SESSION_PAGE.GET_AUDIO.STATUS.NA": "Dispositivo di relè non disponibile",
    "SESSION_PAGE.GET_AUDIO.STATUS.NOT_GET": "Il dispositivo di relay non recupererà l'audio",
    "SESSION_PAGE.GET_AUDIO.TITLE": "Recupero Audio",
    "SESSION_PAGE.RELAY_GRAPH.X": "Frequenza",
    "SESSION_PAGE.RELAY_GRAPH.Y": "Tempo",
    "SESSION_PAGE.RELAY_GRAPH.Z": "Potere",
    "SESSION_PAGE.SESSION_INFORMATION.FIDO_RESULT": "Risultato FIDO",
    "SESSION_PAGE.SESSION_INFORMATION.LEAK_SIZE": "Dimensione della perdita",
    "SESSION_PAGE.SESSION_INFORMATION.TITLE": "Informazioni sulla sessione",
    "SESSION.LOADING_LEAK_MAPPER": "Caricamento del mappatore delle perdite...",
    "SESSIONS.STATUS.DELETED": "Eliminato",
    "SESSIONS.STATUS.ON_TRACK": "In pista",
    "SESSIONS.STATUS.UPLOADED": "Caricato",
    "SESSIONS.STATUS.UPLOADING": "In attesa di caricamento",
    "SIDEBAR.ADMIN": "Amministratore",
    "SIDEBAR.BROWSE": "Esplora",
    "SIDEBAR.COMPANIES": "Aziende",
    "SIDEBAR.COMPANY": "La mia compagnia",
    "SIDEBAR.DASHBOARD": "Pannello di controllo",
    "SIDEBAR.DELIVERY_PERFORMANCE": "Prestazioni di Consegna",
    "SIDEBAR.DELIVERY_PERFORMANCE_LE": "Ingegnere delle perdite",
    "SIDEBAR.DELIVERY_PERFORMANCE_ST": "Tecnico dei sensori",
    "SIDEBAR.DMAPERFORMANCEREPORT": "Rapporto sul rendimento DMA",
    "SIDEBAR.FEEDBACK": "Dai un feedback",
    "SIDEBAR.GIS": "GIS",
    "SIDEBAR.GIS_ADMIN": "Amministratore GIS",
    "SIDEBAR.GIS_UPLOAD": "Caricamento GIS",
    "SIDEBAR.LOGOUT": "Disconnettersi",
    "SIDEBAR.LOGS": "Registro delle modifiche",
    "SIDEBAR.PROJECT_ADMIN": "Amministratore del progetto",
    "SIDEBAR.PROJECT_STATUS": "Stato del progetto",
    "SIDEBAR.PROJECTSTATUS": "Stato del progetto",
    "SIDEBAR.RELAY_MANAGEMENT": "Gestione del Relay",
    "SIDEBAR.REPORTS": "Rapporti",
    "SIDEBAR.SENSOR_MANAGEMENT": "Gestione dei sensori",
    "SIDEBAR.STOCK_MANAGEMENT": "Gestione delle Scorte",
    "SIDEBAR.TITLE": "Pannello di Amministrazione",
    "SIDEBAR.USERS": "Gestione Utenti",
    "SIDEBAR.VERSION": "Versione ",
    "STOCK_MANAGEMENT.DATES_BETWEEN": "Mostra Utilizzo Tra",
    "STOCK_MANAGEMENT.DATES_BETWEEN.AND": "e",
    "STOCK_MANAGEMENT.DISTRIBUTION.CHART_TITLE": "Distribuzione al Cliente",
    "STOCK_MANAGEMENT.DISTRIBUTION.DATE_ERROR": "La data di inizio non può superare la data di fine",
    "STOCK_MANAGEMENT.DISTRIBUTION.FAULTY": "Sensori FIDO difettosi",
    "STOCK_MANAGEMENT.DISTRIBUTION.FILTER": "Filtro",
    "STOCK_MANAGEMENT.DISTRIBUTION.NO_DATA": "Nessun dato di distribuzione delle scorte per l'intervallo di date selezionato",
    "STOCK_MANAGEMENT.DISTRIBUTION.REFURBED": "Sensori FIDO ristrutturati",
    "STOCK_MANAGEMENT.DISTRIBUTION.RETURNED": "Sensori FIDO Restituiti",
    "STOCK_MANAGEMENT.DISTRIBUTION.STOCKED": "Sensori FIDO in magazzino",
    "STOCK_MANAGEMENT.DISTRIBUTION.TITLE": "Distribuzione di Stock ai Clienti",
    "STOCK_MANAGEMENT.DISTRIBUTION.TOGGLE_ALL": "Attiva/Disattiva Tutto",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.FAULTY": "Relè FIDO difettosi",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.REFURBED": "Relè FIDO Ristrutturati",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.RETURNED": "Ritornati Relè FIDO",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.STOCKED": "Relè FIDO in magazzino",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.TITLE": "Distribuzione del Relay ai Clienti",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.FAULTY": "Sensori FIDO difettosi",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.REFURBED": "Sensori FIDO ristrutturati",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.RETURNED": "Sensori FIDO restituiti",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.STOCKED": "Sensori FIDO in magazzino",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.TITLE": "Distribuzione di Sensori ai Clienti",
    "STOCK_MANAGEMENT.TABLE.BUG_NAME": "Nome del sensore",
    "STOCK_MANAGEMENT.TABLE.BUG_OWNER": "Proprietario del sensore",
    "STOCK_MANAGEMENT.TABLE.COMMENT": "Commento",
    "STOCK_MANAGEMENT.TABLE.CUSTOMER": "Cliente",
    "STOCK_MANAGEMENT.TABLE.DATE": "Data più recente",
    "STOCK_MANAGEMENT.TABLE.DATE_FROM": "Da",
    "STOCK_MANAGEMENT.TABLE.DATE_TO": "A",
    "STOCK_MANAGEMENT.TABLE.DEVICE_ID": "ID del sensore",
    "STOCK_MANAGEMENT.TABLE.EDIT_SECTION": "Modifica Stock",
    "STOCK_MANAGEMENT.TABLE.EDIT.COMMENTS": "Commenti",
    "STOCK_MANAGEMENT.TABLE.EDIT.CUSTOMER": "Cliente",
    "STOCK_MANAGEMENT.TABLE.EDIT.DESELECT": "Deseleziona tutto il magazzino",
    "STOCK_MANAGEMENT.TABLE.EDIT.DISCARD": "Annulla",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_COMMENTS": "Inserisci un commento",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_CUSTOMER": "Seleziona un cliente",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_OWNER": "Seleziona un proprietario del sensore",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_STATUS": "Si prega di selezionare uno stato",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_TIMESTAMP": "Si prega di selezionare un timestamp",
    "STOCK_MANAGEMENT.TABLE.EDIT.OWNER": "Proprietario del sensore",
    "STOCK_MANAGEMENT.TABLE.EDIT.PARTNER": "Partner",
    "STOCK_MANAGEMENT.TABLE.EDIT.RELAY_OWNER": "Proprietario del Relay",
    "STOCK_MANAGEMENT.TABLE.EDIT.SENSOR_OWNER": "Proprietario del sensore",
    "STOCK_MANAGEMENT.TABLE.EDIT.STATUS": "Stato",
    "STOCK_MANAGEMENT.TABLE.EDIT.SUBMIT": "Aggiorna",
    "STOCK_MANAGEMENT.TABLE.EDIT.TIMESTAMP": "Timestamp",
    "STOCK_MANAGEMENT.TABLE.EDIT.TITLE": "Modifica Stock Selezionato",
    "STOCK_MANAGEMENT.TABLE.FILTER": "Filtro",
    "STOCK_MANAGEMENT.TABLE.FILTER_SECTION": "Filtri, Ordinamento e Ricerca",
    "STOCK_MANAGEMENT.TABLE.MODIFY": "Modifica Selezionati",
    "STOCK_MANAGEMENT.TABLE.NO_DATA": "Nessun dato di stock",
    "STOCK_MANAGEMENT.TABLE.PERSON": "Persona",
    "STOCK_MANAGEMENT.TABLE.RELAY.BUG_NAME": "Nome del Relay",
    "STOCK_MANAGEMENT.TABLE.RELAY.BUG_OWNER": "Proprietario del Relay",
    "STOCK_MANAGEMENT.TABLE.RELAY.COMMENT": "Commento",
    "STOCK_MANAGEMENT.TABLE.RELAY.CUSTOMER": "Cliente",
    "STOCK_MANAGEMENT.TABLE.RELAY.DATE": "Data più recente",
    "STOCK_MANAGEMENT.TABLE.RELAY.IMEI": "IMEI",
    "STOCK_MANAGEMENT.TABLE.RELAY.PERSON": "Persona",
    "STOCK_MANAGEMENT.TABLE.RELAY.SIM": "ID SIM",
    "STOCK_MANAGEMENT.TABLE.RELAY.STATUS": "Stato",
    "STOCK_MANAGEMENT.TABLE.RELAY.TIMESTAMP": "Ultimo Orario",
    "STOCK_MANAGEMENT.TABLE.SEARCH_BAR.APPLY.FILTER": "Applica filtri, ordinamento e ricerca",
    "STOCK_MANAGEMENT.TABLE.SEARCH.PLACEHOLDER": "Cerca Sensori...",
    "STOCK_MANAGEMENT.TABLE.SELECT_ALL": "Seleziona Tutto",
    "STOCK_MANAGEMENT.TABLE.SELECT_WAYPOINT": "Seleziona",
    "STOCK_MANAGEMENT.TABLE.SENSOR.BUG_NAME": "Nome del sensore",
    "STOCK_MANAGEMENT.TABLE.SENSOR.BUG_OWNER": "Proprietario del sensore",
    "STOCK_MANAGEMENT.TABLE.SENSOR.COMMENT": "Commento",
    "STOCK_MANAGEMENT.TABLE.SENSOR.CUSTOMER": "Cliente",
    "STOCK_MANAGEMENT.TABLE.SENSOR.DATE": "Data più recente",
    "STOCK_MANAGEMENT.TABLE.SENSOR.DEVICE_ID": "ID del sensore",
    "STOCK_MANAGEMENT.TABLE.SENSOR.PERSON": "Persona",
    "STOCK_MANAGEMENT.TABLE.SENSOR.STATUS": "Stato",
    "STOCK_MANAGEMENT.TABLE.SENSOR.TIMESTAMP": "Ultimo Orario",
    "STOCK_MANAGEMENT.TABLE.SORT": "Ordina",
    "STOCK_MANAGEMENT.TABLE.SORT.ASC": "In salita",
    "STOCK_MANAGEMENT.TABLE.SORT.DESC": "In discesa",
    "STOCK_MANAGEMENT.TABLE.SORT.NONE": "Nessuno",
    "STOCK_MANAGEMENT.TABLE.STATUS": "Stato",
    "STOCK_MANAGEMENT.TABLE.STATUSES.customer": "cliente",
    "STOCK_MANAGEMENT.TABLE.STATUSES.faulty": "difettoso",
    "STOCK_MANAGEMENT.TABLE.STATUSES.new": "nuovo",
    "STOCK_MANAGEMENT.TABLE.STATUSES.refurb": "ricondizionato",
    "STOCK_MANAGEMENT.TABLE.STATUSES.retired": "in pensione",
    "STOCK_MANAGEMENT.TABLE.STATUSES.returned": "restituito",
    "STOCK_MANAGEMENT.TABLE.STATUSES.stock": "stock",
    "STOCK_MANAGEMENT.TABLE.TIMESTAMP": "Ultimo Orario",
    "STOCK_MANAGEMENT.TABLE.TITLE": "Tutto il Stock",
    "SUMMARY.DIALOG.SUBTITLE.CHANGE": "Tutti i filtri verranno eliminati?",
    "SUMMARY.DIALOG.SUBTITLE.CLOSE": "Le modifiche verranno eliminate",
    "SUMMARY.DIALOG.TITLE.CHANGE": "Sei sicuro di voler cambiare l'origine dati?",
    "SUMMARY.DIALOG.TITLE.CLOSE": "Sei sicuro di voler chiudere le impostazioni?",
    "SUMMARY.FORM.COLUMN.LABEL": "Colonna",
    "SUMMARY.FORM.COLUMN.PLACEHOLDER": "Seleziona colonna",
    "SUMMARY.FORM.SOURCE.LABEL": "Fonte di dati",
    "SUMMARY.FORM.SOURCE.PLACEHOLDER": "Seleziona Origine dati",
    "SUMMARY.FORM.TITLE.LABEL": "Titolo",
    "SUMMARY.FORM.TITLE.PLACEHOLDER": "Inserisci il titolo",
    "SUMMARY.FORM.TYPE.LABEL": "Tipo",
    "SUMMARY.FORM.TYPE.PLACEHOLDER": "Seleziona il tipo",
    "SUMMARY.MODAL_TITLE": "Impostazioni",
    "SYSTEM_FIELDS.CELLS_FILLED": "Celle riempite",
    "SYSTEM_FIELDS.DROPDOWN.1.PLACEHOLDER": "Scegli il materiale",
    "SYSTEM_FIELDS.DROPDOWN.2.PLACEHOLDER": "Scegli il tipo di asset",
    "SYSTEM_FIELDS.DROPDOWN.3.PLACEHOLDER": "Scegli il tipo di tubo",
    "SYSTEM_FIELDS.DROPDOWN.4.PLACEHOLDER": "Scegli stato",
    "SYSTEM_FIELDS.DROPDOWN.5.PLACEHOLDER": "Scegli unità",
    "SYSTEM_FIELDS.ERROR.NUMERIC_UNIQUE_FIELD": "Il campo unico inserito è numerico e dovrebbe essere una stringa",
    "SYSTEM_FIELDS.ROW_1": "Campi Riga",
    "SYSTEM_FIELDS.ROW_2": "Campi del Sistema",
    "SYSTEM_FIELDS.TITLE": "Mappa le celle con i campi di sistema",
    "SYSTEM_FIELDS.UNIQUE_VALUES_NOT_FOUND": "Nessun valore unico da mappare",
    "TABLE_OF_RESULTS.DIALOG.SUBTITLE.CHANGE": "Tutti i filtri verranno eliminati?",
    "TABLE_OF_RESULTS.DIALOG.SUBTITLE.CLOSE": "Le modifiche verranno eliminate",
    "TABLE_OF_RESULTS.DIALOG.TITLE.CHANGE": "Sei sicuro di voler cambiare l'origine dati?",
    "TABLE_OF_RESULTS.DIALOG.TITLE.CLOSE": "Sei sicuro di voler chiudere le impostazioni?",
    "TABLE_OF_RESULTS.FORM.COLUMNS_TO_SHOW.LABEL": "Colonna da mostrare",
    "TABLE_OF_RESULTS.FORM.COLUMNS_TO_SHOW.PLACEHOLDER": "Seleziona le colonne",
    "TABLE_OF_RESULTS.FORM.SOURCE.LABEL": "Fonte di dati",
    "TABLE_OF_RESULTS.FORM.SOURCE.PLACEHOLDER": "Seleziona Origine dati",
    "TABLE_OF_RESULTS.MODAL_TITLE": "Impostazioni",
    "TOOLTIP.ADDRESS": "Indirizzo",
    "TOOLTIP.ASSET_KEY": "Chiave dell'Asset",
    "TOOLTIP.COMPANY": "Azienda",
    "TOOLTIP.CONSUMPTION_PROFILE_ID": "ID del profilo di consumo",
    "TOOLTIP.DAYS_SINCE_LAST": "Giorni dall'ultimo aggiornamento",
    "TOOLTIP.DEPLOYED_BY": "Implementato da",
    "TOOLTIP.DEPLOYMENT_ORDER": "Ordine di Distribuzione",
    "TOOLTIP.DIAMETER": "Diametro",
    "TOOLTIP.DMA_ID": "Id DMA",
    "TOOLTIP.DMA_KEY": "Chiave DMA",
    "TOOLTIP.DMA_NAME": "Nome DMA",
    "TOOLTIP.ENGINEER": "Ingegnere",
    "TOOLTIP.FIDO_RESULT": "Risultato Fido",
    "TOOLTIP.LATITUDE": "Latitudine",
    "TOOLTIP.LEAK_SIZE": "Dimensione della perdita",
    "TOOLTIP.LONGITUDE": "Longitudine",
    "TOOLTIP.MATERIAL": "Materiale",
    "TOOLTIP.PIPE_TYPE": "Tipo di tubo",
    "TOOLTIP.RECORDINGS_CNT": "Conteggio delle registrazioni",
    "TOOLTIP.SESSION_ID": "Id sessione",
    "TOOLTIP.STANDARDISED_MATERIAL": "Materiale Standardizzato",
    "TOOLTIP.STANDARISED_ASSET_TYPE": "Tipo di Asset Standardizzato",
    "TOOLTIP.TOP_SOUND_ID": "Suono Superiore ID",
    "TOOLTIP.WAYPOINT_ID": "Id del punto di passaggio",
    "TOOLTIP.WAYPOINT_NAME": "Nome del waypoint",
    "TOOLTIP.WHAT_3_WORDS": "Quali 3 Parole",
    "TOP_SOUND_PAGE.AUDIO_INFORMATION": "Informazioni audio",
    "TOP_SOUND_PAGE.COMPANY": "Azienda",
    "TOP_SOUND_PAGE.DISTANCE_GRAPH_TITLE": "Grafici di distanza",
    "TOP_SOUND_PAGE.ENGINEER": "Ingegnere",
    "TOP_SOUND_PAGE.HIGH_FREQUENCY": "Taglio ad alta frequenza",
    "TOP_SOUND_PAGE.LOCATION": "Posizione",
    "TOP_SOUND_PAGE.LOCATION_DETAILS": "Dettagli sulla posizione",
    "TOP_SOUND_PAGE.LOW_FREQUENCY": "Taglio a bassa frequenza",
    "TOP_SOUND_PAGE.NUMBER_PATHS": "Numero di percorsi",
    "TOP_SOUND_PAGE.POSTCODE": "Codice postale",
    "TOP_SOUND_PAGE.PSDS_TITLE": "Profilo spettrale",
    "TOP_SOUND_PAGE.SPACING": "Spaziatura",
    "TOP_SOUND_PAGE.STARTING_DISTANCE": "Distanza di partenza",
    "TOP_SOUND_PAGE.TIME_TOP_SOUNDING": "Tempo di top-sondaggio",
    "TOP_SOUND_PAGE.TITLE": "Suono alto",
    "TOP_SOUND_PAGE.WHAT3WORDS": "What3Words",
    "TOP_SOUNDING.GRAPH_ALT": "grafico della distanza di sondaggio superiore",
    "TOP_SOUNDING.PSD_GRAPH_ALT": "grafico psd",
    "UNIT.GALLONS_DAY": "Galloni/giorno",
    "UNIT.ML_DAY": "ML/Giorno",
    "UPLOAD_HEALTH_CHECK.BTN": "Carica Controllo Salute",
    "UPLOAD_HEALTH_CHECK.MODAL.BTN.SUBMIT": "Invia",
    "UPLOAD_HEALTH_CHECK.MODAL.DESC": "Inserisci l'URL nell'input sottostante",
    "UPLOAD_HEALTH_CHECK.MODAL.ERROR.DESC": "Si prega di riprovare, l'URL non è stato aggiornato",
    "UPLOAD_HEALTH_CHECK.MODAL.ERROR.TITLE": "Riprova!",
    "UPLOAD_HEALTH_CHECK.MODAL.INPUT.LABEL": "URL del controllo di salute",
    "UPLOAD_HEALTH_CHECK.MODAL.SUCCESS.DESC": "L'URL del controllo salute è stato aggiornato",
    "UPLOAD_HEALTH_CHECK.MODAL.SUCCESS.TITLE": "Fantastico!",
    "UPLOAD_HEALTH_CHECK.MODAL.TITLE": "Carica il rapporto di controllo della salute",
    "USER_DETAILS_PAGE.CRUMB": "Gestisci utente",
    "USER_DETAILS_PAGE.DISCARD": "Scartare",
    "USER_DETAILS_PAGE.FORM.BRANCH.LABEL": "Progetto",
    "USER_DETAILS_PAGE.FORM.BRANCH.PLACEHOLDER": "Scegli Progetto",
    "USER_DETAILS_PAGE.FORM.COMPANY.LABEL": "Azienda",
    "USER_DETAILS_PAGE.FORM.COMPANY.PLACEHOLDER": "Scegli Azienda",
    "USER_DETAILS_PAGE.FORM.EMAIL.LABEL": "Indirizzo e-mail",
    "USER_DETAILS_PAGE.FORM.EMAIL.PLACEHOLDER": "Inserisci l'email",
    "USER_DETAILS_PAGE.FORM.FIRST_NAME.LABEL": "Nome di battesimo",
    "USER_DETAILS_PAGE.FORM.FIRST_NAME.PLACEHOLDER": "Inserisci il nome",
    "USER_DETAILS_PAGE.FORM.LAST_NAME.LABEL": "Cognome",
    "USER_DETAILS_PAGE.FORM.LAST_NAME.PLACEHOLDER": "Inserisci Cognome",
    "USER_DETAILS_PAGE.FORM.ROLE.LABEL": "Ruolo",
    "USER_DETAILS_PAGE.FORM.ROLE.PLACEHOLDER": "Scegli Ruolo",
    "USER_DETAILS_PAGE.SUBMIT": "Salva",
    "USER_MANAGEMENT.DROP_DOWN.TITLE": "Gruppi",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_COMPANY": "Aggiungi Azienda",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_PARTNER": "Aggiungi Partner",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_PROJECT": "Aggiungi Progetto",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_USER": "Aggiungi Utente",
    "USER_MANAGEMENT.ROUTE_TITLES.COMPANY": "Azienda",
    "USER_MANAGEMENT.ROUTE_TITLES.PARTNER": "Partner",
    "USER_MANAGEMENT.ROUTE_TITLES.PROJECT": "Progetto",
    "USER_MANAGEMENT.ROUTE_TITLES.PROJECT_ARCHIVES": "Progetto archiviato",
    "USER_MANAGEMENT.ROUTE_TITLES.RESOURCES": "Risorse",
    "USER_MANAGEMENT.ROUTE_TITLES.USER": "Utente",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_COMPANIES": "Visualizza Aziende",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_GIS_UPLOADS": "Visualizza i caricamenti GIS",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PARTNERS": "Visualizza Partner",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PROJECT_ARCHIVES": "Visualizza archivio",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PROJECTS": "Visualizza Progetti",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_USERS": "Visualizza Utenti",
    "USER_ROLE.COMPANY_ADMIN": "Amministratore azienda",
    "USER_ROLE.COMPANY_BUG_DEPLOYMENT_ENGINEER": "Tecnico Sensori Aziendale",
    "USER_ROLE.COMPANY_LEAK_ENGINEER": "Ingegnere di perdite aziendali",
    "USER_ROLE.COMPANY_USER": "Utente Aziendale",
    "USER_ROLE.PARTNER_ADMIN": "Admin del Partner",
    "USER_ROLE.PARTNER_BUG_DEPLOYMENT_ENGINEER": "Tecnico Sensore Partner",
    "USER_ROLE.PARTNER_LEAK_ENGINEER": "Ingegnere Partner per la Rilevazione di Perdite",
    "USER_ROLE.PARTNER_USER": "Utente Partner",
    "USER_ROLE.SUPER_ADMIN": "Super amministratore",
    "USERS_PAGE.ADD_USER.ACTIONS": "Azioni",
    "USERS_PAGE.ADD_USER.BUTTON": "Nuovo utente",
    "USERS_PAGE.ADD_USER.FORM.BRANCH.LABEL": "Progetto",
    "USERS_PAGE.ADD_USER.FORM.BRANCH.PLACEHOLDER": "Scegli Progetto",
    "USERS_PAGE.ADD_USER.FORM.COMPANY.LABEL": "Azienda",
    "USERS_PAGE.ADD_USER.FORM.COMPANY.PLACEHOLDER": "Scegli Azienda",
    "USERS_PAGE.ADD_USER.FORM.EMAIL.LABEL": "Indirizzo e-mail",
    "USERS_PAGE.ADD_USER.FORM.EMAIL.PLACEHOLDER": "Inserisci l'email",
    "USERS_PAGE.ADD_USER.FORM.FIRST_NAME.LABEL": "Nome di battesimo",
    "USERS_PAGE.ADD_USER.FORM.FIRST_NAME.PLACEHOLDER": "Inserisci il nome",
    "USERS_PAGE.ADD_USER.FORM.LAST_NAME.LABEL": "Cognome",
    "USERS_PAGE.ADD_USER.FORM.LAST_NAME.PLACEHOLDER": "Inserisci Cognome",
    "USERS_PAGE.ADD_USER.FORM.ROLE.LABEL": "Ruolo",
    "USERS_PAGE.ADD_USER.FORM.ROLE.PLACEHOLDER": "Scegli Ruolo",
    "USERS_PAGE.ADD_USER.FORM.SUBMIT": "Aggiungi utente",
    "USERS_PAGE.ADD_USER.STATUS": "Stato",
    "USERS_PAGE.CRUMB": "Utenti",
    "USERS_PAGE.DELETE_USER.TITLE": "Sei sicuro di voler eliminare questo Utente?",
    "USERS_PAGE.SUBTITLE": "Alcune altre informazioni importanti vanno qui",
    "USERS_PAGE.TABLE.ACTIONS": "Azioni",
    "USERS_PAGE.TABLE.COMPANY": "Azienda",
    "USERS_PAGE.TABLE.EMAIL": "E-mail",
    "USERS_PAGE.TABLE.ID": "ID",
    "USERS_PAGE.TABLE.NAME": "Nome",
    "USERS_PAGE.TABLE.ROLE": "Ruolo",
    "USERS_PAGE.TABLE.STATUS": "Stato",
    "USERS_PAGE.TITLE.NO_USERS": "Non ci sono utenti",
    "USERS_PAGE.TITLE.TOTAL_COUNT": "Utenti totali:",
    "VALIDATION.BRANCHES.UNIQUE": "Il nome del progetto dovrebbe essere unico",
    "VALIDATION.EMAIL": "E-mail non valido",
    "VALIDATION.MAX": "Deve contenere meno di %1$s caratteri",
    "VALIDATION.PASSWORD.CONFIRM": "La password e la ripetizione della password devono essere le stesse",
    "VALIDATION.PASSWORD.LONG": "La password deve contenere meno di 128 caratteri",
    "VALIDATION.PASSWORD.SHORT": "La password deve contenere più di 8 caratteri",
    "VALIDATION.PASSWORD.SPECIAL": "La password deve contenere almeno un carattere speciale",
    "VALIDATION.PHONE": "Il numero di telefono non è valido",
    "VALIDATION.REQUIRED": "Necessario",
    "VIEW_COMPANIES.BUTTON.ADD": "Aggiungi Azienda",
    "VIEW_COMPANIES.DELETE_ICON": "Icona elimina",
    "VIEW_COMPANIES.EDIT_ICON": "Icona di modifica",
    "VIEW_COMPANIES.TITLE.ACTION": "Azione",
    "VIEW_COMPANIES.TITLE.COMPANY_CODE": "Codice Azienda",
    "VIEW_COMPANIES.TITLE.COUNTRY": "Codice del Paese",
    "VIEW_COMPANIES.TITLE.CURRENCY": "Valuta",
    "VIEW_COMPANIES.TITLE.LIST": "Elenca le Aziende",
    "VIEW_COMPANIES.TITLE.NAME": "Nome",
    "VIEW_COMPANIES.TITLE.PAGE": "Visualizza Aziende",
    "VIEW_COMPANIES.TITLE.PARTNER": "Partner",
    "VIEW_COMPANIES.TITLE.UNIT": "Unità",
    "VIEW_DRAFTS.DIALOG.DELETE.CANCEL": "Disprezzo",
    "VIEW_DRAFTS.DIALOG.DELETE.CONFIRM": "Eliminare",
    "VIEW_DRAFTS.DIALOG.DELETE.TITLE": "Sei sicuro di voler eliminare questa bozza?",
    "VIEW_DRAFTS.TITLE.PAGE": "Visualizza bozze",
    "VIEW_PARTNERS.BUTTON.ADD": "Aggiungi Partner",
    "VIEW_PARTNERS.TITLE.ACTION": "Azione",
    "VIEW_PARTNERS.TITLE.COUNTRY": "Codice del Paese",
    "VIEW_PARTNERS.TITLE.LIST": "Elenco Partner",
    "VIEW_PARTNERS.TITLE.NAME": "Nome",
    "VIEW_PARTNERS.TITLE.PAGE": "Visualizza Partner",
    "VIEW_PARTNERS.TITLE.PARTNER_CODE": "Codice Partner",
    "VIEW_PROJECT_ARCHIVES.DESCRIPTION": "Per riattivare un progetto, contatta l'assistenza.",
    "VIEW_PROJECTS.ACTION.APPROVE": "Approvare",
    "VIEW_PROJECTS.ACTION.ARCHIVE": "Archivio",
    "VIEW_PROJECTS.ACTION.DECLINE": "Declino",
    "VIEW_PROJECTS.ACTION.DELETE": "Eliminare",
    "VIEW_PROJECTS.ACTION.EDIT": "Modificare",
    "VIEW_PROJECTS.ACTION.REJECT": "Rifiutare",
    "VIEW_PROJECTS.ACTION.VIEW": "Visualizzazione",
    "VIEW_PROJECTS.ACTION.VIEW_REJECTION_NOTES": "Visualizza le note di rifiuto",
    "VIEW_PROJECTS.BUTTON.ADD": "Aggiungi Progetto",
    "VIEW_PROJECTS.DIALOG.APPROVE.CANCEL": "Disprezzo",
    "VIEW_PROJECTS.DIALOG.APPROVE.CONFIRM": "Approvare",
    "VIEW_PROJECTS.DIALOG.APPROVE.TITLE": "Sei sicuro di voler approvare questo progetto?",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.CANCEL": "Disprezzo",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.CONFIRM": "Confermare",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.DESCRIPTION": "Quando il progetto viene spostato nell'archivio, i file, i waypoint e le sessioni ad esso associati saranno inattivi e non accessibili. Per riattivare un progetto, è possibile aprire un ticket di supporto.",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.TITLE": "Sei sicuro di voler archiviare questo progetto?",
    "VIEW_PROJECTS.DIALOG.DELETE.CANCEL": "Disprezzo",
    "VIEW_PROJECTS.DIALOG.DELETE.CONFIRM": "Eliminare",
    "VIEW_PROJECTS.DIALOG.DELETE.TITLE": "Sei sicuro di voler eliminare questo progetto?",
    "VIEW_PROJECTS.DIALOG.REJECT.CANCEL": "Disprezzo",
    "VIEW_PROJECTS.DIALOG.REJECT.CONFIRM": "Rifiutare",
    "VIEW_PROJECTS.DIALOG.REJECT.TITLE": "Sei sicuro di voler rifiutare questo progetto?",
    "VIEW_PROJECTS.FORM.FILTER.ALL": "Tutto",
    "VIEW_PROJECTS.FORM.FILTER.APPROVED": "Approvato",
    "VIEW_PROJECTS.FORM.FILTER.SUBMITTED": "Inviato",
    "VIEW_PROJECTS.NOT_FOUND": "Nessun progetto trovato",
    "VIEW_PROJECTS.TITLE.ACTION": "Azione",
    "VIEW_PROJECTS.TITLE.AUTHOR": "Creato da",
    "VIEW_PROJECTS.TITLE.COMPANY": "Azienda",
    "VIEW_PROJECTS.TITLE.DMAS": "Visualizza DMAs",
    "VIEW_PROJECTS.TITLE.DMAS_SUBLIST_TITLE": "Elenco di DMA",
    "VIEW_PROJECTS.TITLE.END_DATE": "Data di Fine",
    "VIEW_PROJECTS.TITLE.LIST": "Elenca Progetti",
    "VIEW_PROJECTS.TITLE.NAME": "Nome",
    "VIEW_PROJECTS.TITLE.NO_DMAS": "Nessun DMA",
    "VIEW_PROJECTS.TITLE.PAGE": "Visualizza Progetti",
    "VIEW_PROJECTS.TITLE.START_DATE": "Data di inizio",
    "VIEW_PROJECTS.TITLE.STATUS": "Stato",
    "VIEW_USERS.ACTION.DELETE": "Eliminare",
    "VIEW_USERS.ACTION.EDIT": "Modificare",
    "VIEW_USERS.ACTION.FORGOT_PASSWORD": "Reimposta password",
    "VIEW_USERS.BUTTON.ADD": "Aggiungi utente",
    "VIEW_USERS.BUTTON.INVITE": "Invita utente",
    "VIEW_USERS.PAGINATION.TITLE": "Righe per pagina",
    "VIEW_USERS.ROW.ICON.DELETE.ALT": "Icona elimina",
    "VIEW_USERS.ROW.ICON.EDIT.ALT": "Icona modifica",
    "VIEW_USERS.TITLE.LIST": "Elenca Utenti",
    "VIEW_USERS.TITLE.PAGE": "Visualizza Utenti",
    "VIEW_USERS.TITLE.ROW_FIVE": "Azione",
    "VIEW_USERS.TITLE.ROW_FOUR": "Ruolo",
    "VIEW_USERS.TITLE.ROW_ONE": "Nome",
    "VIEW_USERS.TITLE.ROW_THREE": "Azienda",
    "VIEW_USERS.TITLE.ROW_TWO": "Partner",
    "WAYPOINT_PAGE.ADD_JOB.ADDRESS": "Indirizzo",
    "WAYPOINT_PAGE.ADD_JOB.DATE_EXTERNALLY": "Data Sollevata Esternamente",
    "WAYPOINT_PAGE.ADD_JOB.DATE_INTERNALLY": "Data Sollevata Internamente",
    "WAYPOINT_PAGE.ADD_JOB.DESCRIPTION": "Aggiungi un lavoro al waypoint",
    "WAYPOINT_PAGE.ADD_JOB.DISCARD": "Scarta",
    "WAYPOINT_PAGE.ADD_JOB.ENGINEERING_NOTE": "Nota di Ingegneria",
    "WAYPOINT_PAGE.ADD_JOB.ENVIRONMENTAL_NOTE": "Nota Ambientale",
    "WAYPOINT_PAGE.ADD_JOB.ERROR.DESC": "Si prega di aggiornare e riprovare",
    "WAYPOINT_PAGE.ADD_JOB.ERROR.TITLE": "Qualcosa è andato storto",
    "WAYPOINT_PAGE.ADD_JOB.ESTIMATED_SIZE": "Dimensione stimata della perdita",
    "WAYPOINT_PAGE.ADD_JOB.ESTIMATED_SIZE_UNIT": "Unità di misura della perdita",
    "WAYPOINT_PAGE.ADD_JOB.FLOW_REDUCTION": "Riduzione del Flusso Convenuta (m3/ora)",
    "WAYPOINT_PAGE.ADD_JOB.IMAGE_ALT": "Immagine caricata %1$s",
    "WAYPOINT_PAGE.ADD_JOB.IMAGES": "Media",
    "WAYPOINT_PAGE.ADD_JOB.JOB_COMMENT": "Note",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS": "Stato del lavoro",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.CANCELLED": "Annullato",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.DRY_DIG": "Scavo a Secco",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.DRY_DIG_APPEALED": "Appello a Dry Dig",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.NFA": "NFA (Nessuna ulteriore azione)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.PLACEHOLDER": "Seleziona uno stato del lavoro",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RAISED_EXTERNALLY": "Generato esternamente",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RAISED_INTERNALLY": "Sollevato internamente",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.REPAIRED": "Riparato",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RFA": "RFA (Richiesta di ulteriori azioni)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.VALIDATION": "Si prega di fornire lo stato del lavoro",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE": "Tipo di lavoro",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.ASSET_VALVE_HYDRANT_LEAK": "Perdita dell'asset (Valvola/Idrante)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CLIENT_METER_PRV_LEAK": "Perdita del contatore/riduttore di pressione del cliente",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.COMM_PIPE_LEAK": "Perdita del tubo di comunicazione",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CUSTOMER_METER_LEAK": "Perdita dal Contatore del Cliente",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CUSTOMER_SIDE_LEAK": "Perdita dal Lato del Cliente",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.FERRULE_LEAK": "Perdita dalla ghiera",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.MAINS_LEAK": "Perdita dalla rete idrica",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.NETWORK_MAINTENANCE": "Manutenzione della Rete",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.PLACEHOLDER": "Seleziona un tipo di lavoro",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.RENEW_STOP_TAP_MSM": "Rinnova Rubinetto di Arresto/MSM",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.RESOLVED_ONSITE": "Risolto sul posto",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.VALIDATION": "Si prega di fornire un tipo di lavoro",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_ESTIMATE": "Stima della Dimensione della Perdita del Cliente",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE": "Tipo di perdita",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.ASSET_LEAK": "Perdita di Asset",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CLIENT_METER_PRV_LEAK": "Perdita del contatore del cliente/ PRV",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.COMMERCIAL_REPAIR": "Riparazione Commerciale",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.COMMUNICATION_PIPE": "Tubo di Comunicazione",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CSL": "CSL",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CUSTOMER_METER_LEAK": "Perdita del contatore del cliente",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CUSTOMER_SIDE_LEAK": "Perdita dal lato del cliente",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.DECOMMISSION_FERRULE": "Decommissionare Ferrule",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXCAVATE_TRIAL_HOLE_PERMIT": "Scavo di Foro di Prova (Permesso)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_INC_EXC": "Contatore di perdite esterne>40mm Inc Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_NO_EXC": "Contatore esterno che perde>40mm No Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_INC_EXC": "Contatore esterno che perde<40mm Inc Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_NO_EXC": "Contatore esterno che perde<40mm No Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FERRULE": "Giunto",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FH_STOPPED_ON_SITE": "F/H si è fermato sul sito",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FIRE_HYDRANT": "Idrante",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FIRE_MAIN": "Principale Antincendio",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_NO_EXC": "Test di Flusso al Confine No Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_WITH_EXC": "Test di flusso al confine con Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INST_MSM_TO_EXIST_COMM_PIPE_UNMTRD": "Installa MSM su Esistente Tubo di Comunicazione Non Monitorato",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_FERRULE_ONLY": "Installa solo la ferrula",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_MSM_INC_METER": "Installa MSM Inc Meter",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_SAMPLE_TAP": "Installa Sample Tap",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_SLUICE_VALVE": "Installa Valvola di Sfogo",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_WASHOUT_HYDRANT": "Installa Idrante di Scarico",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_FIXED_ONSITE": "Perdita Riparata sul Posto",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_FH": "Perdita su F/H",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV": "Perdita sul mandrino di SV",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV_FLANGE": "Perdita sul mandrino di SV / flangia.",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS": "Piatti principali",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS_BURST": "Scoppio della rete idrica",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS_LEAK": "Perdita dalla rete idrica",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NA_WO_STOPPED_ON_SITE": "N/D - Lavoro interrotto sul posto",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NETWORK_MAINTENANCE": "Manutenzione della Rete",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NO_LEAK": "Nessuna Perdita",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.OSV_EXCHANGE": "Scambio OSV",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.OTHER": "Altro",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PASSING_FH": "Passaggio FH",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PASSING_HYDRANT": "Superando l'Idrante",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PLACEHOLDER": "Seleziona un tipo di perdita",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REMEDIAL_WORK_EXTERNAL": "Lavoro di Rimedio Esterno",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REMOVE_SLUICE_VAVLE": "Rimuovi Valvola di Sfogo",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COMMUNICATION_PIPE_LONGSIDE": "Rinnova Tubo di Comunicazione Longside",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COMMUNICATION_PIPE_SHORTSIDE": "Rinnova Tubo di Comunicazione Lato Corto",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COVER_FRAME_STANDARD": "Rinnova Copertura & Cornice (Standard)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FERRULE_ONLY": "Rinnova solo la ghiera",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT": "Rinnova Idrante",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT_CHAMBER": "Rinnova la Camera dell'Idrante",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT_FRAME_COVER": "Rinnova Telaio e Copertura dell'Idrante",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_GT_10M": "Rinnova Tubo di Alimentazione Che Perde >10m",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_LT_10M": "Rinnova il tubo di alimentazione che perde <10m ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_MSM_STOP_TAP_ASSEMBLY": "Rinnova l'Assemblea del Rubinetto di Arresto/MSM",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_SLUICE_VAVLE": "Rinnova Valvola di Sfogo",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_WASHOUT_HYDRANT": "Rinnova Idrante di Lavaggio",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPACK_SLUICE_VALVE": "Riconfeziona Valvola di Sfogo",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_COMMUNICATION_PIPE": "Ripara il Tubo di Comunicazione",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_EXTERNAL_LSP_NON_ELIGIBLE": "Ripara LSP Esterno - Non Ammissibile",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_INTERNAL_LEAK_RECH": "Ripara Perdita Interna (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LEAKING_SUPPLY_PIPE_RECH": "Ripara Tubo di Alimentazione Che Perde (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LOP": "Ripara LOP",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LSP_ELIGIBLE": "Riparazione LSP - Ammissibile",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_GTE_200MM": "Ripara Pezzo di Cavicchio Principale >=200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_LT_200MM": "Ripara il Pezzo Principale del Dado <200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_GTE_200MM": "Riparazione Principale [Non Dowel] >=200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_LT_200MM": "Riparazione Principale [Non Chiodo] <200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAJOR_BURST": "Ripara Rottura Maggiore",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_NON_RETURN_VALVE": "Ripara la Valvola di Non Ritorno",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_RUNNING_OVERFLOW_RECH": "Riparazione Esecuzione Overflow (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_SLUICE_VALVE": "Ripara Valvola di Sfogo",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPOSITION_MSM_STOP_TAP_ASSEMBLY": "Riposiziona l'Assemblea del Rubinetto di Arresto/MSM",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RESET_SURFACE_BOX_STANDARD": "Ripristina Surface Box (Standard)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SERVICE_LEAK": "Perdita di Servizio",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SLUICE_VALVE": "Valvola a saracinesca",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SLUICE_VALVE_VL": "Valvola a saracinesca (VL)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_EXCHANGE": "Scambio di Rubinetto di Arresto",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_LEAK": "Ferma la Perdita del Rubinetto",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_LEAK_NO_7_FERRULE_EXCHANGE_NO_5": "Ferma la perdita del rubinetto N.7\\n\\nScambio di boccola N.5",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.VALIDATION": "Si prega di fornire un tipo di perdita",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.WO_FH": "WO / FH",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_DIAMETER": "Diametro del tubo",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_DIAMETER_UNIT": "Unità di diametro",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_MATERIAL": "Materiale del tubo",
    "WAYPOINT_PAGE.ADD_JOB.REMOVE_IMAGE_ARIA": "Rimuovi immagine %1$s",
    "WAYPOINT_PAGE.ADD_JOB.REPAIR_DATE": "Data di Riparazione",
    "WAYPOINT_PAGE.ADD_JOB.ROAD_SPEED": "Velocità Stradale",
    "WAYPOINT_PAGE.ADD_JOB.SELECT_UNIT.PLACEHOLDER": "Seleziona unità",
    "WAYPOINT_PAGE.ADD_JOB.SUBMIT": "Aggiungi Nuovo Lavoro",
    "WAYPOINT_PAGE.ADD_JOB.SUBMIT.VALIDATION": "La convalida non è riuscita, controlla gli input.",
    "WAYPOINT_PAGE.ADD_JOB.SUCCESS": "Lavoro aggiunto con successo",
    "WAYPOINT_PAGE.ADD_JOB.SURFACE_TYPE": "Tipo di superficie",
    "WAYPOINT_PAGE.ADD_JOB.TITLE": "Aggiungi lavoro a Waypoint",
    "WAYPOINT_PAGE.ADD_JOB.W3W": "What3Words",
    "WAYPOINT_PAGE.ADD_JOB.WORK_ORDER": "Riferimento dell'ordine di lavoro del cliente/utility",
    "WAYPOINT_PAGE.ADD_JOB.WORK_ORDER.VALIDATION": "Si prega di fornire il riferimento dell'ordine di lavoro del cliente/utility",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.ACTION": "Azione",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.DATE": "Data",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.address": "Indirizzo",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.agreed_flow_reduction": "Riduzione del flusso",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.comment": "Commento",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.date_raised_externally": "Data Sollevata Esternamente",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.date_raised_internally": "Data Sollevata Internamente",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.environmental_notes": "Note Ambientali",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.estimate_leak_size": "Dimensione Stimata della Perdita",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.id": "ID",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.job_status": "Stato del lavoro",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.job_type": "Tipo di lavoro",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.leak_type_id": "ID tipo di perdita",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.material": "Materiale",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.pipe_diameter": "Diametro del tubo",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.repair_date": "Data di Riparazione",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.road_speed": "Velocità Stradale",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.surface_type": "Tipo di superficie",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.urls": "URL",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.w3w": "W3W",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.waypoint_id": "ID del punto di passaggio",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.work_order": "Riferimento dell'ordine di lavoro del cliente/utility",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.NEW": "Nuovo Valore",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.NOTES": "Note Aggiuntive",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.OLD": "Valore Precedente",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.STATUS": "Stato",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.TITLE": "Registro attività",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.USER": "Utente",
    "WAYPOINT_PAGE.JOB_TABLE.CREATED_DATE": "Data di creazione",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_ERROR": "La data di inizio deve essere precedente alla data di fine",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_TYPE": "Tipo di data",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_TYPE.PLACEHOLDER": "Seleziona il tipo di data",
    "WAYPOINT_PAGE.JOB_TABLE.END_DATE": "Data di fine",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Asset (Valve/Hydrant) Leak": "Perdita dell'Asset (Valvola/Idrante)",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Cancelled": "Annullato",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Client Meter/PRV Leak": "Perdita del contatore/riduttore di pressione del cliente",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Comm Pipe Leak": "Perdita del tubo di comunicazione",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Customer Meter Leak": "Perdita del Contatore del Cliente",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Ferrule Leak": "Perdita dalla ghiera",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Leak Repair": "Riparazione Perdite",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Mains Leak": "Perdita di acqua principale",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Raised externally": "Allevato esternamente",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Raised internally": "Sollevato internamente",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Repaired": "Riparato",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Scheduled": "Pianificato",
    "WAYPOINT_PAGE.JOB_TABLE.FILTERS": "Filtri, Ordinamento e Ricerca",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.CREATED": "Data di Creazione",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.FLOW_REDUCTION": "Riduzione del Flusso Convenuta",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_COMMENTS": "Note",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_STATUS": "Stato del lavoro",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_TYPE": "Tipo di lavoro",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.LEAK_SIZE": "Dimensione della perdita",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.LEAK_TYPE": "Tipo di perdita",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.REPAIR_DATE": "Data di Riparazione",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.UPDATED_DATE": "Data Aggiornata",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.WORK_ORDER": "Riferimento dell'ordine di lavoro del cliente/utility",
    "WAYPOINT_PAGE.JOB_TABLE.NO_DATA": "Nessun lavoro corrispondente",
    "WAYPOINT_PAGE.JOB_TABLE.NO_DATA_EXISTS": "Non esistono lavori per questo waypoint",
    "WAYPOINT_PAGE.JOB_TABLE.REPAIR_DATE": "Data di riparazione",
    "WAYPOINT_PAGE.JOB_TABLE.SEARCH.BUTTON": "Applica filtri, ordinamento e ricerca",
    "WAYPOINT_PAGE.JOB_TABLE.SEARCH.PLACEHOLDER": "Cerca lavori...",
    "WAYPOINT_PAGE.JOB_TABLE.START_DATE": "Data di inizio",
    "WAYPOINT_PAGE.JOB_TABLE.TITLE": "Lavori per Waypoint",
    "WAYPOINT_PAGE.JOB_TABLE.UPDATED_DATE": "Data aggiornata",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ACTUAL_LEAK_TYPE": "Tipo di perdita effettiva",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ADD_JOB": "Aggiungi lavoro",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ADDRESS": "Indirizzo",
    "WAYPOINT_PAGE.WAYPOINT_INFO.AI_PREDICTED_LEAK_SIZE": "L'intelligenza artificiale ha previsto la dimensione della perdita",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ASSIGNED_ENGINEER": "Ingegnere Assegnato",
    "WAYPOINT_PAGE.WAYPOINT_INFO.BTN_MERGE": "Unisci Waypoint",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CANCEL": "Annulla",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CNS": "CNS",
    "WAYPOINT_PAGE.WAYPOINT_INFO.COMMENT": "Nota di Ingegneria",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CURRENT_STATUS": "Stato",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DIAMETER": "Diametro",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DIAMETER_UNIT": "Unità di diametro",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DMA_NAME": "Nome DMA",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DMA_REFERENCE": "Riferimento DMA",
    "WAYPOINT_PAGE.WAYPOINT_INFO.EDIT_FIELDS": "Modifica Campi",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ENVIRONMENTAL_NOTES": "Note Ambientali",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE": "Riduzione del Flusso Convenuta",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_CLIENT": "Stima della Dimensione della Perdita del Cliente",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_CLIENT_UNIT": "Unità di stima della dimensione della perdita del cliente",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_ENGINEER": "Stima della Dimensione della Perdita sul Posto",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_ENGINEER_UNIT": "Unità di stima della dimensione della perdita in loco",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_UNIT": "Unità di Riduzione del Flusso Concordata",
    "WAYPOINT_PAGE.WAYPOINT_INFO.JOB_TYPE_CODE": "Codice lavoro",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LAST_SCHEDULED_ENGINEER": "Ingegnere Assegnato",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LAST_UPDATE": "Giorni dall'ultimo aggiornamento",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LEAK_TYPE": "Tipo di perdita",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PIPE_MATERIAL": "Materiale del tubo",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.DATE": "Seleziona Data",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.ENGINEER": "Assegna Ingegnere",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.JOB_TYPE_CODE": "Seleziona il codice lavoro",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.LEAK_TYPE": "Seleziona Tipo di Perdita",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.MATERIAL": "Materiale del tubo",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.STATUS": "Seleziona stato",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PREDICTED_LEAK_SIZE": "Stima del Tipo di Perdita sul Posto",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PREDICTED_SIZE": "Dimensione prevista",
    "WAYPOINT_PAGE.WAYPOINT_INFO.REPAIR_TIME": "Data di Scavo",
    "WAYPOINT_PAGE.WAYPOINT_INFO.SUBMIT": "Salva",
    "WAYPOINT_PAGE.WAYPOINT_INFO.SURFACE_TYPE": "Tipo di superficie",
    "WAYPOINT_PAGE.WAYPOINT_INFO.TITLE": "Informazioni sul waypoint",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WAYPOINT_NAME": "Nome del waypoint",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WHAT_3_WORDS": "Quali 3 parole",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WHAT3WORDS": "What3Words",
    "WAYPOINT_SIZE_WIDGET.DAY": "Giorno",
    "WAYPOINT_SIZE_WIDGET.DAY_other": "Giorni",
    "WAYPOINT_SIZE_WIDGET.NO_NAME": "Nessuno",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_A": "Ultima Fuga",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_B": "Perdita più Lunga",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_C": "La più grande perdita",
    "WAYPOINT_SIZE_WIDGET.TITLE": "Punti di passaggio",
    "WIDGET_LAYOUT.CANCEL_TEXT": "NO",
    "WIDGET_LAYOUT.CONFIRM_TEXT": "SÌ",
    "WIDGET_LAYOUT.FILTERS": "Filtri",
    "WIDGET_LAYOUT.MAP_VIEW": "Vista mappa",
    "WIDGET_LAYOUT.REMOVE_WIDGET": "Rimuovi widget",
    "WIDGET_LAYOUT.SETTINGS": "Impostazioni",
    "WIDGET_LAYOUT.SUBTITLE": "Tutte le impostazioni verranno eliminate",
    "WIDGET_LAYOUT.SUMMARY": "Riepilogo",
    "WIDGET_LAYOUT.TABLE_OF_RESULTS": "Tabella dei risultati",
    "WIDGET_LAYOUT.TITLE": "Sei sicuro di voler eliminare questo widget?",
    "BROWSE_VIEW.RELAY.UPTIME": "Tempo di attività del relè",
    "BROWSE_VIEW.WAYPOINT.EDIT": "modificare",
    "BROWSE_VIEW.WAYPOINT.MERGE_W": "Unisci waypoint",
    "BROWSE_VIEW.WAYPOINT.SECTION.MEDIA": "Media",
    "BROWSE_VIEW.WAYPOINT.SECTION.MEDIA_EMPTY": "Nessun supporto per questo waypoint",
    "BROWSE_VIEW.WAYPOINT.SHARE": "condividere",
    "BROWSE.FILTERS.PREDICTED_SIZE.NO_PREDICTION": "Nessuna previsione",
    "BROWSE.FILTERS.UPTIME": "Tempo di attività",
    "BROWSE.FILTERS.UPTIME_PLACEHOLDER": "Seleziona i tempi di attività",
    "BROWSE.FILTERS.UPTIME.AVERAGE": "Media",
    "BROWSE.FILTERS.UPTIME.GOOD": "Bene",
    "BROWSE.FILTERS.UPTIME.HIGH": "Alto",
    "BROWSE.FILTERS.UPTIME.LOW": "Basso",
    "BROWSE.FILTERS.UPTIME.MEDIUM": "Medio",
    "BROWSE.FILTERS.UPTIME.POOR": "Povero",
    "BROWSE.TABLE.COLUMNS.UPTIME": "Tempo di attività"
  }
}
